import React, { useRef, useState } from "react";
import {
  Button,
  Row,
  Col,
  Form,
  Tab,
  Tabs,
  Modal,
  Nav,
  FormGroup,
} from "react-bootstrap";
import { IReportParameter } from "../../Common/Contracts/IReportParameter";
import { toast, ToastContainer } from "react-toastify";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { BusinessAccountSelector } from "./BusinessAccountSelector";
import { ReportGroupSelector } from "./ReportGroupSelector";
import { YearSelector } from "./YearSelector";
import { LaborEmployeeSelector } from "./LaborEmployeeSelector";
import { EmployementTypeSelector } from "./EmployementTypeSelector";
import { LookBackPeriodSelector } from "./LookBackPeriodSelector";
import { ReportTypeSelector } from "./ReportTypeSelector";
import { TotalFormat } from "./TotalFormat";
import EmployeeAutoSelector from "./EmployeeAutoSelector";
import { ACACodeSelector } from "./ACACodeSelector";
import { DepartmentSelector } from "./DepartmentSelector";
import { SingleAllDepartmentSelect } from "../../Common/Components/SingleAllDepartmentSelect";
import { LaborSummarySubTypeSelector } from "./LaborSummarySubTypeSelector";
import { AllHotelBrandSelector } from "../../Common/Services/ReportGroup";
import { SelectAccount } from "../Reports/SelectAccount";
import { ModuleReports } from "../../Common/Services/ModuleReports";
import { IParameterSelectionState } from "./models/ParameterSelectionState";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import ReactTooltip from "react-tooltip";
import { ReactPageLoader } from "../../Common/Components/ReactPageLoader";
// import moment from "moment";
import { Schedule } from "../../Common/Services/Schedule";
//import { isNumber } from "util";
import { LaborMultiEmployeeSelector } from "./LaborMultiEmployeeSelector";
import { LaborResponseStatus } from "./LaborResponseStatus";
import { AccountingCOAType } from "./AccountingCOAType";
import { COASelector } from "./COASelector";
import { AccountTOSelector } from "./AccountTOSelector";
import { SelectSingleCOA } from "./SelectSingleCOA";
import { DateLayOutSelector } from "./DateLayOutSelector";
import { confirmAlert } from "react-confirm-alert";
import { resolve, reject } from "q";
import { convertCompilerOptionsFromJson, isParameter } from "typescript";
import { debug, log } from "console";
import { stat } from "fs";
import { ReportGroupBrandSelector } from "./ReportGroupBrandSelector";
import { DataSourceOperating } from "./DataSourceOperating";
import { DataSourceSelector } from "./DataSourceSelector";
import { RowTittle } from "./RowTittle";
import { MultiTabls } from "./MultiTabls";
import { HotelDisplayFormat } from "./HotelDisplayFormat";
import { AccotingPeriodSector } from "./AccotingPeriodSector";
import { DDLReportType } from "./DDLReportType";
import { DataSource2Selectore } from "./DataSource2Selectore";
import { AccountingPeriodEndSector } from "./AccountingPeriodEndSector";
import { PeriorYearSelect } from "./PeriorYearSelect";
import { BankAccountSelector } from "./BankAccountSelector";
import { MultiBankAccountSelector } from "./MultiBankAccountSelector";
import { PaymentRegisterSelector } from "./PaymentRegisterSelector";
import { DataSource1Periods } from "./DataSource1Periods";
import { DataSource2Periods } from "./DataSource2Periods";
import { AgingSelector } from "./AgingSelector";
import { DesignLayOut } from "./DesignLayOut";
import { DisputeStatus } from "./DisputeStatus";
import { PositivePaySelector } from "./PositivePaySelector";
import { MultiHotelsByPositivePay } from "./MultiHotelsByPositivePay";
import moment from "moment-timezone";
import { Hotel } from "../../Common/Services/Hotel";
import { ProjectBudgets } from "./ProjectBudgets";
import { ReportGlobalSetting } from "./GlobalSetting/ReportGlobalSetting";
import { ExpireStatus } from "./ExpireStatus";
import { VendorSelector } from "./VendorSelector";
import { ContractSelector } from "./ContractSelector";
import { MultiSelectDocType } from "./MultiSelectDocType";
import { COAClassificationReportType } from "./COAClassificationReportType";
import { Utils } from "../../Common/Utilis";
import { AmountControl } from "./AmountControl";
import { Generate1096Ctrl } from "./Generate1096Ctrl";
import { ScheduleReportSortSelector } from "./ScheduleReportSortSelector";
import { EmployeeWageHoursExtendedReportSortSelector } from "./EmployeeWageHoursExtendedReportSortSelector";
import { MultiSelectVendorControl } from "./MultiSelectVendorControl";
import { EpayStatus } from "./ePayStatus";
import { HireDateSortSelector } from "./HireDateSortSelector";
import { StatusSelector } from "./StatusSelector";
import { GroupBySelector } from "./GroupBySelector";
import { ReportServices } from "../../Common/Services/ReportServices";
import { User } from "../../Common/Services/User";
import { YearSelectorAccPeriod } from "./YearSelectorAccPeriod";
import { BussinessAccountSelectorMaxLimit } from "./BussinessAccountSelectorMaxLimit";
import { FacilitiesStatus } from "./FacilitiesStatus";
import { FacilitiesMultiPMSchuleSelector } from "./FacilitiesMultiPMSchuleSelector";
import { FacilitiesWoStatus } from "./FacilitiesWoStatus";
import { FacilitiesWoSorting } from "./FacilitiesWoSorting";
import { FacilitiesAWOSorting } from "./FacilitiesAWOSorting";
import { FacilitiesAWoStatus } from "./FacilitiesAWoStatus";
import { FacilitiesAssetLocation } from "./FacilitiesAssetLocation";
import { FacilitiesAssetSorting } from "./FacilitiesAssetSorting";
import { FacilitiesMultiAssetLocationFilter } from "./FacilitiesMultiAssetLocationFilter";
import { FacilitiesAssetTypeFilter } from "./FacilitiesAssetTypeFilter";


import _ from "lodash";
import "./reportStyle.scss";
const tooltipMessageAdd = "Add to My Reports";
const tooltipMessageReset = "Reset";

export const ReportParameterSelection: React.FC<any> = (props: any) => {
  let htmlControls: any[] = [];
  let reportInputParameters: any[] = [];
  const [ActPeriodFrom, setActPeriodFrom] = React.useState("");
  const [PrYear, setPrYear] = React.useState("");
  const [AccountingPeriodThrough, setAccountingPeriodThrough] =
    React.useState("");
  const [reportParameters, setReportParameters] = React.useState<
    IReportParameter[]
  >([]);
  const [visibleHtmlControls, setVisibleHtmlControls] = React.useState<any[]>(
    []
  );
  const [state, setCompState] = React.useState<IParameterSelectionState>({
    isAcaCodes: true,
    status: "1",
    chkCompareActuals: 0,
    reportType: "",
    dataSourceValueCount: 0,
    showNonWorkingHoursAndwages: true,
  } as IParameterSelectionState);
  const [laborSummaryTypeTooltip, setLaborSummaryTypeTooltip] =
    React.useState("");
  const [group, setgroups] = React.useState();
  const [GroupNameForMsg, setGroupNameForMsg] = React.useState("");
  const buisnessAccountRef = useRef(null);
  const employeeDDLRef: any = useRef(null);
  const vendorControlRef: any = useRef(null);
  const amountControlRef: any = useRef(null);
  const frmSectionRef: any = useRef(null);
  const [key, setKey] = React.useState("runoptions");
  const [reportHeader, setreportHeader] = React.useState();
  const [overBudget, setoverBudget] = React.useState();
  const [overVariance, setoverVariance] = React.useState();
  const [underBudget, setunderBudget] = React.useState();
  const [underVariance, setunderVariance] = React.useState();
  const [ParantID, SetParantID] = React.useState("");
  const [PeriodStart, SetperiodStart] = React.useState("");
  const [showRenameModal, setshowRenameModal] = React.useState(false);
  const [newReportName, setnewReportName] = React.useState("");
  const [reportData, setReportData] = React.useState(props.reportData);
  const [disableSave, setdisableSave] = React.useState(true);
  const [dataFetched, SetDataFetched] = React.useState(false);
  const [userReports, setuserReports] = React.useState([] as any);
  const [currentSaveReport, setcurrentSaveReport] = React.useState({
    userReportId: 0,
  } as any);
  const activeCheckBox: any = React.createRef();
  const accountingperiodsCheckBox: any = React.createRef();
  const payRollDataSourceCheckBox: any = React.createRef();
  const payRollDataSourcePeriodCheckBox: any = React.createRef();
  const CalculatedColumnCheckBox: any = React.createRef();
  const includeAllEmpCheckBox: any = React.createRef();
  const renReportRef: any = React.createRef();
  const accountingEndupdateref = useRef("");
  const [disableRunReport, setdisableRunReport] = React.useState(false);
  const bankAccountRef: any = React.createRef();
  const [vePayLst, setvePayLst] = React.useState([] as any);

  //======================================================Default Load Page============================================================
  React.useEffect(() => {
    setDefaultParamValues();
    runDefaultForgroup();
    getCurrentUser();
    IsPageBreakData();
  }, []);

  React.useEffect(() => {
    getisGlobalSetting();
    GetLastActivePeriod();
    GetServerDate();
    getLastClosedPeriod();
    runDefaultForgroup();
    getCurrentUser();
    IsPageBreakData();
    getUserReport();
  }, []);

  React.useEffect(() => {
    let _htmlControls: any[] = [];
    ModuleReports.GetReportInputParamters(props.reportData.moduleReportId)
      .then((parameters) => {
        localStorage.removeItem("reportParameters");
        SetDataFetched(true);
        console.log(parameters);
        if (parameters[0]?.paramName) {
          reportInputParameters = parameters;
          setSavedReportParameter();
          buildFilterControls(state);
          setCompState(state);
          _htmlControls = htmlControls
            .map((r) => {
              if (controlshouldBeVisible(r?.controlName)) {
                const control = getControl(r?.controlName);
                r.displayOrder = control?.displayOrder;
                r.isRequired = control?.isRequired;
                r.isVisible = true;
                r.isSameDateRangeYear = control?.isSameDateRangeYear;
              }
              return r;
            })
            ?.filter((x) => x?.isVisible);

          if (_htmlControls.length > 1) {
            _htmlControls = _htmlControls?.sort(
              (a, b) => a?.displayOrder - b?.displayOrder
            );
          }

          setVisibleHtmlControls(_htmlControls);
          const tabindexDivs = document?.querySelectorAll('[role="dialog"]');
          if (
            tabindexDivs?.length > 0 &&
            _htmlControls?.filter(
              (r) =>
                r?.controlName === "txtDateRange" ||
                r?.controlName === "txtDate" ||
                r.controlName === "txtDateStartingAndThruControl"
            )?.length > 0
          ) {
            if (tabindexDivs?.length > 1) {
              document
                .querySelectorAll('[role="dialog"]')[1]
                .removeAttribute("tabIndex");
            } else {
              document
                ?.querySelectorAll('[role="dialog"]')[0]
                ?.removeAttribute("tabIndex");
            }
          }
        } else {
          const e: any = {};
          //if (reportData?.reportName.toLocalLowerCase() != 'role permission') {
          assignReportParameters(e);
          return;
          //}
        }
      })
      .catch(() => {
        localStorage.removeItem("reportParameters");
      });
  }, []);

  const getUserReport = () => {
    ModuleReports.GetUserReport()
      .then((result: any[]) => {
        if (result != null && result.length > 0) {
          const data = result;
          setuserReports(data);
        } else {
          setuserReports([]);
        }
      })
      .catch((error) => {
        // Need to handle this
        setuserReports([]);
      });
  };

  const GetePayVendorList = () => {
    // //debugger;
    let request: any = {};
    request.Hid = state.hotelIds;
    ModuleReports.GetePayVendorList(request)
      .then((result: any[]) => {
        if (result != null && result.length > 0) {
          setvePayLst(result);
          setTimeout(() => {
            if (vendorControlRef?.current) {
              vendorControlRef?.current?.resetState();
            }
          }, 500);
        } else {
          setvePayLst([]);
        }
      })
      .catch((err) => {
        setvePayLst([]);
      });
  };

  const IsPageBreakData = () => {
    if (state?.isPageBreak !== null) {
      let IsPageBreak;
      let type;
      if (state?.isPageBreak === true) {
        type = "IsPageBreak";
        IsPageBreak = "1";
      } else {
        type = "IsPageBreak";
        IsPageBreak = "0";
      }
      setNewParameterValue(type, IsPageBreak);
    }
    let ExportType;
    let type;
    if (state?.isPageBreak === true) {
      type = "ExportType";
      ExportType = "PDF";
    } else {
      type = "ExportType";
      ExportType = "View";
    }
    setNewParameterValue(type, ExportType);
  };

  const setDefaultParamValues = () => {
    state.hotelIds = "";
    state.BankAccount = "";
    state.PayFileFormatId = -1;
    state.projectBudget = "Select";
    state.projectBudgetId = -1;
    state.selectedContract = "Select";
    state.multiDocs = "";
    state.multiSelectVendor = "";
    state.statusString = "Active";
    state.loadEmployee = false;
    state.employeeStatus = "Active";
    state.groupBy = "Employee";

    state.hireDateSortBy = "";
    setNewParameterValue("HireDateSortBy", "");
    state.selectedCoaClassificationTypes = "";
    setNewParameterValue("BankAccount", -1);
    setNewParameterValue("BankAccountName", "");
    state.isLayOutSelector = false;
    if (!state.status || state.status === "1") {
      state.status = "1";

      setNewParameterValue("Status", "1");
      setNewParameterValue("coaType", "Active");
    }
    if (!state.CalculatedStatus || state.CalculatedStatus === "Total") {
      state.CalculatedStatus = "Total";
      setNewParameterValue("CalculatedStatus", "Total");
    }

    if (props.reportData.moduleReportId === 2158) {
      if (!state.TwelveAccountPeriod || state.TwelveAccountPeriod === "-1") {
        state.TwelveAccountPeriod = "-1";
        setNewParameterValue("LayoutDesign", "-1");
      }
    } else {
      if (!state.TwelveAccountPeriod || state.TwelveAccountPeriod === "1") {
        if (reportData?.moduleReportId === 2204) {
          state.TwelveAccountPeriod = "2";
          setNewParameterValue("LayoutDesign", "2");
        } else {
          state.TwelveAccountPeriod = "1";
          setNewParameterValue("LayoutDesign", "1");
        }
      }
    }

    if (!state.adjustedBudget || state.adjustedBudget === "Adjusted Budget") {
      state.adjustedBudget =
        props.reportData.moduleReportId === 2168 ? "" : "Adjusted Budget";
      setNewParameterValue(
        "PayRollDataSource",
        props.reportData.moduleReportId === 2168 ? "" : "Adjusted Budget"
      );
      setNewParameterValue(
        "adjustedBudget",
        props.reportData.moduleReportId === 2168 ? "" : "Adjusted Budget"
      );
    }

    if (!state.actual || state.actual === "Actual") {
      let val = "Actual";
      if (props.reportData.moduleReportId === 2204) {
        state.actual = "Variance to Budget";
        val = "Variance to Budget";
      } else {
        state.actual = "Actual";
      }
      setNewParameterValue("dataSourceType", val);
    }

    if (!laborSummaryTypeTooltip) {
      setLaborSummaryTypeTooltip(
        "Includes Over Time, one pay period, one EHID can be selected"
      );
      setLaborSummaryDefaultParams();
    }

    if (!reportData?.reportVariantValue) {
      setNewParameterValue("ReportName", reportData.reportName);
    } else {
      setNewParameterValue("ReportName", reportData?.reportVariantValue);
      if (+reportData?.parentId === 20) {
        setPunchHistoryDefaultParams();
      }
    }

    if (state?.isIncludeEnterpriseEmployees !== null) {
      let IsExclued;
      let type;
      if (state?.isIncludeEnterpriseEmployees === true) {
        type = "IsExclude";
        IsExclued = "Yes";
      } else {
        type = "IsExclude";
        IsExclued = "No";
      }
      state.IsUnapprovedtransactions = false;
      state.IsExClearedtransactions = false;
      state.isIncludeCustomer = false;
      state.hotelDisplayFormat = "1";
      setNewParameterValue(type, IsExclued);
      setNewParameterValue("ChkSummSec", state.isAcaCodes ? "Yes" : "No");
      setNewParameterValue("ChkIsCompSet", state.isCompSet ? "Yes" : "No");
      setNewParameterValue(
        "ChkIsIncludeDesc",
        state.isIncludeDesc ? "Yes" : "No"
      );
      setNewParameterValue(
        "ChkIncludeBudget",
        state.isIncludeBudget ? "Yes" : "No"
      );
      setNewParameterValue(
        "ChkHideZeroActualValues",
        state.isZeroActualValues ? "Yes" : "No"
      );
      setNewParameterValue(
        "ChkIncludeRevenue",
        state.isIncludeRevenue ? "Yes" : "No"
      );
      setNewParameterValue("ChkCheckCOA", state.IsCheckCOA ? "Yes" : "No");
      setNewParameterValue(
        "ChkGeneralCode",
        state.IsGeneralCode ? "Yes" : "No"
      );
      setNewParameterValue(
        "ChkContractorExclude",
        state.IsContractorExclude ? "Yes" : "No"
      );
      setNewParameterValue(
        "chkShowZeroActualHours",
        state.IsShowZeroActualHours ? "Yes" : "No"
      );
      setNewParameterValue(
        "chkBankBalance",
        state.isBankBalanceValues ? "Yes" : "No"
      );
      setNewParameterValue(
        "chkSummayOnly",
        state.isShowSummayValues ? "Yes" : "No"
      );
      setNewParameterValue(
        "chkShowCombinedOnly",
        state.isShowCombinedValues ? "Yes" : "No"
      );
      setNewParameterValue(
        "chkGroupBankAccountsByType",
        state.isGrpBankAccByTypeValues ? "Yes" : "No"
      );
      setNewParameterValue(
        "chkGroupCCAccounts",
        state.isGrpCCAccountsValues ? "Yes" : "No"
      );
      setNewParameterValue(
        "chkNonWorkingHoursAndwages",
        state.showNonWorkingHoursAndwages ? "Yes" : "No"
      );

      setNewParameterValue(
        "ChkHideStatistics",
        state.IsHideStatistics ? "Yes" : "No"
      );
      setNewParameterValue(
        "ChkIncludePendingInvoices",
        state.IsIncludePendingInvoices ? "Yes" : "No"
      );

      setNewParameterValue(
        "ChkUnapprovedtransactions",
        state.IsUnapprovedtransactions ? "Yes" : "No"
      );
      setNewParameterValue(
        "chkExClearedtransactions",
        state.IsExClearedtransactions ? "Yes" : "No"
      );
      setNewParameterValue(
        "IsFromOverview",
        state.IsFromOverview ? "Yes" : "No"
      );
      setNewParameterValue("GetActivePeriods", "");
      setNewParameterValue("PriorYearTodate", "");
      setNewParameterValue("chkSummarySection", "No"); //added for report
      setNewParameterValue("writerFormat", "");
      setNewParameterValue("AgingSelected", "0 - 30");
      setNewParameterValue("Date", "");
      setNewParameterValue("DateEnd", "");
      setNewParameterValue("Adjusted Budget", "");
      setNewParameterValue("Original Budget", "");
      setNewParameterValue("Forecast", "");
      setNewParameterValue("DisputeStatus", "Open");
      setNewParameterValue("ddlMultiTabls", "1");
      setNewParameterValue("DDLType", "Accrual");
      setNewParameterValue("ExpireStatus", 30);
      setNewParameterValue("MultiSelectVendor", "");
      setNewParameterValue("ePayStatusCtrl", "All");
      setNewParameterValue("isVendorReportDateF", "");
      setNewParameterValue("isVendorReportDateT", "");
      setNewParameterValue("isVendorReportUName", "");
      setNewParameterValue("MinimumAmount", "");
      setNewParameterValue("Generate1096", "");
      setNewParameterValue("DocumentType", "");
      setNewParameterValue("IsHyperlink", "");
      setNewParameterValue("PayFileFormatId", "-1");
      setNewParameterValue("projectBudget", "Select");
      setNewParameterValue("projectBudgetId", "-1");
      setNewParameterValue("One", ""); //
      setNewParameterValue("Two", "");
      setNewParameterValue("Closed", "12");
      setNewParameterValue("IsActual", "");
      setNewParameterValue("IsPercentage", "");
      setNewParameterValue("IsPOR", "");
      setNewParameterValue("PHotelName", "");
      setNewParameterValue("DataSource2", "");
      setNewParameterValue("DataSource1", "");
      setNewParameterValue("SelectPL", "");

      setNewParameterValue("selectedVendorId", "-1");
      setNewParameterValue("selectedContract", "Select");
      setNewParameterValue("CoaClassificationTypes", "");

      setNewParameterValue(
        "chkIncludeCustomer",
        state.isIncludeCustomer ? "Yes" : "No"
      );
      setNewParameterValue("ddlHotelDisplayFormat", "1");
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let userUniqueID = storage === null ? 0 : storage.user_UniqueID;
      setNewParameterValue("loginUserId", userUniqueID || 0);

      if (!state.status) {
        state.status = "1";
        setNewParameterValue("coaType", "Active");
      }
    }

    if (
      props.reportData.moduleReportId === 2181 ||
      props.reportData.moduleReportId === 2225
    ) {
      state.actual = "Actual";
      setNewParameterValue("DataSource1", "Actual");
    }
    updateHtmlControlState(state);
  };

  const getCurrentUser = () => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let username = storage === null ? 1 : (storage.userName as any);
    let type = "userName";
    setNewParameterValue(type, username);
  };

  const runDefaultForgroup = () => {
    if (group == null) {
      let type = "Type";
      let rGroupid = props.reportData?.reportName
        ?.toString()
        ?.includes("Daily Flash")
        ? "Cash"
        : "0";
      let Validation: any = rGroupid;
      setgroups(Validation);
      setNewParameterValue(type, rGroupid);

      if (props.reportData?.reportName?.toString()?.includes("Daily Flash")) {
        setNewParameterValue("HyperLink", true);
      }
    }
  };
  //============================Run Reports on Run=========================================================================

  const runReportClicked = async (event) => {
    if (props?.reportData?.reportMasterId === 184 && state?.PayFileFormatId != null && state?.hotelIds != null && state?.hotelIds != '') {
      if (state?.PayFileFormatId === 5) {
        const len = state?.hotelIds?.split(',').length;
        if (len > 1) {
          const result: any = await Hotel.ValidateSingleOrMultipleCCodeForCity(state?.hotelIds, state?.PayFileFormatId);
          if (result?.message === "Success") {
            if (result?.result[0]?.total != "1") {
              Utils.toastError("Selected hotel have different company code for this positive pay format. Please run report one by one hotel having different company code.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "reportParameterSelection",
              });
              return;
            }
          }
        }
      }
    }

    if (
      props?.reportData?.moduleReportId === 2131 &&
      (state.isVendorReportDateF !== undefined ||
        state.isVendorReportDateF !== "" ||
        state.isVendorReportDateT !== undefined ||
        state.isVendorReportDateT !== "") &&
      state.hotelIds?.toString()?.trim() !== "" &&
      state.amountVal === ""
    ) {
      let value = { value: "0.00" };
      let event = { target: value };
      if (amountControlRef.current !== null) {
        amountControlRef.current?.handleFormChange(event);
      }
    }
    assignReportParameters(event);
    props.logReportLoadTiming("onstart");
  };

  const handleAccountingRedirection = () => {
    User.UserTokenDetailsSave()
      .then(async (result: any | null) => {
        if (result) {
          let tokenID = result.result.tokenID;
          runAccountingReport(tokenID);
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  const runAccountingReport = (tokenID) => {
    ReportServices.runAccountingReport()
      .then(async (result: any | null) => {
        debugger;
        if (result !== null) {
          let reportUrl = result?.reportUrl;
          let token = result?.token;
          let reportRunID = result?.reportRunID;
          const storage = JSON.parse(localStorage.getItem("storage")!);
          let tenantId = storage === null ? 0 : (storage.tenantID as any);
          let runReportUrl =
            reportUrl +
            "?TokenID=" +
            btoa(token) +
            "&TenantID=" +
            tenantId +
            "&ReportRunID=" +
            reportRunID +
            "&TokenID2=" +
            btoa(tokenID);
          console.log(runReportUrl);
          window.open(runReportUrl);
          props.onRunReportClick();
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  const openSaveReportModal = () => {
    let reportExist = userReports.filter(
      (x) =>
        x.reportName.toLowerCase() === props.reportData.reportName.toLowerCase()
    );

    if (reportExist?.length === 0) {
      setnewReportName("Copy Of " + props.reportData.reportName);
    }
    setshowRenameModal(true);
  };

  const hideRenameModal = () => {
    setnewReportName("");
    setshowRenameModal(false);
    setdisableSave(false);
  };

  const changeReportName = (e) => {
    setnewReportName(e.target.value);
  };

  const getisGlobalSetting = async () => {
    let reportParanetid = props.reportData.moduleReportId;
    const result: any[] = await ModuleReports.GetGlobalSetting(reportParanetid);
    if (result?.length > 0) {
      state.isGlobalSetting = result[0].isGlobalSetting;
      SetParantID(result[0].parentId);
    }
  };

  const getLastClosedPeriod = async () => {
    const result: any[] = await ModuleReports.GetClosingPeriod(
      props.reportData.moduleReportId
    );
    if (result?.length > 0) {
      let newVaribaleDate = new Date(result[0].lastClosedPeriod);
      let tempYear = newVaribaleDate.getFullYear()?.toString()?.substr(2, 2);
      let tempDate = newVaribaleDate.getDate();
      let tempMonth = newVaribaleDate.getMonth() + 0;
      const finalDate =
        tempMonth.toString().padStart(2, "0") +
        "/" +
        tempDate.toString().padStart(2, "0") +
        "/" +
        tempYear;
      state.periorDate = finalDate;
      SetperiodStart(finalDate);
    }
  };

  const GetLastActivePeriod = async () => {
    const result: any[] = props?.lastAPD; //await ModuleReports.GetlastActivePeriods(props.reportData.tenantId);
    if (result?.length > 0) {
      let newLastActiveDate = new Date(result[0].lastClosedPeriod);
      let tempYear = newLastActiveDate.getFullYear()?.toString()?.substr(2, 2);
      let tempDate = newLastActiveDate.getDate();
      let tempMonth = newLastActiveDate.getMonth() + 1;
      const finalDate =
        tempMonth.toString().padStart(2, "0") +
        "/" +
        tempDate.toString().padStart(2, "0") +
        "/" +
        tempYear;
      state.lastActiveDate = finalDate;
      state.accountsPeriodSelectStart = finalDate;
      let det = newLastActiveDate.getFullYear() - 1;
      state.defaultYear = det.toString();
      if (reportData.moduleReportId === 2078) {
        setNewParameterValue("coaType", finalDate);
      } else {
        setNewParameterValue("AccountingPeriodFrom", finalDate);
      }
      state.aacountingPeriorYear = det.toString();
      setNewParameterValue("PriorYear", det.toString());
      setActPeriodFrom(finalDate);
      setPrYear(det.toString());
    }
  };

  const GetServerDate = async () => {
    const result: any[] = props?.throughAPD; //await ModuleReports.GetSeverDateTime(props.reportData.tenantId);
    if (result?.length > 0) {
      let date = result[0].date;
      let firstDayOfTheMonth = new Date(date);
      let year = firstDayOfTheMonth.getFullYear();
      let month = firstDayOfTheMonth.getMonth() + 1;
      let day = new Date(year, month, 0).getDate();
      const finalSeverDate =
        month.toString().padStart(2, "0") +
        "/" +
        day.toString().padStart(2, "0") +
        "/" +
        year?.toString()?.substr(2, 2);
      state.serverDateTime = finalSeverDate;
      setNewParameterValue("AccountingPeriodThrough", finalSeverDate);
      setAccountingPeriodThrough(finalSeverDate);
    }
  };

  const cancelreportsetup = () => {
    setKey("runoptions");
  };

  const saveReport = async () => {
    setNewParameterValue(
      "tenantId",
      JSON.parse(localStorage.getItem("storage")!).tenantID
    );
    setNewParameterValue("reportId", reportData.moduleReportId);
    setNewParameterValue("uniqueReportId", reportData.uniqueReportId);
    let currentReportParameters = reportParameters;
    const currentReportParams = localStorage.getItem("reportParameters");
    const jsonReportParameters = JSON.stringify(currentReportParameters);
    if (currentReportParams) localStorage.removeItem("reportParameters");
    localStorage.setItem("reportParameters", jsonReportParameters);
    const validationMessage = reportParametersValidationMessage();
    if (validationMessage) {
      Utils.toastError(validationMessage, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "reportParameterSelection",
      });
      return;
    }

    const request: any = {};
    if (props.runFrom === "myreports") {
      request.changeParam = true;
      request.ReportName = props.userReportName;
    } else {
      request.changeParam = currentSaveReport.userReportId > 0 ? true : false;
      request.ReportName =
        currentSaveReport.userReportId > 0
          ? currentSaveReport.reportName
          : newReportName;
    }

    request.ReportType = props.reportData.reportName;
    request.ReportId = props.reportData.moduleReportId;
    request.UserReportId = props.reportData.userReportId
      ? props.reportData.userReportId
      : currentSaveReport.userReportId > 0
        ? currentSaveReport.userReportId
        : 0;
    request.ReportParameter = localStorage.getItem("reportParameters");
    setdisableSave(true);
    try {
      const result: any = await ModuleReports.SaveUserReport(request);
      if (result.success) {
        if (!(props.runFrom === "myreports")) {
          setcurrentSaveReport(result.result);
        }
        setshowRenameModal(false);
        setnewReportName("");
        toast.success(result.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "reportParameterSelection",
        });
      } else {
        Utils.toastError(result.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "reportParameterSelection",
        });
      }
    } catch (error) {
      setdisableSave(false);
      Utils.toastError("Something went wrong", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "reportParameterSelection",
      });
    }
  };

  const assignReportParameters = (event) => {
    props?.showReportData(false);
    const validationMessage = reportParametersValidationMessage();
    if (validationMessage) {
      event?.preventDefault();
      Utils.toastError(validationMessage, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "reportParameterSelection",
      });
      return;
    }
    setNewParameterValue(
      "tenantId",
      JSON.parse(localStorage.getItem("storage")!).tenantID
    );
    setNewParameterValue("reportId", reportData.moduleReportId);
    setNewParameterValue("uniqueReportId", reportData.moduleReportId);
    setNewParameterValue("reportName", reportData.reportName);
    setNewParameterValue("useNewPeriod", reportData?.useNewPeriod);
    let currentReportParameters = reportParameters;
    const currentReportParams = localStorage.getItem("reportParameters");
    const jsonReportParameters = JSON.stringify(currentReportParameters);
    if (currentReportParams) localStorage.removeItem("reportParameters");
    localStorage.setItem("reportParameters", jsonReportParameters);
    setdisableSave(false);
    if (props?.modalType === "new") {
      // runAccountingReport();
      handleAccountingRedirection();
    } else {
      setTimeout(() => {
        props?.showReportData();
      }, 0);
    }
  };

  const isRequiredControl = (controlName: string): boolean => {
    const control = visibleHtmlControls?.find(
      (r) => r?.controlName?.toLowerCase() === controlName?.toLocaleLowerCase()
    );
    return control?.isRequired ? true : false;
  };

  const isSameDateRangeYear = (controlName: string): boolean => {
    const control = visibleHtmlControls?.find(
      (r) => r?.controlName?.toLowerCase() === controlName?.toLocaleLowerCase()
    );
    return control?.isSameDateRangeYear ? true : false;
  };

  const diff_months = (d1, d2) => {
    // let diff = (date2.getTime() - date1.getTime()) / 1000;
    // diff /= (60 * 60 * 24 * 7 * 4);
    // return Math.abs(Math.round(diff));

    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  };

  const reportParametersValidationMessage = (): string => {
    const messageList: any[] = [];

    if (visibleHtmlControls?.length === 0) {
      return "";
    }
    //debugger;
    if (
      isRequiredControl("chkStatus") &&
      state.reportType !== "ByEmployee" &&
      +state.status <= 0
    ) {
      messageList.push({
        message: "Please select status.",
        displayOrder: getControl("chkStatus")?.displayOrder,
      });
    }
    if (isRequiredControl("ddlReportType") && !state.reportType) {
      messageList.push({
        message: "Please select Report Type.",
        displayOrder: getControl("ddlReportType")?.displayOrder,
      });
    }

    if (
      isRequiredControl("txtDate") &&
      !state.startDate &&
      state.dateLayOutSelector !== 2
    ) {
      messageList.push({
        message: "Date can not be blank or Date format should be: MM/DD/YY.",
        displayOrder: getControl("txtDate")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlAccountingYears") && !state.accountingYear) {
      messageList.push({
        message: "Please select Year.",
        displayOrder: getControl("ddlAccountingYears")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlCurrentYears") && !state.currentYear) {
      messageList.push({
        message: "Please select Current Year.",
        displayOrder: getControl("ddlCurrentYears")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlcomparisonYears") && !state.comparisonYear) {
      messageList.push({
        message: "Please select Year for Comparison.",
        displayOrder: getControl("ddlcomparisonYears")?.displayOrder,
      });
    }

    if (
      isRequiredControl("ddlCurrentYears") &&
      isRequiredControl("ddlcomparisonYears")
    ) {
      if (Number(state.currentYear) <= Number(state.comparisonYear)) {
        messageList.push({
          message:
            "Please enter the Year for Comparison less than equal to Current Year.",
          displayOrder: getControl("ddlcomparisonYears")?.displayOrder,
        });
      }
    }

    if (isRequiredControl("ddlaccPeriodMonth") && !state.accPeriodMonth) {
      messageList.push({
        message: "Please select Accounting Period.",
        displayOrder: getControl("ddlaccPeriodMonth")?.displayOrder,
      });
    }

    if (
      isRequiredControl("txtDateRange") &&
      state.dateLayOutSelector !== 1 &&
      (state.reportType !== "ByEmployee" || !state.reportType)
    ) {
      if (!state.startDate || !state.endDate) {
        messageList.push({
          message: "Date can not be blank or Date format should be: MM/DD/YY.",
          displayOrder: getControl("txtDateRange")?.displayOrder,
        });
      } else if (
        isSameDateRangeYear("txtDateRange") &&
        new Date(state.startDate)?.getFullYear() !==
        new Date(state.endDate)?.getFullYear()
      ) {
        messageList.push({
          message: `Please enter the same year date range.`,
          displayOrder: getControl("txtDateRange")?.displayOrder,
        });
        //  -- if date range choosen from accross the years Like starting  01/01/18 and thru 01/18/21.
      } else if (new Date(state.startDate) > new Date(state.endDate)) {
        state.endDate = "";
        updateHtmlControlState(state);
        messageList.push({
          message: `Please enter the Starting Date greater than or equal to Thru Date.`,
          displayOrder: getControl("txtDateRange")?.displayOrder,
        });
      }

      let Months = diff_months(
        new Date(state.startDate),
        new Date(state.endDate)
      );

      if (Months > 11) {
        if (
          props?.reportData?.moduleReportId === 2095 ||
          props?.reportData?.moduleReportId === 2096
        ) {
          messageList.push({
            message:
              "Please select the date range less than or equal to 12 months.",
            displayOrder: getControl("txtDateRange")?.displayOrder,
          });
        }
      }
    }

    if (
      isRequiredControl("txtDateStartingAndThruControl") &&
      state.dateLayOutSelector !== 1
    ) {
      if (!state.isVendorReportDateF || !state.isVendorReportDateT) {
        messageList.push({
          message: "Date can not be blank or Date format should be: MM/DD/YY.",
          displayOrder: getControl("txtDateStartingAndThruControl")
            ?.displayOrder,
        });
      } else if (
        isSameDateRangeYear("txtDateRange") &&
        new Date(state.isVendorReportDateF)?.getFullYear() !==
        new Date(state.isVendorReportDateT)?.getFullYear()
      ) {
        messageList.push({
          message: `Please enter the same year date range.`,
          displayOrder: getControl("txtDateStartingAndThruControl")
            ?.displayOrder,
        });
        //  -- if date range choosen from accross the years Like starting  01/01/18 and thru 01/18/21.
      } else if (
        new Date(state.isVendorReportDateF) >
        new Date(state.isVendorReportDateT)
      ) {
        state.isVendorReportDateT = "";
        updateHtmlControlState(state);
        messageList.push({
          message: `Please enter the Starting Date greater than or equal to Thru Date.`,
          displayOrder: getControl("txtDateStartingAndThruControl")
            ?.displayOrder,
        });
      }
    }

    if (
      isRequiredControl("txtgenerate1096ValCtrl") &&
      state.dateLayOutSelector !== 1
    ) {
      let isValidEmail =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (
        state.generate1096Val.split(",")[0] === "Yes" &&
        state.generate1096Val.split(",")[1].length === 0
      ) {
        messageList.push({
          message: "Please enter a valid contact name",
          displayOrder: getControl("txtgenerate1096ValCtrl")?.displayOrder,
        });
      } else if (
        state.generate1096Val.split(",")[0] === "Yes" &&
        state.generate1096Val.split(",")[2].trim().match(isValidEmail) === null
      ) {
        messageList.push({
          message: "Please enter a valid contact email",
          displayOrder: getControl("txtgenerate1096ValCtrl")?.displayOrder,
        });
      }
    }

    // if (isRequiredControl("txtAmountControl") && state.dateLayOutSelector !== 1) {
    //   if (state.amountVal === "") {
    //     messageList.push({ message: "Please enter amount.", displayOrder: getControl('txtAmountControl')?.displayOrder });
    //   }
    // }

    if (
      isRequiredControl("txtDocumentType") &&
      state.dateLayOutSelector !== 1
    ) {
      if (state.multiDocs === "") {
        messageList.push({
          message: "Please select document type.",
          displayOrder: getControl("txtDocumentType")?.displayOrder,
        });
      }
    }
    if (isRequiredControl("txtMultiVendor") && state.dateLayOutSelector !== 1) {
      if (state.multiSelectVendor === "") {
        messageList.push({
          message: "Please select vendor.",
          displayOrder: getControl("txtMultiVendor")?.displayOrder,
        });
      }
    }
    //debugger;
    if (
      isRequiredControl("ddlAccountingStart") &&
      isRequiredControl("ddlAccountingPeriodEnd")
    ) {
      if (
        new Date(state.accountsPeriodSelectStartEnd) <
        new Date(state.accountsPeriodSelectStart)
      ) {
        updateHtmlControlState(state);
        messageList.push({
          message: `Please enter the Thru Date greater than or equal to Starting Date. `,
          displayOrder: getControl("ddlAccountingStart")?.displayOrder,
        });
      }

      let Months = diff_months(
        new Date(state.lastActiveDate),
        new Date(state.serverDateTime)
      );

      if (Months > 11) {
        if (props.reportData.moduleReportId === 2164) {
          messageList.push({
            message: "Thru Date year should be equal to Starting Date year.",
            displayOrder: getControl("txtDate")?.displayOrder,
          });
        } else {
          messageList.push({
            message:
              "Please select the date range less than or equal to 12 months.",
            displayOrder: getControl("txtDate")?.displayOrder,
          });
        }
      }
    }
    if (isRequiredControl("chkStatus") && reportParameters?.length <= 0) {
      messageList.push({
        message: `Please select at least one parameter.`,
        displayOrder: getControl("chkStatus")?.displayOrder,
      });
    }
    if (
      isRequiredControl("ddlReportGroup") &&
      state.groupSelectValue !== "-1" &&
      (state.reportType !== "ByEmployee" || !state.reportType) &&
      state.dateLayOutSelector !== 2
    ) {
      if (!state.hotelIds?.toString()?.trim()) {
        messageList.push({
          message: `Please Select Hotel Account.`,
          displayOrder: getControl("ddlReportGroup")?.displayOrder,
        });
      }
    }
    if (
      isRequiredControl("ddlMultiReportGroup") &&
      !state.subGroupSelectValue?.toString()?.trim() && // state.groupSelectValue !== "-1" &&
      (state.reportType !== "ByEmployee" || !state.reportType) &&
      state.dateLayOutSelector !== 2
    ) {
      if (!state.hotelIds?.toString()?.trim()) {
        messageList.push({
          message: `Please Select Hotel Account.`,
          displayOrder: getControl("ddlMultiReportGroup")?.displayOrder,
        });
      }
    }
    if (
      isRequiredControl("chkDesignLayOut") &&
      (state.reportType !== "ByEmployee" || !state.reportType)
    ) {
      if (state.TwelveAccountPeriod === "-1") {
        messageList.push({
          message: `Please Select Layout Design.`,
          displayOrder: getControl("chkDesignLayOut")?.displayOrder,
        });
      }
    }
    if (
      (isRequiredControl("ddlHotelMulti") ||
        isRequiredControl("ddlHotelSingle")) &&
      (state.reportType !== "ByEmployee" || !state.reportType) &&
      !state.hotelIds?.toString()?.trim()
    ) {
      if (props.reportData.moduleReportId === 2187) {
        messageList.push({
          message: "Please Select Hotel Account.",
          displayOrder: getControl("txtDate")?.displayOrder,
        });
      } else {
        messageList.push({
          message: `Please select at least one hotel account.`,
          displayOrder:
            getControl("ddlHotelMulti")?.displayOrder ||
            getControl("ddlHotelSingle")?.displayOrder,
        });
      }
    }

    if (
      isRequiredControl("txtAutoEmployee") &&
      !state.employee &&
      (state.reportType === "ByEmployee" ||
        !state.reportType ||
        isRequiredControl("ddlPunchHistoryReportType"))
    ) {
      messageList.push({
        message: `Please enter Employee Name.`,
        displayOrder: getControl("txtAutoEmployee")?.displayOrder,
      });
    }

    // if (isRequiredControl("ddlReportGroup") && state.subGroupSelectValue == "Select Group") {
    //   messageList.push({ message: `Please select group.`, displayOrder: 1 });
    // }

    if (isRequiredControl("ddlEmployee") && !state.employee) {
      messageList.push({
        message: `Please select Employee.`,
        displayOrder: getControl("ddlEmployee")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlLookBackPeriod") && !state.lookBackPeriod) {
      messageList.push({
        message: `Please select Lookback Period.`,
        displayOrder: getControl("ddlLookBackPeriod")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlDaysInterval") && !state.daysInterval) {
      messageList.push({
        message: `Please select Date-Range.`,
        displayOrder: getControl("ddlDaysInterval")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlEmployementType") && !state.employementType) {
      messageList.push({
        message: `Please select Employement Type.`,
        displayOrder: getControl("ddlEmployementType")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlACACoverageCodes") && !state.acaCoverageCodes) {
      messageList.push({
        message: `Please select ACA Coverage Codes.`,
        displayOrder: getControl("ddlACACoverageCodes")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlACAHarborCodes") && !state.acaACASHarborCodes) {
      messageList.push({
        message: `Please select ACA Harbor Codes.`,
        displayOrder: getControl("ddlACAHarborCodes")?.displayOrder,
      });
    }
    if (isRequiredControl("ddlDataSource") && !state.IsdataSoureSelect) {
      messageList.push({
        message: `Please select Data Source 1`,
        displayOrder: getControl("ddlDataSource")?.displayOrder,
      });
    }

    if (
      isRequiredControl("ddlDataSource") &&
      (props.reportData.moduleReportId === 2168 || props.reportData.moduleReportId === 2164) &&
      state.dataSourceforPanL > 2
    ) {
      messageList.push({
        message: `Data source 1 can not have more than 2 values selected at a time.`,
        displayOrder: getControl("ddlDataSource")?.displayOrder,
      });
    }
    if (
      isRequiredControl("ddlDataSource") &&
      (props.reportData.moduleReportId === 2164 || props.reportData.moduleReportId === 2168) &&
      !state.IsdataSoureSelect.includes("Actual")
    ) {
      messageList.push({
        message: `Data Source 1 : Actual option is mandatory to select.`,
        displayOrder: getControl("ddlDataSource")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlDataSource") && state.dataSourceforPanL >= 4) {
      messageList.push({
        message: `Data source 1 can not have more than 3 values selected at a time.`,
        displayOrder: getControl("ddlDataSource")?.displayOrder,
      });
    }
    if (
      isRequiredControl("ddlDataSource") &&
      !state.IsdataSoureSelect.includes("Actual") &&
      state.isZeroActualValues &&
      (props.reportData.moduleReportId === 2222 ||
        props.reportData.moduleReportId === 2220)
    ) {
      messageList.push({
        message: `Actual should be selected for Data Source 1 to enable 'Hide Rows with Zero Actual Values'.`,
        displayOrder: getControl("ddlDataSource")?.displayOrder,
      });
    }
    if (isRequiredControl("ddlDataSource1") && !state.IsdataSoureSelect) {
      messageList.push({
        message: `Please select Data Source 1.`,
        displayOrder: getControl("ddlDataSource1")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlDataSource1") && state.dataSourceValueCount > 2) {
      messageList.push({
        message: `Data source 1 can not have more than 2 values selected at a time.`,
        displayOrder: getControl("ddlDataSource1")?.displayOrder,
      });
    }

    if (
      isRequiredControl("ddlDataSource1Periods") &&
      !state.IsdataSoureSelect
    ) {
      messageList.push({
        message: `Please select Data Source 1`,
        displayOrder: getControl("ddlDataSource1Periods")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlDataSource2") && !state.IsdataSoureSelect2
      && (props.reportData.moduleReportId !== 2228)
    ) {
      messageList.push({
        message: `Please select Data Source 2`,
        displayOrder: getControl("ddlDataSource2")?.displayOrder,
      });
    }
    let valtext = "";
    if (props.reportData.moduleReportId === 2198 ||
      props.reportData.moduleReportId === 2230 ||
      props.reportData.moduleReportId === 2199 ||
      props.reportData.moduleReportId === 2231 ||
      props.reportData.moduleReportId === 2200 ||
      props.reportData.moduleReportId === 2232

    ) {
      valtext = "Data Source 1";
    } else {
      valtext = "Data Source 2";
    }

    if (
      isRequiredControl("ddlDataSource2Periods") &&
      !state.IsdataSoureSelect2
    ) {
      messageList.push({
        message: `Please select ` + valtext,
        displayOrder: getControl("ddlDataSource2Periods")?.displayOrder,
      });
    }
    if (isRequiredControl("ddlAgingSelect") && state.IsAgingSelect == "") {
      messageList.push({
        message: `Please select Aging.`,
        displayOrder: getControl("ddlAgingSelect")?.displayOrder,
      });
    }

    if (
      (isRequiredControl("ddlDepartmentMulti") ||
        isRequiredControl("ddlDepartmentSingle")) &&
      !state.departmentIds?.toString()?.trim()
    ) {
      messageList.push({
        message: `Please select Department.`,
        displayOrder:
          getControl("ddlDepartmentMulti")?.displayOrder ||
          getControl("ddlDepartmentSingle")?.displayOrder,
      });
    }

    if (state.coAaccountType === "3") {
      if (props.reportData.moduleReportId === 2096) {
        const frCoa: any = state.coaFromId;
        const toCoa: any = state.coaToId;
        if (Number(toCoa) < Number(frCoa)) {
          messageList.push({
            message:
              "Please enter the Starting Account greater than or equal to Thru Account.",
            displayOrder: getControl("ddlCOAType")?.displayOrder,
          });
        }
      }

      if (isRequiredControl("ddlChartNofrom") && !state.coaAccounts) {
        messageList.push({
          message: `Please Select Account From.`,
          displayOrder: getControl("ddlChartNofrom")?.displayOrder,
        });
      }
      if (isRequiredControl("ddlChartNoTo") && !state.coaAccountsOne) {
        messageList.push({
          message: `Please Select Account To.`,
          displayOrder: getControl("ddlChartNoTo")?.displayOrder,
        });
      }
    }

    if (state.coAaccountType === "2") {
      if (isRequiredControl("ddlChartNofrom") && !state.coaAccountsTwo) {
        messageList.push({
          message: `Please select coa.`,
          displayOrder: getControl("ddlChartNofrom")?.displayOrder,
        });
      }
    }

    if (
      isRequiredControl("chkIncludeEnterpriseEmployees") &&
      !state.isIncludeEnterpriseEmployees
    ) {
      messageList.push({
        message: `Please Include Enterprise Empolyees.`,
        displayOrder: getControl("chkIncludeEnterpriseEmployees")?.displayOrder,
      });
    }

    if (isRequiredControl("chkPageBreak") && !state.isPageBreak) {
      messageList.push({
        message: `Please Select Page Break.`,
        displayOrder: getControl("chkPageBreak")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlHoursFormat") && !state.hoursFormat) {
      messageList.push({
        message: `Please Select Hours Format.`,
        displayOrder: getControl("ddlHoursFormat")?.displayOrder,
      });
    }

    if (
      isRequiredControl("ddlPunchHistoryReportType") &&
      !state.punchHistoryType
    ) {
      messageList.push({
        message: `Please Select Punch History Type.`,
        displayOrder: getControl("ddlPunchHistoryReportType")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlReportType") && !state.reportType) {
      messageList.push({
        message: `Please Select Report Type.`,
        displayOrder: getControl("ddlReportType")?.displayOrder,
      });
    }

    if (
      (isRequiredControl("ddlSubReportGroupMulti") ||
        isRequiredControl("ddlSubReportGroupSingle")) &&
      !state.subGroupSelectValue?.toString()?.trim()
    ) {
      messageList.push({
        message: `Please select Sub-Group.`,
        displayOrder:
          getControl("ddlSubReportGroupMulti")?.displayOrder ||
          getControl("ddlSubReportGroupSingle")?.displayOrder,
      });
    }

    if (
      isRequiredControl("txtAvgHoursWorked") &&
      !state.avgHours?.toString()?.trim()
    ) {
      messageList.push({
        message: `Please Enter Average Hours Worked.`,
        displayOrder: getControl("txtAvgHoursWorked")?.displayOrder,
      });
    }

    if (
      isRequiredControl("txtHireDate") &&
      !state.hireDate?.toString()?.trim()
    ) {
      messageList.push({
        message: `Please Enter Hire Days.`,
        displayOrder: getControl("txtHireDate")?.displayOrder,
      });
    }

    if (
      state.hotelIds?.toString()?.split(",").length === 1
        ? (isRequiredControl("ddlBankAccount") ||
          isRequiredControl("ddlBankAccountMulti")) &&
        !state.BankAccount?.toString()?.trim()
        : false
    ) {
      messageList.push({
        message: `Please Select Bank Account.`,
        displayOrder:
          getControl("ddlBankAccount")?.displayOrder ||
          getControl("ddlBankAccountMulti")?.displayOrder,
      });
    }

    if (
      isRequiredControl("ddlPositivePayType") &&
      state.PayFileFormatId === -1
    ) {
      messageList.push({
        message: `Please Select Positive Pay Format.`,
        displayOrder: getControl("ddlHoursFormat")?.displayOrder,
      });
    }

    if (isRequiredControl("ddlProjectBudget") && state.projectBudgetId === -1) {
      messageList.push({
        message: `Please Select Project Budget.`,
        displayOrder: getControl("ddlHoursFormat")?.displayOrder,
      });
    }

    if (
      /*state.isAccountEmpty &&*/
      isRequiredControl("ddlMultiHotelsByPositivePay") &&
      !state.hotelIds?.toString()?.trim()
    ) {
      messageList.push({
        message: `Please Select Hotel Account.`,
        displayOrder: getControl("ddlHoursFormat")?.displayOrder,
      });
    }

    if (
      isRequiredControl("ddlVendorSelector") &&
      state.selectedVendorId === -1
    ) {
      messageList.push({
        message: `Please Select Vendor.`,
        displayOrder: getControl("ddlVendorSelector")?.displayOrder,
      });
    }

    if (
      isRequiredControl("ddlContractSelector") &&
      state.selectedContract.toLowerCase() === "select"
    ) {
      messageList.push({
        message: `Please Select Contract No.`,
        displayOrder: getControl("ddlContractSelector")?.displayOrder,
      });
    }

    if (
      isRequiredControl("ddlCoaClassificationReportType") &&
      state.dateLayOutSelector !== 1
    ) {
      if (state.selectedCoaClassificationTypes === "") {
        messageList.push({
          message: "Please select Report type.",
          displayOrder: getControl("ddlCoaClassificationReportType")
            ?.displayOrder,
        });
      }
    }

    let message = "";

    if (messageList?.length > 0) {
      message = messageList.sort((a, b) => +a.displayOrder - +b.displayOrder)[0]
        .message;
    }

    if (
      isRequiredControl("txtFileSize") &&
      !state.fileSize?.toString()?.trim()
    ) {
      return (message = "Please Enter File Size."); //Show File Sizes Larger than
    }
    return message;
  };

  const setSavedReportParameter = (): void => {
    // const savedParameters: IParameterSelectionState = {} as IParameterSelectionState;
    let isGroupReportExist: boolean = false;
    let isGroupData: any = [];
    if (reportData.reportParameter) {
      if (reportData.reportParameter !== "") {
        let savedParameter = JSON.parse(reportData.reportParameter);
        savedParameter?.forEach((element) => {
          setNewParameterValue(element.name, element.value);
          switch (element?.name) {
            case "Status":
              state.status = element?.value ? element?.value : 1;
              break;
            case "Year":
              state.accountingYear = element?.value;
              break;
            case "currentYear":
              state.currentYear = element?.value;
              break;
            case "comparisonYear":
              state.comparisonYear = element?.value;
              break;
            case "accPeriodMonth":
              state.accPeriodMonth = element?.value;
              break;
            case "ReportType":
              state.reportType = element?.value;
              break;
            case "StartDate":
              state.startDate = element?.value ? element?.value : new Date();
              break;
            case "EndDate":
              state.endDate = element?.value ? element?.value : new Date();
              break;
            case "Hotelid":
              state.hotelIds = element?.value;
              break;
            case "HotelBrand":
              state.subGroupSelectValue = element?.value;
              isGroupReportExist = element?.value !== "";
              isGroupData.push({
                subGroupName: element?.value,
                subGroupID: "-0001",
              });
              break;
            case "SubGroupMulti":
              state.subGroupSelectValue = element?.value;
              break;
            case "ACACoverageCode":
              state.acaCoverageCodes = element?.value;
              break;
            case "DataSource1":
              state.IsdataSoureSelect = element?.value;
              state.actual = element?.value;
              break;
            case "DataSource2":
              state.IsdataSoureSelect2 = element?.value;
              break;
            case "ACASaferCode":
              state.acaACASHarborCodes = element?.value;
              break;
            case "AvgHrsWorked":
              state.avgHours = element?.value;
              break;
            case "HireDate":
              state.hireDate = element?.value;
              break;
            case "FileSize":
              state.fileSize = element?.value;
              break;
            case "IsSalaried":
              state.IsSalaried = element?.value === "Yes" ? true : false;
              break;
            case "isPosition":
              state.laborSummarySubType = element?.value;
              break;
            case "IsExcludePayroll":
              state.IsExcludePayroll = element?.value === "Yes" ? true : false;
              break;
            case "IsVariance":
              state.IsVariance = element?.value === "Yes" ? true : false;
              break;
            case "IsDollars":
              state.IsDollars = element?.value === "Yes" ? true : false;
              break;
            case "ActualCompared":
              state.chkCompareActuals = +element?.value;
              break;
            case "ChkSummSec":
              state.isAcaCodes = element?.value === "Yes" ? true : false;
              break;
            case "ChkIsCompSet":
              state.isCompSet = element?.value === "Yes" ? true : false;
              break;
            case "ChkIsIncludeDesc":
              state.isIncludeDesc = element?.value === "Yes" ? true : false;
              break;
            case "ChkIncludeBudget":
              state.isIncludeBudget = element?.value === "Yes" ? true : false;
              break;
            case "ChkHideZeroActualValues":
              state.isZeroActualValues =
                element?.value === "Yes" ? true : false;
              break;
            case "ChkIncludeRevenue":
              state.isIncludeBudget = element?.value === "Yes" ? true : false;
              break;
            case "ChkCheckCOA":
              state.IsCheckCOA = element?.value === "Yes" ? true : false;
              break;
            case "ChkGeneralCode":
              state.IsGeneralCode = element?.value === "Yes" ? true : false;
              break;
            case "ChkContractorExclude":
              state.IsContractorExclude =
                element?.value === "Yes" ? true : false;
              break;

            case "chkShowZeroActualHours":
              state.IsShowZeroActualHours = element?.value === "Yes" ? true : false;

              break;
            case "chkBankBalance":
              state.isBankBalanceValues =
                element?.value === "Yes" ? true : false;
              break;
            case "chkSummayOnly":
              state.isShowSummayValues =
                element?.value === "Yes" ? true : false;
              break;
            case "chkShowCombinedOnly":
              state.isShowCombinedValues =
                element?.value === "Yes" ? true : false;
              break;
            case "chkGroupBankAccountsByType":
              state.isGrpBankAccByTypeValues =
                element?.vale === "Yes" ? true : false;
              break;
            case "chkGroupCCAccounts":
              state.isGrpCCAccountsValues =
                element?.value === "Yes" ? true : false;
              break;
            case "chkNonWorkingHoursAndwages":
              state.showNonWorkingHoursAndwages =
                element?.value === "Yes" ? true : false;
              break;

            case "ChkHideStatistics":
              state.IsHideStatistics = element?.value === "Yes" ? true : false;
              break;
            case "ChkIncludePendingInvoices":
              state.IsIncludePendingInvoices =
                element?.value === "Yes" ? true : false;
              break;

            case "ChkUnapprovedtransactions":
              state.IsUnapprovedtransactions =
                element?.value === "Yes" ? true : false;
              break;
            case "ExcClearedTran":
              state.IsExClearedtransactions =
                element?.value === "1" ? true : false;
              break;
            case "coaType":
              state.lastActiveDate = element?.value;
              if (props.reportData.moduleReportId === 2078) {
                state.accountsPeriodSelectStart = element?.value;
              }
              break;
            case "OwnershipID":
              state.BankAccount = element?.value;
              break;
            case "OwnershipIDorGroupid":
              state.OwnershipIDorGroupid = element?.value;
              break;
            case "IsPageBreak":
              state.isPageBreak = +element?.value === 1 ? true : false;
              break;
            case "IsExclude":
              state.isIncludeEnterpriseEmployees =
                element?.value === "Yes" ? true : false;
              break;
            case "GroupName":
              state.groupSelectValue = element?.value;
              break;
            case "OnlyGroupName":
              state.OnlyGroupName = element?.value;
              break;
            case "EmpType":
              state.employementType = element?.value;
              break;
            case "LookBack":
              state.lookBackPeriod = element?.value;
              break;
            case "Employee":
              state.employee = element?.value;
              break;
            case "timeFormat":
              state.hoursFormat = element?.value;
              break;
            case "deptID":
              state.departmentIds = element?.value;
              break;
            case "userUniquenId":
              state.userUniquenIds = element?.value;
              break;
            case "responseStatus":
              state.responseStatus = element?.value;
              break;
            case "dateLayOutSelector":
              state.dateLayOutSelector = element?.value || 0;
              break;
            case "ReportName":
              state.ReportName = element?.value;
              break;
            case "BankAccount":
              state.BankAccount = element?.value;
              break;
            case "Aging":
              state.IsAgingSelect = element?.value;
              break;
            case "CalculatedStatus":
              state.CalculatedStatus = element?.value;
              break;
            case "LayoutDesign":
              state.TwelveAccountPeriod = element?.value;
              break;
            case "AccountingPeriodFrom":
              state.lastActiveDate = element?.value;
              state.accountsPeriodSelectStart = element?.value;
              break;
            case "AccountingPeriodThrough":
              state.accountsPeriodSelectStartEnd = element?.value;
              state.serverDateTime = element?.value;
              break;
            case "DisputeStatus":
              state.disputueStatus = element?.value;
              break;
            case "ddlMultiTabls":
              state.multiTabs = element?.value;
              break;
            case "DDLType":
              state.reportSubTypes = element?.value;
              break;
            case "ExpireStatus":
              state.expireStatus = element?.value;
              break;
            case "PayFileFormatId":
              state.PayFileFormatId = element?.value;
              break;
            case "projectBudget":
              state.projectBudget = element?.value;
              break;
            case "projectBudgetId":
              state.projectBudgetId = element?.value;
              break;
            case "PayRollDataSource":
              state.adjustedBudget = element?.value;
              break;
            case "PriorYear":
              state.defaultYear = element?.value;
              break;
            case "RowTittle":
              state.rowTitles = element?.value;
              break;
            case "selectedVendorId":
              state.selectedVendorId = element?.value;
              break;
            case "selectedContract":
              state.selectedContract = element?.value;
              break;
            case "isVendorReportDateF":
              state.isVendorReportDateF = element?.value
                ? element?.value
                : new Date();
              break;
            case "isVendorReportDateT":
              state.isVendorReportDateT = element?.value
                ? element?.value
                : new Date();
              break;
            case "userName":
              state.userName = element?.value;
              break;
            case "ScheduleReportSortBy":
              state.scheduleReportSortBy = element?.value;
              break;
            case "HireDateSortBy":
              state.hireDateSortBy = element?.value;
              break;

            case "StatusString":
              state.statusString = element?.value;
              break;

            case "EmployeeStatus":
              state.employeeStatus = element?.value;
              break;
            case "GroupBy":
              state.groupBy = element?.value;
              break;

            case "EmployeeWageNewReportSortBy":
              state.employeeWageNewReportSortBy = element?.value;
              break;
            case "DocumentType":
              state.multiDocs = element?.value ? element?.value.toString() : "";
              break;
            case "MinimumAmount":
              state.amountVal = element?.value ? element?.value.toString() : "";
              break;
            case "CoaClassificationTypes":
              state.selectedCoaClassificationTypes = element?.value
                ? element?.value.toString()
                : "";
              break;
            case "MultiSelectVendor":
              state.multiSelectVendor = element?.value;
              break;
            case "ePayStatusCtrl":
              state.ePayStatus = element?.value;
              break;
            // case "StatusString":
            //   state.statusString = element?.value;
            //   break;
            // case "EmployeeStatus":
            //   state.employeeStatus = element?.value;
            //   break;
            // case "GroupBy":
            //   state.groupBy = element?.value;
            //   break;
            case "chkIncludeCustomer":
              state.isIncludeCustomer = element?.value === "Yes" ? true : false;
              break;
            case "SubGroupid":
              state.SubGroupid = element?.value;
              break;
            case "ddlHotelDisplayFormat":
              state.hotelDisplayFormat = element?.value;
              break;
            case "responseFCStatus":
              state.responseFCStatus = element?.value;
              break;
            case "PmScheduleId":
              state.PmScheduleId = element?.value;
              break;
            case "FcAwoSorting":
              state.FcAwoSorting = element?.value;
              break;
            case "FcAwoStatus":
              state.FcAwoStatus = element?.value;
              break;
            case "FcAssetTypeDetails":
              state.FcAssetTypeDetails = element?.value;
              break;
            case "FcAssetLocation":
              state.FcAssetLocation = element?.value;
              break;
            case "FcAssetLocationSorting":
              state.FcAssetLocationSorting = element?.value;
              break;
              case "FCWoSorting":
                state.FCWoSorting = element?.value;
                break;
                case "FCWoStatus":
                  state.FCWoStatus = element?.value;
                  break;
            default:
              break;
          }
        });
      }
    }

    if (!state.subGroupSelectValue && !state.groupSelectValue) {
      state.subGroupSelectValue = "Select Group";
    }

    if (isGroupReportExist) {
      if (isGroupData.length) {
        if (state?.SubGroupid !== undefined && state?.SubGroupid !== "") {
          const MultipleSubGroupIds = state?.SubGroupid.split(",");
          if (MultipleSubGroupIds.length > 0) {
            isGroupData = [];
            MultipleSubGroupIds.forEach((element, i) => {
              isGroupData.push({
                subGroupName: state?.subGroupSelectValue?.split(",")[i],
                groupName: state?.OnlyGroupName,
                subGroupID: +element,
              });
            });
          }
        }
        handleMultiReportGroupChange(isGroupData);
      }
      if (!state.subGroupSelectValue && state.groupSelectValue === "All") {
        state.subGroupSelectValue = "All";
      }
    }
    // return savedParameters;
  };
  //======================================================================Controls and Events Chnages================================================

  const handleParameterChange = (target, statusValue) => {
    setStatusValue(statusValue);
    setNewParameterValue(target.name, target.value);
    updateEmployeeDDL();
    //setdisableSave(false);
  };

  const handleParameterChange12Account = (target, statusValue) => {
    setStatusValue12Account(statusValue);
  };

  const handleParameterPayrollDataSoure = (target, statusValue) => {
    setStatusValuePayRollDataSource(statusValue);
  };

  const handleParameterPayrollChkDataSoure = (target, statusValue) => {
    setStatusValuePayRollChkDataSource(statusValue);
  };

  const handleParameterCalculatedColumn = (target, statusValue) => {
    setStatusValueCal(statusValue);
  };

  const handleCompareActualChange = (paramName, value) => {
    state.chkCompareActuals = +value;
    setNewParameterValue(paramName, value);
    updateHtmlControlState(state);
  };

  const setStatusValue = (statusValue) => {
    state.status = statusValue;
    updateHtmlControlState(state);
    setNewParameterValue("Status", statusValue);
  };

  const setStatusValueCal = (statusValue) => {
    state.CalculatedStatus = statusValue;
    updateHtmlControlState(state);
    setNewParameterValue("CalculatedStatus", statusValue);
  };
  const setStatusValue12Account = (statusValue) => {
    state.TwelveAccountPeriod = statusValue;
    updateHtmlControlState(state);
    setNewParameterValue("LayoutDesign", statusValue);
  };

  const setStatusValuePayRollDataSource = (statusValue) => {
    //debugger;
    state.adjustedBudget = statusValue;
    updateHtmlControlState(state);
    setNewParameterValue("PayRollDataSource", statusValue);
  };

  const setStatusValuePayRollChkDataSource = (statusValue) => {
    state.adjustedBudget = "";
    state.actual = statusValue;
    updateHtmlControlState(state);
    setNewParameterValue("DataSource1", statusValue);
    setNewParameterValue("dataSourceType", statusValue);
  };

  const handleParameterPayrollDataSoureIncome = (target, statusValue) => {
    if (!target.checked && statusValue == "Adjusted Budget") statusValue = "";

    setStatusValuePayRollChkDataSourceIncome(statusValue);
  };

  const setStatusValuePayRollChkDataSourceIncome = (statusValue) => {
    state.adjustedBudget = statusValue;
    state.actual = "";
    updateHtmlControlState(state);
    if (props.reportData.moduleReportId === 2204)
      setNewParameterValue("dataSourceType", statusValue);
    setNewParameterValue("adjustedBudget", statusValue);
    setNewParameterValue("PayRollDataSource", statusValue);
  };

  const handleDatesChange = (date, type) => {
    if (type === "StartDate") {
      state.startDate = date;
      updateHtmlControlState(state);
      let newVaribaleDate = new Date(date);
      let tempYear = newVaribaleDate.getFullYear()?.toString()?.substr(2, 2);
      let tempDate = newVaribaleDate.getDate();
      let tempMonth = newVaribaleDate.getMonth() + 1;
      let finalDate =
        tempMonth.toString().padStart(2, "0") +
        "/" +
        tempDate.toString().padStart(2, "0") +
        "/" +
        tempYear;
      setNewParameterValue(type, finalDate);
      if (reportData.moduleReportId === 2228 || reportData.moduleReportId === 2184) {
        let dt = newVaribaleDate.getFullYear() - 1;
        state.defaultYear = dt.toString();
        state.aacountingPeriorYear = dt.toString();
        setNewParameterValue("PriorYear", dt.toString());
        updateHtmlControlState(state);
      }
    }

    if (type === "EndDate") {
      state.endDate = date;
      if (new Date(state.startDate) > new Date(state.endDate)) {
        state.endDate = "";
        updateHtmlControlState(state);
        Utils.toastError(
          "Please enter the End Date greater than or equal to Start Date.",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "reportParameterSelection",
          }
        );

        return false;
      }

      updateHtmlControlState(state);
      let newVaribaleDate = new Date(date);
      let tempYear = newVaribaleDate.getFullYear()?.toString()?.substr(2, 2);
      let tempDate = newVaribaleDate.getDate();
      let tempMonth = newVaribaleDate.getMonth() + 1;
      let finalDate =
        tempMonth.toString().padStart(2, "0") +
        "/" +
        tempDate.toString().padStart(2, "0") +
        "/" +
        tempYear;
      setNewParameterValue(type, finalDate);
    }

    setNewParameterValue("useNewPeriod", reportData?.useNewPeriod);
  };

  const handleDatesChange2 = (date, type) => {
    if (type === "isVendorReportDateF") {
      state.isVendorReportDateF = date;
      updateHtmlControlState(state);
      let newVaribaleDate = new Date(date);
      let tempYear = newVaribaleDate.getFullYear()?.toString()?.substr(2, 2);
      let tempDate = newVaribaleDate.getDate();
      let tempMonth = newVaribaleDate.getMonth() + 1;
      let finalDate =
        tempMonth.toString().padStart(2, "0") +
        "/" +
        tempDate.toString().padStart(2, "0") +
        "/" +
        tempYear;
      setNewParameterValue(type, finalDate);
    }

    if (type === "isVendorReportDateT") {
      state.isVendorReportDateT = date;
      if (
        new Date(state.isVendorReportDateF) >
        new Date(state.isVendorReportDateT)
      ) {
        state.isVendorReportDateT = "";
        updateHtmlControlState(state);
        Utils.toastError(
          "Please enter the End Date greater than or equal to Start Date.",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "reportParameterSelection",
          }
        );

        return false;
      }

      updateHtmlControlState(state);
      let newVaribaleDate = new Date(date);
      let tempYear = newVaribaleDate.getFullYear()?.toString()?.substr(2, 2);
      let tempDate = newVaribaleDate.getDate();
      let tempMonth = newVaribaleDate.getMonth() + 1;
      let finalDate =
        tempMonth.toString().padStart(2, "0") +
        "/" +
        tempDate.toString().padStart(2, "0") +
        "/" +
        tempYear;
      setNewParameterValue(type, finalDate);
    }
  };

  const handleCOAAccountSelector = (value: any) => {
    state.coaAccounts = value.hotelID;
    state.coaFromId = value.value;
    updateHtmlControlState(state);
    setNewParameterValue("AccountFrom", value.value);
  };

  const handleAccotingSelector = (value: any) => {
    if (value !== "") {
      let currDate = new Date();
      let currYear = currDate.getFullYear();
      let Selectdate = new Date(value.value);
      let year = Selectdate.getFullYear();
      let month = Selectdate.getMonth() + 1;
      let day = new Date(year, month, 0).getDate();
      let finalSeverDatee =
        month.toString().padStart(2, "0") +
        "/" +
        day.toString().padStart(2, "0") +
        "/" +
        year?.toString()?.substr(2, 2);
      if (currYear >= year) {
        let date = new Date(value.value);
        let dt = date.getFullYear() - 1;
        state.defaultYear = dt.toString();
        state.aacountingPeriorYear = dt.toString();
        state.accountsPeriodSelectStart = value.hotelID;
        state.lastActiveDate = value.value;
        state.serverDateTime = finalSeverDatee;

        if (reportData.moduleReportId === 2078) {
          setNewParameterValue("coaType", value.value);
        } else {
          setNewParameterValue("AccountingPeriodFrom", value.value);
          setNewParameterValue("AccountingPeriodThrough", finalSeverDatee);
          setNewParameterValue("PriorYear", dt.toString());
        }
        updateHtmlControlState(state);
      } else {
        ModuleReports.GetlastActivePeriods(props.reportData.tenantId).then(
          (result: any[]) => {
            if (result?.length > 0) {
              let newLastActiveDate = new Date(result[0].lastClosedPeriod);
              let det = newLastActiveDate.getFullYear() - 1;
              state.defaultYear = det.toString();
              state.aacountingPeriorYear = det.toString();
              state.accountsPeriodSelectStart = value.hotelID;
              state.lastActiveDate = value.value;
              state.serverDateTime = finalSeverDatee;

              if (reportData.moduleReportId === 2078) {
                setNewParameterValue("coaType", value.value);
              } else {
                setNewParameterValue("AccountingPeriodFrom", value.value);
                setNewParameterValue(
                  "AccountingPeriodThrough",
                  finalSeverDatee
                );
                setNewParameterValue("PriorYear", det.toString());
              }
              updateHtmlControlState(state);
            }
          }
        );
      }
    }
  };

  const handleAccotingSelectorEnd = (value: any) => {
    state.accountsPeriodSelectStartEnd = value.hotelID;
    state.serverDateTime = value.hotelID;
    updateHtmlControlState(state);
    setNewParameterValue("AccountingPeriodThrough", value.value);
  };

  const handlePeriorYear = (value: any) => {
    state.defaultYear = value.hotelID;
    state.aacountingPeriorYear = value.hotelID;
    updateHtmlControlState(state);
    setNewParameterValue("PriorYear", value.value);
  };

  const handleCOAAccountSelectortow = (value: any) => {
    state.coaAccountsOne = value.hotelID;
    state.coaToId = value.value;
    updateHtmlControlState(state);
    setNewParameterValue("AccountTo", value.value);
  };

  const handleSingleCoaSelect = (value: any) => {
    state.coaAccountsTwo = value.hotelID;
    updateHtmlControlState(state);
    setNewParameterValue("SelectSingleCoa", value.value);
  };

  const handleSingleBusinessAccountChange = (value: any) => {
    // //debugger;
    state.isResetHIDControl = true;
    state.hotelIds = "";
    clearCOAList();
    if (props.reportData.reportName === "GENERAL LEDGER REPORT") {
    }
    const reportActiveTab = localStorage.getItem("reportActiveTab")!; // added to stop below code from executing by default on opening Reconciliation Report from My Reports
    if (reportActiveTab === "myreports") {
      localStorage.removeItem("reportActiveTab");
    } else {
      if (controlshouldBeVisible("ddlBankAccountMulti")) {
        state.BankAccount = "";
        setNewParameterValue("OwnershipID", "");
        setNewParameterValue("Type", "");
      }
    }
    if (controlshouldBeVisible("showDateRangeAsPerPayPeriod")) {
      state.lastDateOfPayPeriodWeekOfHotel = "";
      state.startDate = "";
      setNewParameterValue("StartDate", "");
      state.endDate = "";
      setNewParameterValue("EndDate", "");
    }
    if (value.hotelID !== "") {
      state.hotelIds = value.hotelID;
      updateHtmlControlState(state);
      if (props.reportData.moduleReportId === 2096) {
        setTimeout(() => {
          state.isResetHIDControl = false;
          updateHtmlControlState(state);
        }, 50);
      }
      if (employeeDDLRef?.current) {
        if (
          typeof employeeDDLRef?.current["updateEmployeeDDL"] === "function"
        ) {
          employeeDDLRef?.current?.updateEmployeeDDL(
            value.hotelID,
            state.status
          );
        }
      }
      setNewParameterValue("Hotelid", value.hotelID);
      setNewParameterValue("HotelType", value?.hotelType);
    } else if (value.description !== "") {
      state.hotelName = value.description;
      state.hotelNames = value.description;
      updateHtmlControlState(state);
    }
    let hotename;
    let hotelcode;

    let sethotelName = value.description;
    const stringToRemove = sethotelName?.toString()?.split("-")[0];
    hotename = sethotelName.replace(stringToRemove, "");
    while (hotename.charAt(0) === "-") {
      hotename = hotename.substring(1)?.trim();
    }
    hotelcode = value?.value;

    //hotename.toUpperCase()
    let type = "description";
    setNewParameterValue(type, hotename + " (" + hotelcode + ")");
    let fullDescription = "fullDescription";
    setNewParameterValue(fullDescription, hotename + " (" + hotelcode + ")");
    setNewParameterValue("PHotelName", hotename + " (" + hotelcode + ")");
    if (controlshouldBeVisible("showDateRangeAsPerPayPeriod")) {
      Schedule.GetPayPeriodWeekByDateAndHotel(
        value.hotelID,
        moment.tz(value?.timeZone).format("MM/DD/YYYY")
      ).then((result) => {
        if (result?.dateTo) {
          if (
            result?.weekLayOut === "bi-weekly" &&
            moment(moment().tz(value?.timeZone).format("MM/DD/YY")).diff(
              moment(result.dateFrom).tz(value?.timeZone),
              "days"
            ) >= 7
          ) {
            state.lastDateOfPayPeriodWeekOfHotel = moment(result.dateTo)
              .subtract(6, "days")
              .tz(value?.timeZone)
              ?.format("MM/DD/YY");
          } else {
            state.lastDateOfPayPeriodWeekOfHotel = moment(result.dateFrom)
              .tz(value?.timeZone)
              ?.format("MM/DD/YY");
          }
        }

        updateHtmlControlState(state);
      });
    }

    if (controlshouldBeVisible("ddlVendorSelector")) {
      // //debugger;
      state.selectedVendorId = -1;
      updateHtmlControlState(state);
      setNewParameterValue("selectedVendorId", -1);
    }

    if (controlshouldBeVisible("ddlProjectBudget")) {
      // //debugger;
      state.projectBudget = "Select";
      state.projectBudgetId = -1;
      updateHtmlControlState(state);
      setNewParameterValue("projectBudget", "Select");
      setNewParameterValue("projectBudgetId", -1);
    }

    if (controlshouldBeVisible("ddlContractSelector")) {
      // //debugger;
      state.selectedContract = "Select";
      updateHtmlControlState(state);
      setNewParameterValue("selectedContract", "Select");
    }
  };
  const handleBusinessAccountChange = (
    value: any,
    reset = false,
    hid = "",
    subGroupName: any = "",
    subGroupID = "",
    isReset = false
  ) => {
    state.BankAccount = "";
    state.resetMultiGroup = isReset;
    state.resetGroupHid = hid;
    state.resetGroupID = subGroupID;
    updateHtmlControlState(state);
    setNewParameterValue("BankAccount", -1);
    setNewParameterValue("BankAccountName", "");

    if (reset) {
      subGroupName === "" && setNewParameterValue("GroupName", "");
      setNewParameterValue("HotelBrand", subGroupName);
      subGroupName === "" && setNewParameterValue("OnlyGroupName", "");
      subGroupName === "" && setNewParameterValue("OwnershipIDorGroupid", "0");
      state.multigroupList = subGroupName === "" ? [] : state.multigroupList;
      state.subGroupSelectValue =
        subGroupName === "" ? "Select Group" : subGroupName;
      subGroupName === "" && updateHtmlControlState(state);
    }

    if (value.length > 0) {
      let selectedHIDs: any = [];
      let newItem = "";
      let gethides;
      value.forEach((element: any) => {
        newItem += element.hotelID + ",";
      });
      selectedHIDs.push(newItem);
      gethides = selectedHIDs[0];
      let lastcomaaHid = gethides.replace(/,(\s+)?$/, "");
      if (employeeDDLRef?.current) {
        if (
          typeof employeeDDLRef?.current["updateEmployeeDDL"] === "function"
        ) {
          employeeDDLRef?.current?.updateEmployeeDDL(
            lastcomaaHid,
            state.status
          );
        }
      }

      state.hotelIds = lastcomaaHid;
      updateHtmlControlState(state);
      let setEhid = lastcomaaHid;
      let type = "Hotelid";
      setNewParameterValue(type, setEhid);
      setNewParameterValue("HotelType", value?.hotelType);
      if (value[0].description !== "") {
        state.hotelName = value[0].description;
        updateHtmlControlState(state);
        let hotename;
        let hotelcode;
        let sethotelName = value[0].description;
        const stringToRemove = sethotelName?.toString()?.split("-")[0];
        hotename = sethotelName.replace(stringToRemove, "");
        while (hotename.charAt(0) === "-") {
          hotename = hotename.substring(1)?.trim();
        }
        hotelcode = value[0]?.value;
        let type = "description";
        setNewParameterValue(
          type,
          hotename + " (" + hotelcode + ")" //.toUpperCase()
        );
        let fullDescription = "fullDescription";
        var hotelNames = value?.map(
          (element) =>
            element?.description?.split("-")[1]?.trim() +
            " (" +
            element.value +
            ")"
        );
        setNewParameterValue(fullDescription, hotelNames.join(", "));
        setNewParameterValue("PHotelName", hotename + " (" + hotelcode + ")");
      }

      if (state.PayFileFormatId === 5) {
        if (value.length > 0) {
          let getUserHotelAccess: any;
          getUserHotelAccess = Hotel.ValidateSingleOrMultipleCCodeForCity(
            lastcomaaHid,
            state.PayFileFormatId
          );
          getUserHotelAccess
            .then(async (result: any[] | null) => {
              if (result != null && result.length > 0) {
                if (result.length > 1) {
                  const check = result.filter(
                    (e) => e.companyCode !== result[0].companyCode
                  );
                  if (check.length === 0) {
                    setdisableRunReport(false);
                    state.companyCode = result[0].companyCode;
                    setNewParameterValue("companyCode", result[0].companyCode);
                    updateHtmlControlState(state);
                  } else {
                    state.companyCode = "";
                    setNewParameterValue("companyCode", "");
                    updateHtmlControlState(state);
                    setdisableRunReport(true);
                    Utils.toastError(
                      "Selected hotel have different company code for this positive pay format you can run or export one by one or hotel having common company code.",
                      {}
                    );
                  }
                } else {
                  setdisableRunReport(false);
                  state.companyCode = result[0].companyCode;
                  setNewParameterValue("companyCode", result[0].companyCode);
                  updateHtmlControlState(state);
                }
              } else {
                state.companyCode = "";
                setNewParameterValue("companyCode", "");
                updateHtmlControlState(state);
                setdisableRunReport(false);
              }
            })
            .catch((error) => {
              // Need to handle this
              console.log(error);
            });
        }
      }
    } else {
      state.hotelIds = "";
      updateEmployeeDDL();
      state.hotelName = "";
      updateHtmlControlState(state);
      setdisableRunReport(false);
    }
    if (controlshouldBeVisible("txtMultiVendor")) {
      GetePayVendorList();
    }
  };

  const handleSelectAllSingleDepartments = (value: any) => {
    state.departmentIds = value;
    updateHtmlControlState(state);
    let setDepartmentid = value;
    let type = "deptID";
    setNewParameterValue(type, setDepartmentid);
  };

  const handleReportGroupChange = (item: any) => {
    if (item?.groupName) {
      let type = "GroupName";
      let typee = "OnlyGroupName";
      let OwnershipIDorGroupid = "OwnershipIDorGroupid";
      if (item?.groupName != "All") {
        setNewParameterValue(
          type,
          item?.groupName === "Select Group"
            ? ""
            : item?.groupName + " : " + item?.subGroupName?.toUpperCase()
        );
        setNewParameterValue(OwnershipIDorGroupid, item?.groupID);
        setNewParameterValue(
          typee,
          item?.groupName === "Select Group" ? "" : item?.groupName
        );
        // setNewParameterValue("ReportType", "");
      } else {
        setNewParameterValue(
          type,
          item?.groupName === "Select Group" ? "" : item?.groupName
        );
        setNewParameterValue(OwnershipIDorGroupid, item?.groupID);
        // setNewParameterValue("ReportType", "");
      }
    }
    handleGroupItemChange(item, [{ type: "ddlReportGroup" }]);
  };

  const handleGroupItemChange = (
    item: any,
    type: any = [],
    initial = false
  ) => {
    //state.hotelIds = "";

    if (!item) {
      return false;
    }
    const childcall: any = buisnessAccountRef.current;
    if (+item?.groupID === 0 || +item?.groupID === -1) {
      setNewParameterValue("HotelBrand", "");
      if (+item?.groupID === 0) {
        childcall.updateHotelList([], [], true);
      } else {
        childcall.updateHotelList([]);
      }
      state.subGroupSelectValue = item.groupName;
      updateHtmlControlState(state);
      return;
    }

    state.subGroupSelectValue = item.subGroupName;
    updateHtmlControlState(state);
    setNewParameterValue("HotelBrand", item.subGroupName);

    AllHotelBrandSelector.GetHidSelectbyGroup(
      item.subGroupID,
      controlshouldBeVisible("showAllHotels"),
      reportData?.payrollSubscriptionRequired
    ).then(async (result: any | null) => {
      if (result != null) {
        const hotelList: any = [];
        result.forEach((element) => {
          let newItem = {} as any;
          newItem.hotelID = element.hotelID;
          newItem.isChecked = true;
          hotelList.push(newItem);
        });

        if (buisnessAccountRef.current !== null) {
          if (initial && state.hotelIds?.length > 0) {
            let hotelIDs = state.hotelIds.split(",")?.map((r) => +r);
            const selectedHotels = hotelList?.map((r) => {
              if (hotelIDs?.includes(r.hotelID)) {
                r.isChecked = true;
              } else {
                r.isChecked = false;
              }
              return r;
            });

            childcall.updateHotelList(selectedHotels, type);
          }
          if (!initial) {
            childcall.updateHotelList(hotelList, type);
          }
        }
      }
    });
  };

  const checkGroupSelected = (group) => {
    state.multigroupList = group;
    updateHtmlControlState(state);
  };

  const handleMultiReportGroupChange = (
    value: any,
    reset = false,
    groupList: any = [],
    oldrows: any = []
  ) => {
    state.multigroupList = value;
    state.SubGroupid = "";
    setNewParameterValue("SubGroupid", "");
    updateHtmlControlState(state);
    if (reset) {
      setNewParameterValue("SubGroupid", "");
      setNewParameterValue("GroupName", "");
      setNewParameterValue("OnlyGroupName", "");
      setNewParameterValue("HotelBrand", "");
      setNewParameterValue("OwnershipIDorGroupid", "0");
      state.subGroupSelectValue = "Select Group";
      setNewParameterValue("ReportType", "");
      updateHtmlControlState(state);
    }
    let OwnershipIDorGroupid;
    if (value.length > 0) {
      let selectedGrpNames: any = [];
      let newItem = "";
      let getgrpnames;
      value.forEach((element: any) => {
        newItem += element.subGroupName + ",";
      });
      newItem = newItem.replace(/,(\s+)?$/, "");
      let _newVal: any = newItem.split(",");
      _newVal = _.uniq(_newVal);
      selectedGrpNames.push(_newVal.toString());
      getgrpnames = selectedGrpNames[0];
      let lastcomaaGroups = getgrpnames.replace(/,(\s+)?$/, "");
      let setGrpNames = lastcomaaGroups;
      state.subGroupSelectValue = setGrpNames;
      state.subGroupSelectedList = value;
      updateHtmlControlState(state);
      setNewParameterValue("ReportType", "");
      setNewParameterValue("HotelBrand", lastcomaaGroups);
      value.forEach((element: any) => {
        setNewParameterValue(
          "OnlyGroupName",
          element.groupName === undefined
            ? state?.OnlyGroupName
            : element.groupName
        );
        if (element.subGroupName !== "") {
          let subgroupname;
          // let hotelcode;
          let setsubGroupName = element.subGroupName;
          const stringToRemove = setsubGroupName?.toString()?.split("-")[0];
          subgroupname = setsubGroupName.replace(stringToRemove, "");
          while (subgroupname.charAt(0) === "-") {
            subgroupname = subgroupname.substring(1)?.trim();
          }
          setNewParameterValue(
            "GroupName",
            element.groupName === "Select Group"
              ? ""
              : (element?.groupName === undefined
                ? state?.groupSelectValue
                : element?.groupName) +
              " : " +
              element.subGroupName.toUpperCase()
          );
          setNewParameterValue(
            "OwnershipIDorGroupid",
            element?.groupID === undefined
              ? state?.OwnershipIDorGroupid
              : element?.groupID
          );
        }
      });
      if (value[0].subGroupID !== "-0001") {
        handleMultiGroupItemChange(value, oldrows);
      }
    } else {
      //state.groupIds = "";
      handleMultiGroupItemChange(value, oldrows);
      // updateEmployeeDDL();
      state.subGroupSelectValue = "";
      updateHtmlControlState(state);
    }
  };

  const handleMultiGroupItemChange = (
    item: any,
    oldrows: any = [],
    initial: any = false
  ) => {
    //state.hotelIds = "";
    if (!item || item.length === 0) {
      let hotelIds = state?.hotelIds.split(",");
      let Hidlist: any = [];
      hotelIds.forEach((o: any) => {
        Hidlist.push({ hotelID: o });
      });
      const childcall: any = buisnessAccountRef.current;
      // state.hotelIds = "";
      // const hotelList: any = [];
      // updateHtmlControlState(state);
      childcall.updateHotelList(Hidlist, oldrows);
      return false;
    }
    const childcall: any = buisnessAccountRef.current;
    if (+item?.groupID === 0 || +item?.groupID === -1) {
      setNewParameterValue("HotelBrand", "");
      if (+item?.groupID === 0) {
        childcall.updateHotelList([], true);
      } else {
        childcall.updateHotelList([]);
      }
      state.subGroupSelectValue = item.groupName;
      updateHtmlControlState(state);
      return;
    }
    state.SubGroupid = "";
    state.SubGroupid = item?.map((x) => x?.subGroupID).join(",");
    updateHtmlControlState(state);
    setNewParameterValue("SubGroupid", state.SubGroupid);
    const hotelList: any = [];
    item.forEach((value: any) => {
      AllHotelBrandSelector.GetHidSelectbyGroup(
        value.subGroupID,
        controlshouldBeVisible("showAllHotels"),
        reportData?.payrollSubscriptionRequired
      ).then(async (result: any | null) => {
        if (result != null) {
          result.forEach((element) => {
            let newItem = {} as any;
            newItem.hotelID = element.hotelID;
            newItem.isChecked = true;
            hotelList.push(newItem);
          });
          if (buisnessAccountRef.current !== null) {
            if (initial && state.hotelIds?.length > 0) {
              let hotelIDs = state.hotelIds.split(",")?.map((r) => +r);
              const selectedHotels = hotelList?.map((r) => {
                if (hotelIDs?.includes(r.hotelID)) {
                  r.isChecked = true;
                } else {
                  r.isChecked = false;
                }
                return r;
              });
              childcall.updateHotelList(selectedHotels, oldrows);
            }
            if (!initial) {
              childcall.updateHotelList(hotelList, oldrows);
            }
          }
        }
      });
    });
  };

  const handleParameterIsPagebreakIsCheck = (event) => {
    let checked = event.target.checked;
    const isPageBreak = checked ? "1" : "0";
    const exportType = checked ? "pdf" : "View";
    state.isPageBreak = checked;
    updateHtmlControlState(state);
    setNewParameterValue("IsPageBreak", isPageBreak);
    setNewParameterValue("ExportType", exportType);
  };

  const handleParameterChangeIsCheck = (event) => {
    let checked = event.target.checked;
    state.isIncludeEnterpriseEmployees = checked;
    updateHtmlControlState(state);
    const isExclude = checked ? "Yes" : "No";
    setNewParameterValue("IsExclude", isExclude);
  };

  const setNewParameterValue = (name: string, value: any) => {
    const newParameter: IReportParameter = { name, value };
    const nameIndex = reportParameters.map((p) => p.name).indexOf(name);
    let currentReportParameters = reportParameters;
    if (nameIndex > -1) {
      currentReportParameters.splice(nameIndex, 1);
    }
    currentReportParameters.push(newParameter);
    setReportParameters(currentReportParameters);
  };

  const getNewParameterValueByName = (name: string) => {
    return reportParameters.find((p) => p.name === name)?.value ?? "";
  };

  const handleAccountingYearChange = (value) => {
    state.accountingYear = value;
    updateHtmlControlState(state);
    setNewParameterValue("Year", value);
  };

  const handleCurrentYearChange = (value) => {
    state.currentYear = value;
    updateHtmlControlState(state);
    setNewParameterValue("currentYear", value);
  };

  const handleComparisonYearChange = (value) => {
    state.comparisonYear = value;
    updateHtmlControlState(state);
    setNewParameterValue("comparisonYear", value);
  };

  const handleAccPeriodMonth = (value) => {
    state.accPeriodMonth = value;
    updateHtmlControlState(state);
    setNewParameterValue("accPeriodMonth", value);
  };

  const handleEmployementTypeChange = (value) => {
    state.employementType = value;
    updateHtmlControlState(state);
    setNewParameterValue("EmpType", value);

    if (
      props.reportData.uniqueReportId == 49 &&
      state.employementType != "Contractor"
    ) {
      state.isPageBreak = false;
      const isPageBreak = state.isPageBreak ? "1" : "0";
      const exportType = state.isPageBreak ? "pdf" : "View";
      setNewParameterValue("IsPageBreak", isPageBreak);
      setNewParameterValue("ExportType", exportType);
    }
  };

  const handleLookBackPeriodChange = (value) => {
    state.lookBackPeriod = value;
    updateHtmlControlState(state);
    setNewParameterValue("LookBack", value);
  };

  const handleEmployeeChange = (value) => {
    debugger;
    state.employee = value;
    updateHtmlControlState(state);
    setNewParameterValue("Employee", value);
  };

  const handleBankAccountChange = (value) => {
    state.BankAccount = value.name;
    updateHtmlControlState(state);
    setNewParameterValue("BankAccount", value.oprID);
    setNewParameterValue("BankAccountName", value.name);
  };

  const handleReportTypeChange = (value) => {
    state.reportType = value;
    // state.startDate = "";
    // setNewParameterValue("StartDate", "");
    if (value !== "ByEmployee") {
      state.employee = "";
      const type = "Employee";
      setNewParameterValue(type, "All Employees");
    } else {
      state.startDate = "";
      state.endDate = "";
      state.subGroupSelectValue = "Select Group";
      state.subGroupSelectedList = [];
      state.hotelIds = "";
      updateEmployeeDDL();
      setNewParameterValue("StartDate", "");
      setNewParameterValue("EndDate", "");
      setNewParameterValue("Hotelid", "");
      setNewParameterValue("HotelBrand", "");
      setNewParameterValue("GroupName", "");
    }

    const type = "ReportType";
    setNewParameterValue(type, value);
    updateHtmlControlState(state);
  };

  const handleReportChange = (item) => {
    state.Reportdesc = item.description;
    state.ReportName = item.value;
    setNewParameterValue("ReportName", item.value);
    updateHtmlControlState(state);
  };

  const handlePositivePayChange = async (item) => {
    state.PayFileFormat = item.payFileFormat;
    state.PayFileFormatId = item.id;
    state.hotelIds = "";
    setNewParameterValue("Hotelid", "");
    setNewParameterValue("PayFileFormatId", item.id);
    state.multiDocs = item.id;
    setNewParameterValue("DocumentType", item.id);
    updateHtmlControlState(state);
    if (item.id !== -1) {
      const result: any = await Hotel.getUserHotelByPositivePay(item.id);
      state.isAccountEmpty = result.length > 0;
      updateHtmlControlState(state);
      const childcall: any = buisnessAccountRef.current;
      if (buisnessAccountRef.current !== null) {
        childcall.updateHotelList(item.id);
      }
    }
  };

  const handleProjectBudgetsChange = (item) => {
    // //debugger;
    state.projectBudget = item.label;
    state.projectBudgetId = item.id;
    setNewParameterValue("projectBudget", item.label);
    setNewParameterValue("projectBudgetId", item.id);
    updateHtmlControlState(state);

    if (controlshouldBeVisible("ddlContractSelector")) {
      ////debugger;
      state.selectedContract = "Select";
      updateHtmlControlState(state);
      setNewParameterValue("selectedContract", "Select");
    }

    // if (item.id !== -1) {
    //   const childcall: any = buisnessAccountRef.current;
    //   if (buisnessAccountRef.current !== null) {
    //     childcall.updateHotelList(item.id);
    //   }
    // }
  };

  const handleVendorChange = (item) => {
    // //debugger;
    if (item.length > 0) {
      state.selectedVendorId = item[0].id;
      setNewParameterValue("selectedVendorId", item[0].id);
      updateHtmlControlState(state);
    } else {
      state.selectedVendorId = -1;
      setNewParameterValue("selectedVendorId", -1);
      updateHtmlControlState(state);
    }

    if (controlshouldBeVisible("ddlProjectBudget")) {
      ////debugger;
      state.projectBudget = "Select";
      state.projectBudgetId = -1;
      updateHtmlControlState(state);
      setNewParameterValue("projectBudget", "Select");
      setNewParameterValue("projectBudgetId", -1);
    }

    if (controlshouldBeVisible("ddlContractSelector")) {
      ////debugger;
      state.selectedContract = "Select";
      updateHtmlControlState(state);
      setNewParameterValue("selectedContract", "Select");
    }
  };

  const handleContractChange = (item) => {
    // //debugger;
    state.selectedContract = item.label;
    setNewParameterValue("selectedContract", item.label);
    updateHtmlControlState(state);
  };

  const onFormatTypeChange = (value): void => {
    state.hoursFormat = value;
    updateHtmlControlState(state);
    setNewParameterValue("timeFormat", value);
  };

  const handleACACoverageCodesChange = (value: any) => {
    const codes = value.map((r) => r?.code).join(",");

    setNewParameterValue("ACACoverageCode", codes);
    state.acaCoverageCodes = codes;
    updateHtmlControlState(state);
  };

  const handleACASaferCodesChange = (value: any) => {
    // setACACoverageCodes(value);
    const codes = value.map((r) => r?.code).join(",");
    setNewParameterValue("ACASaferCode", codes);
    state.acaACASHarborCodes = codes;
    updateHtmlControlState(state);
  };

  const onDataSourcePeriods = (value: any) => {
    let codes;
    const getPriorYear = value.filter(
      (itemList: any) =>
        itemList.value === "Prior" && itemList.isChecked === true
    );
    if (getPriorYear.length > 0) {
      state.IsPrayerYear = getPriorYear[0].value;
    } else {
      state.IsPrayerYear = "";
    }

    if (value.length > 0) {
      let selectedDataSources: any = [];
      let newItem = "";

      value.forEach((element: any) => {
        if (element.isChecked === true) {
          newItem += element.value + ",";
        }
      });
      selectedDataSources.push(newItem);
      codes = selectedDataSources[0];
      state.IsdataSoureSelect = codes;
      let split = codes.split(",");
      const arr = split.filter((item) => item);
      if (arr.length <= 3) {
        setNewParameterValue("DataSource1", codes.replace(/,\s*$/, ""));
        setNewParameterValue("Actual", "");
        setNewParameterValue("AdjustedBudget", "");
        setNewParameterValue("OriginalBudget", "");
        setNewParameterValue("Prior", "");
        setNewParameterValue("Forecast", "");
        state.dataSourceforPanL = arr.length;
      } else {
        state.dataSourceforPanL = arr.length;
      }
    } else {
      state.IsdataSoureSelect = "";
    }
    state.dataSourceValueCount = 0;
    state.dataSourceType = "Periods";
    setNewParameterValue("dataSourceType", "Periods");
    updateHtmlControlState(state);
  };

  const onDataSourceOperating = (value: any) => {
    let codes;
    const getPriorYear = value.filter(
      (itemList: any) =>
        itemList.value === "Prior" && itemList.isChecked === true
    );
    if (getPriorYear.length > 0) {
      state.IsPrayerYear = getPriorYear[0].value;
    } else {
      state.IsPrayerYear = "";
    }

    if (value.length > 0) {
      let selectedDataSources: any = [];
      let newItem = "";

      value.forEach((element: any) => {
        if (element.isChecked === true) {
          newItem += element.value + ",";
        }
      });
      selectedDataSources.push(newItem);
      codes = selectedDataSources[0];
      state.IsdataSoureSelect = codes;
      let split = codes.split(",");
      const arr = split.filter((item) => item);
      if (arr.length <= 3) {
        setNewParameterValue("DataSource1", codes.replace(/,\s*$/, ""));
        setNewParameterValue("Actual", "");
        setNewParameterValue("AdjustedBudget", "");
        setNewParameterValue("OriginalBudget", "");
        setNewParameterValue("Prior", "");
        setNewParameterValue("Forecast", "");
        state.dataSourceforPanL = arr.length;
      } else {
        state.dataSourceforPanL = arr.length;
      }
    } else {
      state.IsdataSoureSelect = "";
    }
    state.dataSourceValueCount = 0;
    state.dataSourceType = "opr";
    setNewParameterValue("dataSourceType", "opr");
    updateHtmlControlState(state);
  };

  const handlebankACCChange = (value: any) => {
    let codes;
    if (value.length > 0) {
      let selectedDataSources: any = [];
      let newItem = "";
      let bankNames = "";
      let type = "";
      value.forEach((element: any) => {
        if (element.isChecked === true) {
          newItem += element.value + ",";
          bankNames += element.label + ",";
          if (value.length > 1) {
            type = "Cash";
          } else {
            type +=
              element.acctType === "CC" ? "C" + "," : element.acctType + ",";
          }
        }
      });
      selectedDataSources.push(newItem);
      codes = selectedDataSources[0];
      state.BankAccount = bankNames;
      setNewParameterValue("OwnershipID", codes.replace(/,\s*$/, ""));
      setNewParameterValue("Type", type.replace(/,\s*$/, ""));
    } else {
      state.BankAccount = "";
      setNewParameterValue("OwnershipID", "");
      setNewParameterValue("Type", "");
    }
    updateHtmlControlState(state);
  };

  const handleDataSourceChang = (value: any) => {
    let codes;
    if (value.length > 0) {
      let selectedDataSources: any = [];
      let newItem = "";
      value.forEach((element: any) => {
        if (element.isChecked === true) {
          newItem += element.value + ",";
        }
      });
      selectedDataSources.push(newItem);
      codes = selectedDataSources[0];
      state.IsdataSoureSelect = codes;
      let split = codes.split(",");
      const arr = split.filter((item) => item);

      setNewParameterValue("DataSource1", codes);
      setNewParameterValue("IsADR", "");
      setNewParameterValue("IsOCC", "");
      setNewParameterValue("IsRMREV", "");
      setNewParameterValue("IsREVPAR", "");
      state.dataSourceValueCount = arr.length;
    } else {
      state.IsdataSoureSelect = "";
    }
    state.dataSourceforPanL = 0;
    state.dataSourceType = "";
    setNewParameterValue("dataSourceType", "");
    updateHtmlControlState(state);
  };

  const handleDataSource2Chang = (value: any) => {
    let codes;
    if (value.length > 0) {
      let selectedDataSources: any = [];
      let newItem = "";
      value.forEach((element: any) => {
        if (element.isChecked === true) {
          newItem += element.value + ",";
        }
      });
      selectedDataSources.push(newItem);
      codes = selectedDataSources[0];
      state.IsdataSoureSelect2 = codes.replace(/,\s*$/, "");
      let split = codes.split(",");
      const arr = split.filter((item) => item);
      if (arr.length > 0) {
        setNewParameterValue("DataSource2", codes.replace(/,\s*$/, ""));
        updateHtmlControlState(state);
        state.dataSourceValueCount = 0;
      } else {
        state.dataSourceValueCount = arr.length;
      }
    } else {
      state.IsdataSoureSelect2 = "";
      setNewParameterValue("DataSource2", "");
      updateHtmlControlState(state);
    }
  };

  const handleDataSource2ChangPeriods = (value: any) => {
    state.dataSourceType = "Periods";
    if (props.reportData.rdlcName !== "PLReport12AccPerAllOptimize.rdlc") {
      setNewParameterValue("dataSourceType", "Periods");
    }
    let codes;
    if (value.length > 0) {
      let selectedDataSources: any = [];
      let newItem = "";
      value.forEach((element: any) => {
        if (element.isChecked === true) {
          newItem += element.value + ",";
        }
      });
      selectedDataSources.push(newItem);
      codes = selectedDataSources[0];
      state.IsdataSoureSelect2 = codes.replace(/,\s*$/, "");
      let split = codes.split(",");
      const arr = split.filter((item) => item);
      let isCalculatedStatusRequired =
        codes.includes("%") || codes.includes("POR");
      if (isCalculatedStatusRequired) {
        state.CalculatedStatus = "";
        setNewParameterValue("CalculatedStatus", "");
      } else {
        if (state.CalculatedStatus == "") {
          state.CalculatedStatus = "Total";
          updateHtmlControlState(state);
          setNewParameterValue("CalculatedStatus", "Total");
        }
      }

      if (arr.length > 0) {
        setNewParameterValue("DataSource2", codes.replace(/,\s*$/, ""));
        updateHtmlControlState(state);
        state.dataSourceValueCount = arr.length;
      } else {
        state.dataSourceValueCount = arr.length;
      }
    } else {
      state.IsdataSoureSelect2 = "";
      setNewParameterValue("DataSource2", "");
      updateHtmlControlState(state);
    }
  };

  const handleAgingSelectChange = (value: any) => {
    let codes;
    if (value.length > 0) {
      let selectedDataSources: any = [];
      let newItem = "";

      value.forEach((element: any) => {
        if (element.isChecked === true) {
          newItem += element.value + ",";
        }
      });
      selectedDataSources.push(newItem);
      codes = selectedDataSources[0];
      state.IsAgingSelect = codes;
      // let split = codes.split(',');
      // const arr = split.filter(item => item);
      setNewParameterValue("Aging", codes.replace(/,\s*$/, ""));
      updateHtmlControlState(state);
    } else {
      state.IsAgingSelect = "";
      // updateHtmlControlState(state);
    }
  };

  const handleACACodeChange = (e: any) => {
    const checked = e.currentTarget.checked;
    // e.currentTarget.checked = checked;
    const type = "ChkSummSec";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isAcaCodes = checked;
    updateHtmlControlState(state);
  };

  const handleIsCompSetChange = (e: any) => {
    const checked = e.currentTarget.checked;
    // e.currentTarget.checked = checked;
    const type = "ChkIsCompSet";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isCompSet = checked;
    updateHtmlControlState(state);
  };

  const handleIsIncludeDescChange = (e: any) => {
    const checked = e.currentTarget.checked;
    // e.currentTarget.checked = checked;
    const type = "ChkIsIncludeDesc";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isIncludeDesc = checked;
    updateHtmlControlState(state);
  };

  const handleIncludeBudget = (e: any) => {
    const checked = e.currentTarget.checked;
    // e.currentTarget.checked = checked;
    const type = "ChkIncludeBudget";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isIncludeBudget = checked;
    updateHtmlControlState(state);
  };

  const handleZeroActualValues = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "ChkHideZeroActualValues";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isZeroActualValues = checked;
    updateHtmlControlState(state);
  };

  const handleIncludeRevenue = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "ChkIncludeRevenue";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isIncludeRevenue = checked;
    updateHtmlControlState(state);
  };

  const handleBankBalanceValues = (e: any) => {
    const checked = e.currentTarget.checked;
    // e.currentTarget.checked = checked;
    const type = "chkBankBalance";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isBankBalanceValues = checked;
    updateHtmlControlState(state);
  };

  const handleShowSummaryValues = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "chkSummayOnly";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isShowSummayValues = checked;
    updateHtmlControlState(state);
  };

  const handleShowCombinedValues = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "chkShowCombinedOnly";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isShowCombinedValues = checked;
    updateHtmlControlState(state);
  };

  const handleGrpBankAccountsValues = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "chkGroupBankAccountsByType";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isGrpBankAccByTypeValues = checked;
    updateHtmlControlState(state);
  };

  const handleGrpCCAccountsValues = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "chkGroupCCAccounts";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isGrpCCAccountsValues = checked;
    updateHtmlControlState(state);
  };

  const handleNonWorkingHoursAndwages = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "chkNonWorkingHoursAndwages";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.showNonWorkingHoursAndwages = checked;
    updateHtmlControlState(state);
  };

  const handleCheckbyCOA = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "ChkCheckCOA";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.IsCheckCOA = checked;
    updateHtmlControlState(state);
  };

  const handleGeneralCode = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "ChkGeneralCode";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.IsGeneralCode = checked;
    updateHtmlControlState(state);
  };

  const handleContractorExclude = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "ChkContractorExclude";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.IsContractorExclude = checked;
    updateHtmlControlState(state);
  };

  const handleShowZeroActualHours = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "chkShowZeroActualHours";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.IsShowZeroActualHours = checked;
    updateHtmlControlState(state);
  };

  const handleHideStatistics = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "ChkHideStatistics";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.IsHideStatistics = checked;
    updateHtmlControlState(state);
  };

  const handleIncludePendingInvoices = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "ChkIncludePendingInvoices";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.IsIncludePendingInvoices = checked;
    updateHtmlControlState(state);
  };

  const handleUnapprovedtransactions = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "ChkUnapprovedtransactions";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.IsUnapprovedtransactions = checked;
    updateHtmlControlState(state);
  };

  const handleIncludeCustomer = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "chkIncludeCustomer";
    const _value = checked ? "Yes" : "No";
    setNewParameterValue(type, _value);
    state.isIncludeCustomer = checked;
    updateHtmlControlState(state);
  };

  const handleExClearedtransactions = (e: any) => {
    const checked = e.currentTarget.checked;
    const type = "ExcClearedTran";
    const _value = checked ? "1" : "0";
    setNewParameterValue(type, _value);
    state.IsExClearedtransactions = checked;
    updateHtmlControlState(state);
  };

  const handleHireDateChange = ({ currentTarget: { value } }) => {
    const type = "HireDate";
    state.hireDate = value;
    updateHtmlControlState(state);
    setNewParameterValue(type, value);
  };

  const handleAvgHoursChange = ({ currentTarget: { value } }) => {
    const type = "AvgHrsWorked";
    state.avgHours = value;
    updateHtmlControlState(state);
    setNewParameterValue(type, value);
  };

  const handleFileSizeChange = ({ currentTarget: { value } }) => {
    const type = "FileSize";
    if (value.toString().includes(".")) {
      state.fileSize = Number(
        value.split(".")[0] + "." + value.split(".")[1].substring(0, 2)
      ).toString();
    } else {
      state.fileSize = value;
    }
    updateHtmlControlState(state);
    setNewParameterValue(type, value);
  };

  const updateEmployeeDDL = () => {
    if (employeeDDLRef?.current) {
      if (typeof employeeDDLRef?.current["updateEmployeeDDL"] === "function") {
        employeeDDLRef?.current?.updateEmployeeDDL(
          state.hotelIds,
          state.status
        );
      }
    }
  };

  const handleDepartmentChange = (value: any) => {
    if (value.length > 0) {
      let selectedDepartments: any = [];
      let newItem = "";
      let gethides;
      value.forEach((element: any) => {
        newItem += element.deptID + ",";
      });
      selectedDepartments.push(newItem);
      gethides = selectedDepartments[0];
      let lastcomaadep = gethides.replace(/,(\s+)?$/, "");
      state.departmentIds = lastcomaadep;
      updateHtmlControlState(state);
      setNewParameterValue("deptID", lastcomaadep);
    } else {
      state.departmentIds = "";
      setNewParameterValue("deptID", "");
      updateHtmlControlState(state);
    }
  };

  const handleMultiEmployeeChange = (value: any) => {
    if (value.selectedItems.length > 0) {
      let selectedDepartments: any = [];
      let newItem = "";
      let gethides;
      let valu1 = value.selectedItems;
      valu1.forEach((element: any) => {
        newItem += element.value + ",";
      });
      selectedDepartments.push(newItem);
      gethides = selectedDepartments[0];
      let lastcomaadep = gethides.replace(/,(\s+)?$/, "");
      state.userUniquenIds = lastcomaadep;
      updateHtmlControlState(state);
      setNewParameterValue("userUniquenId", lastcomaadep);
    } else {
      state.userUniquenIds = "All";
      setNewParameterValue("userUniquenId", "All");
      updateHtmlControlState(state);
    }
  };


  const handlePMschedulesChange = (value: any) => {
    debugger;
    if (value.selectedItems.length > 0) {
      let selectedDepartments: any = [];
      let newItem = "";
      let gethides;
      let valu1 = value.selectedItems;
      valu1.forEach((element: any) => {
        newItem += element.id + ",";
      });
      selectedDepartments.push(newItem);
      gethides = selectedDepartments[0];
      let lastcomaadep = gethides.replace(/,(\s+)?$/, "");
      state.PmScheduleId = lastcomaadep;
      updateHtmlControlState(state);
      setNewParameterValue("PmScheduleId", lastcomaadep);
    } else {
      state.PmScheduleId = "All";
      updateHtmlControlState(state);
      setNewParameterValue("PmScheduleId", "All");

    }
  };

  const handelResponseStatus = (value): void => {
    debugger;
    state.responseStatus = value;
    updateHtmlControlState(state);
    setNewParameterValue("responseStatus", value);
  };

  const handelFCResponseStatus = (value): void => {
    state.responseFCStatus = value;
    updateHtmlControlState(state);
    setNewParameterValue("responseFCStatus", value);
  };
  const handelFCWoStatus = (value): void => {
    state.FCWoStatus = value;
    updateHtmlControlState(state);
    setNewParameterValue("FCWoStatus", value);
  };

  const handelFCWoSorting = (value): void => {
    state.FCWoSorting = value;
    updateHtmlControlState(state);
    setNewParameterValue("FCWoSorting", value);
  };

  const handelFCAWOSorting = (value): void => {
    state.FcAwoSorting = value;
    updateHtmlControlState(state);
    setNewParameterValue("FcAwoSorting", value);
  };

  const handelFCAWOStatus = (value): void => {
    state.FcAwoStatus = value;
    updateHtmlControlState(state);
    setNewParameterValue("FcAwoStatus", value);
  };

  const handelFCAssetFilterStatus = (value: any) => {
    debugger;
    if (value.selectedItems.length > 0) {
      let selectedDepartments: any = [];
      let newItem = "";
      let gethides;
      let valu1 = value.selectedItems;
      valu1.forEach((element: any) => {
        newItem += element.id + ",";
      });
      selectedDepartments.push(newItem);
      gethides = selectedDepartments[0];
      let lastcomaadep = gethides.replace(/,(\s+)?$/, "");
      state.FcAssetLocation = lastcomaadep;
     
      setNewParameterValue("FcAssetLocation", lastcomaadep);
      updateHtmlControlState(state);
    } else {
      state.FcAssetLocation = "All";     
      setNewParameterValue("FcAssetLocation", "All");
      updateHtmlControlState(state);
    }
  };





  const handelFCAssetType = (value): void => {
    state.FcAssetTypeDetails = value;
    updateHtmlControlState(state);
    setNewParameterValue("FcAssetTypeDetails", value);
  };

  const handelFCAssetSorting = (value): void => {
    state.FcAssetLocationSorting = value;
    updateHtmlControlState(state);
    setNewParameterValue("FcAssetLocationSorting", value);
  };

  const handleCOAType = (value): void => {
    //  setTimeout(() => {
    //   setshowhide("3");
    // }, 0);
    // setState
    state.coaAccounts = "";
    state.coaAccountsOne = "";
    state.coaAccountsTwo = "";
    state.coAaccountType = value;
    updateHtmlControlState(state);
    setNewParameterValue("ddlcoaType", value);
    //resetSerchBox();
    clearCOAList();
  };

  const clearCOAList = () => {
    if (props.reportData.moduleReportId === 2096) {
      setNewParameterValue("AccountFrom", "");
      setNewParameterValue("AccountTo", "");
      setNewParameterValue("SelectSingleCoa", "");
      state.coaFromId = "";
      state.coaToId = "";
      updateHtmlControlState(state);
    }
  };

  const handleDateLayOut = (value: number): void => {
    state.dateLayOutSelector = +value;
    state.hotelIds = "";
    state.isLayOutSelector = true;
    updateHtmlControlState(state);
    setNewParameterValue("ddlReportLayoutforDates", value);
  };

  const handleRowTittle = (value): void => {
    state.rowTitles = value;
    updateHtmlControlState(state);
    setNewParameterValue("RowTittle", value);
  };

  const handleDisputeStauts = (value): void => {
    state.disputueStatus = value;
    updateHtmlControlState(state);
    setNewParameterValue("DisputeStatus", value);
  };

  const handleExpireStauts = (value): void => {
    state.expireStatus = value;
    updateHtmlControlState(state);
    setNewParameterValue("ExpireStatus", value);
  };

  const handleEpayStatus = (value): void => {
    state.ePayStatus = value;
    updateHtmlControlState(state);
    setNewParameterValue("ePayStatusCtrl", value);
  };

  const handleddlType = (value): void => {
    state.reportSubTypes = value;
    updateHtmlControlState(state);
    setNewParameterValue("DDLType", value);
  };
  const handleReportSortSelectorChange = (value): void => {
    state.scheduleReportSortBy = value;
    updateHtmlControlState(state);
    setNewParameterValue("ScheduleReportSortBy", value);
  };

  const handleHireDateSortSelectorChange = (value): void => {
    state.hireDateSortBy = value;
    updateHtmlControlState(state);
    setNewParameterValue("HireDateSortBy", value);
  };

  const handleStatusStringSelectorChange = (value, type: any = ""): void => {
    if (type !== "def") {
      handleEmployeeChange("");
    }
    state.loadEmployee = true;
    state.statusString = value;
    updateHtmlControlState(state);
    setNewParameterValue("StatusString", value);

    setTimeout(() => {
      state.loadEmployee = false;
      updateHtmlControlState(state);
    }, 10);
  };

  const handleEmployeeStatusSelectorChange = (value): void => {
    state.employeeStatus = value;
    updateHtmlControlState(state);
    setNewParameterValue("EmployeeStatus", value);
  };
  const handleGroupBySelectorChange = (value): void => {
    state.groupBy = value;
    updateHtmlControlState(state);
    setNewParameterValue("GroupBy", value);
  };

  const handleEmployeeWageExtendedReportSortSelectorChange = (value): void => {
    state.employeeWageNewReportSortBy = value;
    updateHtmlControlState(state);
    setNewParameterValue("EmployeeWageNewReportSortBy", value);
  };

  const handleMultiTabls = (value): void => {
    state.multiTabs = value;
    updateHtmlControlState(state);
    setNewParameterValue("ddlMultiTabls", value);
  };

  const handleHotelDisplayFormat = (value): void => {
    state.hotelDisplayFormat = value;
    updateHtmlControlState(state);
    setNewParameterValue("ddlHotelDisplayFormat", value);
  };

  const handleMultiDocType = (value: any): void => {
    state.multiDocs = value.toString();
    updateHtmlControlState(state);
    setNewParameterValue("DocumentType", value.toString());
  };

  const multiSelectVendor = (value: any): void => {
    state.multiSelectVendor = value.toString();
    updateHtmlControlState(state);
    setNewParameterValue("MultiSelectVendor", value.toString());
  };

  const handleMultiCoaClassificationType = (value: any): void => {
    state.selectedCoaClassificationTypes = value.toString();
    updateHtmlControlState(state);
    setNewParameterValue("CoaClassificationTypes", value.toString());
  };

  const handleAmountVal = (value: any): void => {
    let newVal = Utils.removecurrencyFormat(value);
    state.amountVal = newVal;
    updateHtmlControlState(state);
    setNewParameterValue("MinimumAmount", newVal);
  };

  const handleGenerate1096 = (value): void => {
    state.generate1096Val = value;
    updateHtmlControlState(state);
    setNewParameterValue("Generate1096", value);
  };

  const onSummarySubTypeChange = (value): void => {
    state.laborSummarySubType = value;
    setNewParameterValue("isPosition", value);
  };

  const setPunchHistoryDefaultParams = () => {
    if (
      +reportData?.reportVariantValue === 2 ||
      +reportData?.reportVariantValue === 3
    ) {
      setNewParameterValue("isPosition", "All Employees");
      setNewParameterValue("Employee", "All Employees");
      setNewParameterValue("Employees", "All Employees");
    } else if (+reportData?.reportVariantValue === 6) {
      setNewParameterValue("Employee", "All Employees");
    }
  };

  const setLaborSummaryCheckBoxValue = (type, e): void => {
    const _value = e.currentTarget.checked ? "Yes" : "No";
    state[type] = e.currentTarget.checked;
    updateHtmlControlState(state);
    setNewParameterValue(type, _value);
  };

  const setLaborSummaryDefaultParams = () => {
    setNewParameterValue("Report", "115");
    setNewParameterValue("OwnershipID", "0");
    setNewParameterValue("OwnershipIDorGroupid", "0");
    setNewParameterValue("HotelType", "");
    setNewParameterValue("ReportName", "1");
    setNewParameterValue("isPosition", "No");
    setNewParameterValue("IsSalaried", "No");
    setNewParameterValue("IsExcludePayroll", "No");
    setNewParameterValue("IsVariance", "No");
    setNewParameterValue("IsDollars", "No");
    setNewParameterValue("ActualCompared", "0");
  };

  const getControl = (paramName: string): any => {
    if (
      (reportInputParameters?.length === 0 &&
        visibleHtmlControls?.length === 0) ||
      !paramName
    ) {
      return {};
    }
    let item: any = {};
    if (reportInputParameters?.length > 0) {
      item = reportInputParameters.find(
        (r) =>
          r?.paramName?.toLowerCase()?.trim() ===
          paramName.toLowerCase()?.trim()
      );
    }
    if (visibleHtmlControls?.length > 0) {
      item = visibleHtmlControls.find(
        (r) =>
          r?.controlName?.toLowerCase()?.trim() ===
          paramName.toLowerCase()?.trim()
      );
    }
    return item;
  };

  const controlshouldBeVisible = (controlName: string): boolean => {
    if (
      (reportInputParameters?.length === 0 &&
        visibleHtmlControls?.length === 0) ||
      !controlName
    ) {
      return false;
    }
    if (reportInputParameters?.length > 0) {
      return reportInputParameters?.filter(
        (item: any) =>
          item?.paramName?.toLowerCase()?.trim() ===
          controlName?.toLowerCase()?.trim()
      ).length > 0
        ? true
        : false;
    } else if (visibleHtmlControls?.length > 0) {
      return visibleHtmlControls?.filter(
        (item: any) =>
          item?.controlName?.toLowerCase()?.trim() ===
          controlName?.toLowerCase()?.trim()
      ).length > 0
        ? true
        : false;
    } else {
      return false;
    }
  };

  const getSwitchButtonControls = (state: IParameterSelectionState) => {
    return [
      {
        controlName: "chkStatus",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="chkStatus">
                <Form.Label className="sec-ttl ">
                  {reportData?.uniqueReportId === 1 ? "COA Type" : "Status"}
                </Form.Label>
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll rm-index"
                  label="Active"
                  name="coaType"
                  id="chkActive"
                  value="Active"
                  ref={activeCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void => handleParameterChange(event.target, 1)}
                  checked={+state.status === 1}
                />
                <Form.Check
                  custom
                  className="sm-controll rm-index"
                  type="switch"
                  label="Inactive"
                  name="coaType"
                  id="chkInactive"
                  value="Inactive"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void => handleParameterChange(event.target, 2)}
                  checked={+state.status === 2}
                />
                <Form.Check
                  custom
                  className="sm-controll rm-index"
                  type="switch"
                  label="Both"
                  name="coaType"
                  id="chkBoth"
                  value="Both"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void => handleParameterChange(event.target, 3)}
                  checked={+state.status === 3}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkDesignLayOut",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="chkDesignLayOut">
                <Form.Label className="sec-ttl ">Layout Design</Form.Label>
                {reportData?.moduleReportId === 2204 ? (
                  <React.Fragment>
                    <Form.Check
                      custom
                      className="sm-controll"
                      type="switch"
                      label={
                        reportData?.moduleReportId === 2204
                          ? "YTD"
                          : "Year to Date (YTD)"
                      }
                      name="coaType"
                      id="chkYeartoDate(YTD)"
                      value="2"
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ): void =>
                        handleParameterChange12Account(event.target, 2)
                      }
                      checked={+state.TwelveAccountPeriod === 2}
                    />
                    <Form.Check
                      type="switch"
                      custom
                      className="sm-controll"
                      label={
                        reportData?.moduleReportId === 2204
                          ? "Trailing 12"
                          : "Trailing 12 accounting periods"
                      }
                      name="coaType"
                      id="chkTrailing12accountingperiods"
                      value="1"
                      ref={accountingperiodsCheckBox}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ): void =>
                        handleParameterChange12Account(event.target, 1)
                      }
                      checked={+state.TwelveAccountPeriod === 1}
                    />{" "}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Form.Check
                      type="switch"
                      custom
                      className="sm-controll"
                      label={
                        reportData?.moduleReportId === 2204
                          ? "Trailing 12"
                          : "Trailing 12 accounting periods"
                      }
                      name="coaType"
                      id="chkTrailing12accountingperiods"
                      value="1"
                      ref={accountingperiodsCheckBox}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ): void =>
                        handleParameterChange12Account(event.target, 1)
                      }
                      checked={+state.TwelveAccountPeriod === 1}
                    />
                    <Form.Check
                      custom
                      className="sm-controll"
                      type="switch"
                      label={
                        reportData?.moduleReportId === 2204
                          ? "YTD"
                          : "Year to Date (YTD)"
                      }
                      name="coaType"
                      id="chkYeartoDate(YTD)"
                      value="2"
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ): void =>
                        handleParameterChange12Account(event.target, 2)
                      }
                      checked={+state.TwelveAccountPeriod === 2}
                    />
                  </React.Fragment>
                )}
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkLayoutDesign",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="chkDesignLayOut">
                <Form.Label className="sec-ttl ">Layout Design</Form.Label>
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll"
                  label="Actual/Forecast"
                  name="actual-forecast"
                  id="chkactualforecast"
                  value="1"
                  ref={accountingperiodsCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void => handleParameterChange12Account(event.target, 1)}
                  checked={+state.TwelveAccountPeriod === 1}
                />
                <Form.Check
                  custom
                  className="sm-controll"
                  type="switch"
                  label="Actual Only"
                  name="actualonly"
                  id="chkactualonly"
                  value="2"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void => handleParameterChange12Account(event.target, 2)}
                  checked={+state.TwelveAccountPeriod === 2}
                />
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll"
                  label="Forecast Only"
                  name="forecastonly"
                  id="chkforecastonly"
                  value="3"
                  ref={accountingperiodsCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void => handleParameterChange12Account(event.target, 3)}
                  checked={+state.TwelveAccountPeriod === 3}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkDataSource1",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="chkDataSource1">
                <Form.Label className="sec-ttl ">Data Source 1</Form.Label>
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll"
                  label="Adjusted Budget"
                  name="coaType"
                  id="chkAdjustedBudget"
                  value="Adjusted Budget"
                  ref={payRollDataSourceCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollDataSoure(
                      event.target,
                      "Adjusted Budget"
                    )
                  }
                  checked={state.adjustedBudget === "Adjusted Budget"}
                />
                <Form.Check
                  custom
                  className="sm-controll"
                  type="switch"
                  label="Original Budget"
                  name="coaType"
                  id="chkOriginalBudget"
                  value="Original Budget"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollDataSoure(
                      event.target,
                      "Original Budget"
                    )
                  }
                  checked={state.adjustedBudget === "Original Budget"}
                />
                <Form.Check
                  custom
                  className="sm-controll"
                  type="switch"
                  label="Forecast"
                  name="coaType"
                  id="chkForecast"
                  value="Forecast"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollDataSoure(event.target, "Forecast")
                  }
                  checked={state.adjustedBudget === "Forecast"}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkDataSource1Periods",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="chkDataSource1">
                <Form.Label className="sec-ttl ">Data Source 1</Form.Label>
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll"
                  label="Actual"
                  name="coaType"
                  id="chkActual"
                  value="Actual"
                  ref={payRollDataSourcePeriodCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollChkDataSoure(event.target, "Actual")
                  }
                  checked={state.actual === "Actual"}
                />
                <Form.Check
                  custom
                  className="sm-controll"
                  type="switch"
                  label="Original Budget"
                  name="coaType"
                  id="chkOriginalBudget"
                  value="Original Budget"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollChkDataSoure(
                      event.target,
                      "Original Budget"
                    )
                  }
                  checked={state.actual === "Original Budget"}
                />
                <Form.Check
                  custom
                  className="sm-controll"
                  type="switch"
                  label="Forecast"
                  name="coaType"
                  id="chkForecast"
                  value="Forecast"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollChkDataSoure(event.target, "Forecast")
                  }
                  checked={state.actual === "Forecast"}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkDataSource1IncomeStatement3",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="chkDataSource1IncomeStatement3">
                <Form.Label className="sec-ttl ">Data Source 1</Form.Label>
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll"
                  label="Actual"
                  name="coaType"
                  id="chkActual"
                  value="Actual"
                  ref={payRollDataSourcePeriodCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollChkDataSoure(event.target, "Actual")
                  }
                  checked={state.actual === "Actual"}
                />
                <Form.Check
                  custom
                  className="sm-controll"
                  type="switch"
                  label="Adjusted Budget"
                  name="coaType"
                  id="chkAdjustedBudget"
                  value="Adjusted Budget"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollChkDataSoure(
                      event.target,
                      "Adjusted Budget"
                    )
                  }
                  checked={state.actual === "Adjusted Budget"}
                />
                <Form.Check
                  custom
                  className="sm-controll"
                  type="switch"
                  label="Original Budget"
                  name="coaType"
                  id="chkOriginalBudget"
                  value="Original Budget"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollChkDataSoure(
                      event.target,
                      "Original Budget"
                    )
                  }
                  checked={state.actual === "Original Budget"}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkDataSource1Income",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="chkDataSource1Income">
                <Form.Label className="sec-ttl ">Data Source 1</Form.Label>
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll"
                  label="Actual"
                  name="coaType"
                  id="chkActual"
                  value="Actual"
                  ref={payRollDataSourcePeriodCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollChkDataSoure(event.target, "Actual")
                  }
                  checked={state.actual === "Actual"}
                />
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll"
                  label="Adjusted Budget"
                  name="coaType"
                  id="chkAdjustedBudget"
                  value="Adjusted Budget"
                  ref={payRollDataSourceCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollDataSoureIncome(
                      event.target,
                      "Adjusted Budget"
                    )
                  }
                  checked={state.adjustedBudget === "Adjusted Budget"}
                />
                <Form.Check
                  custom
                  className="sm-controll"
                  type="switch"
                  label="Original Budget"
                  name="coaType"
                  id="chkOriginalBudget"
                  value="Original Budget"
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollDataSoureIncome(
                      event.target,
                      "Original Budget"
                    )
                  }
                  checked={state.adjustedBudget === "Original Budget"}
                />
                {props.reportData.moduleReportId !== 2168 && (
                  <Form.Check
                    custom
                    className="sm-controll"
                    type="switch"
                    label="Prior"
                    name="coaType"
                    id="chkPrior"
                    value="Prior"
                    onChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ): void =>
                      handleParameterPayrollDataSoureIncome(
                        event.target,
                        "Prior"
                      )
                    }
                    checked={state.adjustedBudget === "Prior"}
                  />
                )}
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkDataSource1Variance",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="chkDataSource1Variance">
                <Form.Label className="sec-ttl ">Data Source 1</Form.Label>
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll"
                  label="Variance to Budget"
                  name="chkVarianceToBudget"
                  id="chkVarianceToBudget"
                  value="Variance to Budget"
                  ref={payRollDataSourcePeriodCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollChkDataSoure(
                      event.target,
                      "Variance to Budget"
                    )
                  }
                  checked={state.actual === "Variance to Budget"}
                />
                <Form.Check
                  type="switch"
                  custom
                  className="sm-controll"
                  label="Variance to Prior"
                  name="chkVarianceToPrior"
                  id="chkVarianceToPrior"
                  value="Variance to Prior"
                  ref={payRollDataSourceCheckBox}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void =>
                    handleParameterPayrollDataSoureIncome(
                      event.target,
                      "Variance to Prior"
                    )
                  }
                  checked={state.adjustedBudget === "Variance to Prior"}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkCalculatedColumn",
        control: (
          <>
            {((state.reportType !== "ByEmployee" &&
              state.IsdataSoureSelect2 === "$") ||
              controlshouldBeVisible("chkCalculatedColumnByDefault")) && (
                <Form.Group controlId="chkCalculatedColumn">
                  <Form.Label className="sec-ttl ">Calculated Column</Form.Label>
                  <Form.Check
                    type="switch"
                    //custom
                    className="sm-controll"
                    label="Average"
                    name="Average"
                    id="chkAverage"
                    value="Average"
                    ref={CalculatedColumnCheckBox}
                    onChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ): void =>
                      handleParameterCalculatedColumn(event.target, "Average")
                    }
                    checked={state.CalculatedStatus === "Average"}
                  />
                  <Form.Check
                    //custom
                    className="sm-controll"
                    type="switch"
                    label="Total"
                    name="Total"
                    id="chkTotal"
                    value="Total"
                    onChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ): void =>
                      handleParameterCalculatedColumn(event.target, "Total")
                    }
                    checked={state.CalculatedStatus === "Total"}
                  />
                </Form.Group>
              )}
          </>
        ),
      },
      {
        controlName: "chkComparePreYearActBud",
        control: (
          <>
            <Form.Group
              controlId="chkComparePreYearActBud"
              className="chkComparePreYearActBud"
            >
              <Form.Label className="sec-ttl">
                {"Additional Comparison"}
              </Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkComparePreYearActBud"
                checked={state.IsSalaried}
                label={"Compare to Previous Year Actual/Budget"}
                onChange={(e) =>
                  setLaborSummaryCheckBoxValue("IsAdditionalComparision", e)
                }
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkComparePreYearActFore",
        control: (
          <>
            <Form.Group
              controlId="chkComparePreYearActFore"
              className="chkComparePreYearActFore"
            >
              <Form.Label className="sec-ttl">
                {"Additional Comparison"}
              </Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkComparePreYearActFore"
                checked={state.IsSalaried}
                label={"Compare to Previous Year Actual/Forecast"}
                onChange={(e) =>
                  setLaborSummaryCheckBoxValue("IsAdditionalComparision", e)
                }
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkIncludeSalariedEmployees",
        control: (
          <>
            <Form.Group
              controlId="chkIsSalaried"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkIsSalaried"
                checked={state.IsSalaried}
                label={"Include Salaried Employees"}
                onChange={(e) => setLaborSummaryCheckBoxValue("IsSalaried", e)}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkIsExcludePayroll",
        control: (
          <>
            <Form.Group
              controlId="chkIsExcludePayroll"
              className="includeExcludeFromPayroll"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkIsExcludePayroll"
                checked={state.IsExcludePayroll}
                label={"Include Exclude From Payroll"}
                onChange={(e) =>
                  setLaborSummaryCheckBoxValue("IsExcludePayroll", e)
                }
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkVariance",
        control: (
          <>
            <Form.Group controlId="chkVariance" className="showVariance">
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkVariance"
                checked={state.IsVariance}
                label={"Show Variance"}
                onChange={(e) => setLaborSummaryCheckBoxValue("IsVariance", e)}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkDollars",
        control: (
          <>
            <Form.Group controlId="chkDollars" className="showDollars">
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkDollars"
                checked={state.IsDollars}
                label={"Show Dollars"}
                onChange={(e) => setLaborSummaryCheckBoxValue("IsDollars", e)}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkPageBreak",
        control: (
          <>
            {pageBreakControlDisplayCondition(state) && (
              //  ||
              // !state.ReportName?.toString()?.includes(
              //   "Employee Benefits Eligibility Report"
              // ))
              <Form.Group
                controlId="IsPageBreak"
                className="pageBreakAfterEachDepartment"
              >
                <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
                <Form.Check
                  custom
                  className="sm-controll rm-index"
                  type="switch"
                  name="PageBreakAfterEachDepartment"
                  checked={state.isPageBreak}
                  label={getPageBreakCheckBoxLablelNameBasedOnReport()}
                  onChange={handleParameterIsPagebreakIsCheck}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkShowZeroActualHours",
        control: (
          <>
            {pageBreakControlDisplayCondition(state) && (
              //  ||
              // !state.ReportName?.toString()?.includes(
              //   "Employee Benefits Eligibility Report"
              // ))
              <Form.Group
                controlId="chkShowZeroActualHours"
                className="includeSalariedEmployees"
              >
                <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
                <Form.Check
                  custom
                  className="sm-controll rm-index"
                  type="switch"
                  name="IsShowZeroActualHours"
                  checked={state.IsShowZeroActualHours}
                  label={"Show Positions with 0 Actual Hours"}
                  onChange={handleShowZeroActualHours}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "chkIncludeEnterpriseEmployees",
        control: (
          <>
            <Form.Group
              controlId="HRAnniversary"
              className="includeEnterpriseEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="IncludeEnterpriseEmployees"
                checked={state.isIncludeEnterpriseEmployees}
                label={"Include Enterprise Employees"}
                onChange={handleParameterChangeIsCheck}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkCompareActuals",
        control: (
          <>
            <Form.Group controlId="chkStatus">
              <Form.Label className="sec-ttl">Compare Actuals to</Form.Label>
              <Form.Check
                type="switch"
                custom
                className="sm-controll"
                label="Scheduled"
                name="ActualCompared"
                id="chkScheduled"
                value="Scheduled"
                onChange={(event: React.ChangeEvent<HTMLInputElement>): void =>
                  handleCompareActualChange("ActualCompared", "1")
                }
                checked={+state?.chkCompareActuals === 1}
              />
              <Form.Check
                custom
                className="sm-controll"
                type="switch"
                label="Budgeted"
                name="ActualCompared"
                id="chkBudgeted"
                value="Budgeted"
                onChange={(event: React.ChangeEvent<HTMLInputElement>): void =>
                  handleCompareActualChange("ActualCompared", "0")
                }
                defaultChecked
                checked={+state?.chkCompareActuals === 0}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkACACodes",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">
                ACA Codes{" "}
                <Form.Check
                  type="switch"
                  className="sm-controll rm-index"
                  ref={includeAllEmpCheckBox}
                  onChange={handleACACodeChange}
                  checked={state.isAcaCodes}
                  inline
                  id={`inline-42`}
                  label="Include all users with unassigned ACA Codes"
                />
              </Form.Label>
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkIsCompSet",
        control: (
          <>
            <Form.Group
              controlId="chkIsCompSet"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkIsCompSet"
                id={`inline-42`}
                label={"Include Comp Set"}
                onChange={handleIsCompSetChange}
                checked={state.isCompSet}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkIsIncludeDesc",
        control: (
          <>
            <Form.Group
              controlId="chkIsIncludeDesc"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl"></Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkIsIncludeDesc"
                id={`inline-42`}
                label={"Include Description"}
                onChange={handleIsIncludeDescChange}
                checked={state.isIncludeDesc}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkIncludeBudget",
        control: (
          <>
            <Form.Group
              controlId="chkIsSalaried"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkIsSalaried"
                id={`inline-42`}
                label={"Include Budget"}
                onChange={handleIncludeBudget}
                checked={state.isIncludeBudget}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkZeroActualValues",
        control: (
          <>
            <Form.Group
              controlId="chkIsSalaried"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkIsSalaried"
                id={`inline-43`}
                label={"Hide Rows with Zero Actual Values"}
                onChange={handleZeroActualValues}
                checked={state.isZeroActualValues}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkIncludeRevenue",
        control: (
          <>
            <Form.Group controlId="chkIsRevenue" className="includeRevenue">
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkIsRevenue"
                id={`inline-75`}
                label={"Include Revenue"}
                onChange={handleIncludeRevenue}
                checked={state.isIncludeRevenue}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkByCOA",
        control: (
          <>
            <Form.Group
              controlId="chkByCOA"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkByCOA"
                id={`inline-44`}
                label={"By COA"}
                onChange={handleCheckbyCOA}
                checked={state.IsCheckCOA}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkGeneralCode",
        control: (
          <>
            <Form.Group
              controlId="chkGeneralCode"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkGeneralCode"
                id={`inline-44`}
                label={"By COA / General Code"}
                onChange={handleGeneralCode}
                checked={state.IsGeneralCode}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkContractorExclude",
        control: (
          <>
            <Form.Group
              controlId="chkContractorExclude"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkContractorExclude"
                id={`inline-44`}
                label={"Include Contractor"}
                onChange={handleContractorExclude}
                checked={state.IsContractorExclude}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkHideStatistics",
        control: (
          <>
            <Form.Group
              controlId="chkHideStatistics"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkHideStatistics"
                id={`inline-45`}
                label={"Hide Statistics"}
                onChange={handleHideStatistics}
                checked={state.IsHideStatistics}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkIncludePendingInvoices",
        control: (
          <>
            <Form.Group
              controlId="chkIncludePendingInvoices"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl"></Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkIncludePendingInvoices"
                id={`inline-46`}
                label={"Include Pending Invoices"}
                onChange={handleIncludePendingInvoices}
                checked={state.IsIncludePendingInvoices}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkUnapprovedtransactions",
        control: (
          <>
            <Form.Group
              controlId="chkUnapprovedtransactions"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll"
                type="switch"
                name="chkUnapprovedtransactions"
                id={`inline-60`}
                label={"Unapproved transactions"}
                onChange={handleUnapprovedtransactions}
                checked={state.IsUnapprovedtransactions}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkIncludeCustomer",
        control: (
          <>
            <Form.Group
              controlId="chkIncludeCustomer"
            // className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl ">Format Option</Form.Label>
              <Form.Check
                custom
                className="sm-controll"
                type="switch"
                name="chkIncludeCustomer"
                id={`inline-61`}
                label={"Include Customer"}
                onChange={handleIncludeCustomer}
                checked={state.isIncludeCustomer}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkExClearedtransactions",
        control: (
          <>
            <Form.Group
              controlId="chkExClearedtransactions"
              className="includeBalance"
            >
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkExClearedtransactions"
                id={`inline-62`}
                label={"Exclude cleared transactions"}
                onChange={handleExClearedtransactions}
                checked={state.IsExClearedtransactions}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkBankBalance",
        control: (
          <>
            <Form.Group controlId="chkBankBalance" className="includeBalance">
              <Form.Label className="sec-ttl ">Layout Design</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkBankBalance"
                id={`inline-61`}
                label={"Bank Balances Only"}
                onChange={handleBankBalanceValues}
                checked={state.isBankBalanceValues}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkSummayOnly",
        control: (
          <>
            <Form.Group controlId="chkSummayOnly" className="includeBalance">
              <Form.Label className="sec-ttl ">Layout Design</Form.Label>
              <Form.Check
                custom
                className="sm-controll rm-index"
                type="switch"
                name="chkSummayOnly"
                id={`inline-62`}
                label={"Show Summary Only"}
                onChange={handleShowSummaryValues}
                checked={state.isShowSummayValues}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkShowCombinedOnly",
        control: (
          <>
            <Form.Group
              controlId="chkShowCombinedOnly"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll"
                type="switch"
                name="chkShowCombinedOnly"
                id={`inline-63`}
                label={"Show Combined Only"}
                onChange={handleShowCombinedValues}
                checked={state.isShowCombinedValues}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkGroupBankAccountsByType",
        control: (
          <>
            <Form.Group
              controlId="chkGroupBankAccountsByType"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll"
                type="switch"
                name="chkGroupBankAccountsByType"
                id={`inline-64`}
                label={"Group Bank Accounts by Type"}
                onChange={handleGrpBankAccountsValues}
                checked={state.isGrpBankAccByTypeValues}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkGroupCCAccounts",
        control: (
          <>
            <Form.Group
              controlId="chkGroupCCAccounts"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll"
                type="switch"
                name="chkGroupCCAccounts"
                id={`inline-65`}
                label={"Group CC Accounts"}
                onChange={handleGrpCCAccountsValues}
                checked={state.isGrpCCAccountsValues}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "chkNonWorkingHoursAndwages",
        control: (
          <>
            <Form.Group
              controlId="chkNonWorkingHoursAndwages"
              className="includeSalariedEmployees"
            >
              <Form.Label className="sec-ttl">{/* COA Type */}</Form.Label>
              <Form.Check
                custom
                className="sm-controll"
                type="switch"
                name="chkNonWorkingHoursAndwages"
                id={`inline-65`}
                label={"show non-working hours and wages"}
                onChange={handleNonWorkingHoursAndwages}
                checked={state.showNonWorkingHoursAndwages}
              />
            </Form.Group>
          </>
        ),
      },
    ];
  };

  const buildFilterControls = (savedParameters: IParameterSelectionState) => {
    htmlControls = [
      ...getSwitchButtonControls(savedParameters),
      ...getTextBoxControls(savedParameters),
      ...getDropDownControls(savedParameters),
    ];
  };

  const getDateRangePickerNormal = (state) => {
    return (
      <>
        <div className="dateRangeContainer d-flex align-items-center">
          <DateRangePicker
            initialSettings={{
              showDropdowns: true,
              singleDatePicker: true,
              autoUpdateInput: false,
              autoApply: true,
              maxDate: moment().add(10, "years").format("MM/DD/YY"),
              minDate: moment().add(-30, "years").format("MM/DD/YY"),
            }}
            onApply={(e: any, picker: any) => {
              const value = picker.startDate.format("MM/DD/YY");
              handleDatesChange(value, "StartDate");
            }}
          >
            {!state.startDate ? (
              <input
                type="text"
                placeholder="MM/DD/YY"
                value={""}
                className=""
                name={"reportStartDate" + props?.reportData?.reportName}
                autoComplete="off"
              />
            ) : (
              <input
                type="text"
                value={state.startDate}
                name={"reportStartDate" + props?.reportData?.reportName}
                autoComplete={"off"}
                className=""
              />
            )}
          </DateRangePicker>

          <span>-</span>
          <DateRangePicker
            initialSettings={{
              showDropdowns: true,
              singleDatePicker: true,
              autoUpdateInput: false,
              autoApply: true,
              minDate: moment().add(-30, "years").format("MM/DD/YY"), //state.startDate.length>0 ? state.startDate : moment().add(-10, 'years').format("MM/DD/YY"),
              maxDate: moment().add(10, "years").format("MM/DD/YY"),
            }}
            onApply={(e: any, picker: any) => {
              const value = picker.startDate.format("MM/DD/YY");
              handleDatesChange(value, "EndDate");
            }}
          >
            {!state.endDate ? (
              <input
                type="text"
                placeholder="MM/DD/YY"
                value={""}
                className=""
                name={"reportEndDate" + props?.reportData?.reportName}
                autoComplete="off"
              />
            ) : (
              <input
                type="text"
                value={state.endDate}
                name={"reportEndDate" + props?.reportData?.reportName}
                autoComplete="off"
                className=""
              />
            )}
          </DateRangePicker>
        </div>
      </>
    );
  };

  const getDateRangePickerNormal2 = (state) => {
    return (
      <>
        <div className="dateRangeContainer d-flex align-items-center">
          <DateRangePicker
            initialSettings={{
              drops: "auto",
              showDropdowns: true,
              singleDatePicker: true,
              autoUpdateInput: false,
              autoApply: true,
              maxDate: moment().add(10, "years").format("MM/DD/YY"),
              minDate: moment().add(-10, "years").format("MM/DD/YY"),
            }}
            onApply={(e: any, picker: any) => {
              const value = picker.startDate.format("MM/DD/YY");
              handleDatesChange2(value, "isVendorReportDateF");
            }}
          >
            {!state.isVendorReportDateF ? (
              <input
                type="text"
                placeholder="MM/DD/YY"
                value={""}
                className=""
                name={"isVendorReportDateF" + props?.reportData?.reportName}
                autoComplete="off"
              />
            ) : (
              <input
                type="text"
                value={state.isVendorReportDateF}
                name={"isVendorReportDateF" + props?.reportData?.reportName}
                autoComplete="off"
                className=""
              />
            )}
          </DateRangePicker>

          <span>-</span>
          <DateRangePicker
            initialSettings={{
              drops: "auto",
              showDropdowns: true,
              singleDatePicker: true,
              autoUpdateInput: false,
              autoApply: true,
              minDate: moment().add(-10, "years").format("MM/DD/YY"),
              maxDate: moment().add(10, "years").format("MM/DD/YY"),
            }}
            onApply={(e: any, picker: any) => {
              const value = picker.endDate.format("MM/DD/YY");
              handleDatesChange2(value, "isVendorReportDateT");
            }}
          >
            {!state.isVendorReportDateT ? (
              <input
                type="text"
                placeholder="MM/DD/YY"
                value={""}
                className=""
                name={"isVendorReportDateT" + props?.reportData?.reportName}
                autoComplete="off"
              />
            ) : (
              <input
                type="text"
                value={state.isVendorReportDateT}
                name={"isVendorReportDateT" + props?.reportData?.reportName}
                autoComplete="off"
                className=""
              />
            )}
          </DateRangePicker>
        </div>
      </>
    );
  };

  const getDateRangePickerForPayPeriod = (state) => {
    return (
      <>
        <div className="dateRangeContainer d-flex align-items-center">
          {state.lastDateOfPayPeriodWeekOfHotel && (
            <DateRangePicker
              initialSettings={{
                showDropdowns: true,
                singleDatePicker: true,
                autoUpdateInput: false,
                autoApply: true,
                maxDate: state.lastDateOfPayPeriodWeekOfHotel,
              }}
              onApply={(e: any, picker: any) => {
                const value = picker.startDate.format("MM/DD/YY");
                handleDatesChange(value, "StartDate");
              }}
            >
              {!state.startDate ? (
                <input
                  type="text"
                  placeholder="MM/DD/YY"
                  value={""}
                  name={"reportStartDate" + props?.reportData?.reportName}
                  className=""
                  autoComplete="off"
                />
              ) : (
                <input type="text" value={state.startDate} className="" />
              )}
            </DateRangePicker>
          )}
          {state.lastDateOfPayPeriodWeekOfHotel && <span>-</span>}

          {state.lastDateOfPayPeriodWeekOfHotel && (
            <DateRangePicker
              initialSettings={{
                showDropdowns: true,
                singleDatePicker: true,
                autoUpdateInput: false,
                autoApply: true,
                maxDate: state.lastDateOfPayPeriodWeekOfHotel,
                // minDate: state.startDate,
              }}
              onApply={(e: any, picker: any) => {
                const value = picker.startDate.format("MM/DD/YY");
                handleDatesChange(value, "EndDate");
              }}
            >
              {!state.endDate ? (
                <input
                  name={"reportendDate" + props?.reportData?.reportName}
                  type="text"
                  placeholder="MM/DD/YY"
                  value={""}
                  className=""
                  autoComplete="off"
                />
              ) : (
                <input type="text" value={state.endDate} className="" />
              )}
            </DateRangePicker>
          )}
        </div>
      </>
    );
  };

  const getTextBoxControls = (state: IParameterSelectionState): any[] => {
    let defaultDate: any = new Date();
    if (JSON.parse(localStorage.storage).currentUtcTime !== "") {
      defaultDate = new Date(JSON.parse(localStorage.storage).currentUtcTime);
    }
    defaultDate = moment(defaultDate).format("MM/DD/YY");

    if (props.reportData.moduleReportId === 2144 && !state.startDate) {
      state.startDate = defaultDate;
      let newVaribaleDate = new Date(defaultDate);
      let tempYear = newVaribaleDate.getFullYear()?.toString()?.substr(2, 2);
      let tempDate = newVaribaleDate.getDate();
      let tempMonth = newVaribaleDate.getMonth() + 1;
      let finalDate =
        tempMonth.toString().padStart(2, "0") +
        "/" +
        tempDate.toString().padStart(2, "0") +
        "/" +
        tempYear;
      setNewParameterValue("StartDate", finalDate);
    }

    return [
      {
        controlName: "txtDate",
        control: (
          <>
            {state.dateLayOutSelector !== 2 && (
              <Form.Group controlId="date" className="datePicker">
                <Form.Label className="sec-ttl">Date</Form.Label>
                <DateRangePicker
                  initialSettings={{
                    showDropdowns: true,
                    singleDatePicker: true,
                    autoUpdateInput: false,
                    autoApply: true,
                    startDate: state.startDate ? state.startDate : defaultDate,
                    maxDate: moment().add(10, "years").format("MM/DD/YY"),
                    minDate: moment().add(-30, "years").format("MM/DD/YY"),
                  }}
                  onApply={(e: any, picker: any) => {
                    const value = picker.startDate.format("MM/DD/YY");
                    handleDatesChange(value, "StartDate");
                  }}
                >
                  {!state.startDate ? (
                    <input
                      type="text"
                      placeholder="MM/DD/YY"
                      name={"reportStartDate" + props?.reportData?.reportName}
                      autoComplete="off"
                      value={
                        props.reportData.moduleReportId === 2144
                          ? defaultDate
                          : ""
                      }
                      className="form-control"
                    />
                  ) : (
                    <input
                      type="text"
                      autoComplete="off"
                      name={"reportStartDate" + props?.reportData?.reportName}
                      value={state.startDate}
                      className="form-control single-date-pick"
                    />
                  )}
                </DateRangePicker>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                  <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                </svg>
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "txtDateRange",
        control: (
          <>
            {" "}
            {state.dateLayOutSelector !== 1 &&
              state.reportType !== "ByEmployee" && (
                <Form.Group
                  controlId="excessivePtoHours"
                  className="dateRangePicker"
                >
                  <Form.Label className="sec-ttl">
                    {props?.reportData?.moduleReportId === 2161
                      ? "Payment Submission Date Range"
                      : "Date Range"}
                  </Form.Label>
                  {controlshouldBeVisible("showDateRangeAsPerPayPeriod")
                    ? getDateRangePickerForPayPeriod(state)
                    : getDateRangePickerNormal(state)}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                    <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                  </svg>
                </Form.Group>
              )}
          </>
        ),
      },
      {
        controlName: "txtExpireStatusCtrl",
        control: (
          <Form.Group controlId="ExpireStatus" className="dateRangePicker">
            <Form.Label className="sec-ttl">Expire in</Form.Label>
            <ExpireStatus
              defaultValue={state.expireStatus}
              handleExpireStauts={handleExpireStauts}
            />
          </Form.Group>
        ),
      },
      {
        controlName: "txtDocumentType",
        control: (
          <Form.Group controlId="DocumentType" className="dateRangePicker">
            <Form.Label className="sec-ttl">Document Type</Form.Label>
            <MultiSelectDocType
              defaultValue={state.multiDocs}
              handleMultiDocType={handleMultiDocType}
            />
          </Form.Group>
        ),
      },
      {
        controlName: "txtMultiVendor",
        control: (
          <Form.Group controlId="MultiVendor" className="dateRangePicker">
            <Form.Label className="sec-ttl">
              Vendor(<span className="text-lowercase">s</span>)
            </Form.Label>
            <MultiSelectVendorControl
              defaultValue={state.multiSelectVendor}
              ref={vendorControlRef}
              {...state}
              multiSelectVendor={multiSelectVendor}
            />
          </Form.Group>
        ),
      },
      {
        controlName: "txtEpayStatusCtrl",
        control: (
          <Form.Group controlId="EpayStatusCtrl" className="dateRangePicker">
            <Form.Label className="sec-ttl">Status</Form.Label>
            <EpayStatus
              defaultValue={state.ePayStatus}
              handleEpayStatus={handleEpayStatus}
            />
          </Form.Group>
        ),
      },
      {
        controlName: "txtAmountControl",
        control: (
          <Form.Group controlId="">
            {(props?.reportData?.moduleReportId === 2131 ||
              props?.reportData?.moduleReportId === 2136) && (
                <>
                  <Form.Label className="sec-ttl">
                    Transaction Totals Exceeding{" "}
                  </Form.Label>
                </>
              )}
            <Form.Group
              controlId="CtrlAmount"
              className="txtCtrlInput dollarBox"
            >
              <Form.Label className="sec-ttl">Amount</Form.Label>
              <AmountControl
                ref={amountControlRef}
                defaultValue={state.amountVal}
                handleAmountVal={handleAmountVal}
              />
            </Form.Group>
          </Form.Group>
        ),
      },
      {
        controlName: "txtgenerate1096ValCtrl",
        control: (
          <Form.Group
            controlId="ctrlGenerate1096"
            className="txtGenerate1096Ctrl"
          >
            <Generate1096Ctrl
              defaultValue={state.generate1096Val}
              handleGenerate1096={handleGenerate1096}
            />
          </Form.Group>
        ),
      },
      {
        controlName: "txtDateStartingAndThruControl",
        control: (
          <Form.Group
            controlId="ctrlAccountingPeriodST"
            className="dateRangePicker"
          >
            <Form.Label className="sec-ttl">
              {props?.reportData?.moduleReportId === 2136
                ? "Accounting Periods"
                : "Date Range"}
            </Form.Label>
            {getDateRangePickerNormal2(state)}
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
              <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
            </svg>
          </Form.Group>
        ),
      },
      {
        controlName: "txtAvgHoursWorked",
        control: (
          <>
            <Form.Group controlId="" className="numPicker">
              <Form.Label className="sec-ttl">
                Average Hours Worked (Equal or Greater than - In Hours)
              </Form.Label>
              <Form.Control //custom
                type="number"
                min="0"
                autoComplete="off"
                onInput={(e) => {
                  let value: any = e.currentTarget.value;
                  value = value?.toString().includes("-") ? null : value;
                }}
                value={state.avgHours}
                onChange={handleAvgHoursChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "txtHireDate",
        control: (
          <>
            <Form.Group controlId="" className="numPicker">
              <Form.Label className="sec-ttl">
                Hire Date (Greater than - In Days)
              </Form.Label>
              <Form.Control //custom
                type="number"
                min="0"
                onInput={(e) => {
                  let value: any = e.currentTarget.value;
                  value = value?.toString().includes("-") ? null : value;
                }}
                value={state.hireDate}
                name={"txtsdshireDate" + props?.reportData?.reportName}
                autoComplete="off"
                onChange={handleHireDateChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "txtFileSize",
        control: (
          <>
            <Form.Group controlId="" className="numPicker">
              <Form.Label
                className="sec-ttl"
                style={{ textTransform: "unset" }}
              >
                Show File Sizes Larger than
              </Form.Label>
              <div className="d-flex align-items-center">
                <Form.Control
                  type="number"
                  min="0"
                  autoComplete="off"
                  pattern="[+-]?\d+(?:[.,]\d+)?"
                  value={state.fileSize}
                  maxLength={6}
                  style={{ fontSize: "larger", width: "200px" }}
                  placeholder="Enter file size"
                  name="fileSize"
                  onChange={handleFileSizeChange}
                />
                <span className="ml-2">(MB)</span>
              </div>
            </Form.Group>
          </>
        ),
      },
    ];
  };

  const skipHotelFormatOptions = (): any[] => {
    // Daily Flash Report Version 3
    if (props.reportData.moduleReportId == 2008) {
      return ["3"];
    }
    return [];
  };

  const getDropDownControls = (state: IParameterSelectionState): any[] => {
    return [
      {
        controlName: "ddlHoursFormat",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">{"Total"}</Form.Label>
              <TotalFormat
                defaultValue={state.hoursFormat}
                onFormatTypeChange={onFormatTypeChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlAccountingYears",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Select Year</Form.Label>
              <YearSelector
                defaultValue={state.accountingYear}
                onYearChange={handleAccountingYearChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlCurrentYears",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Current Year</Form.Label>
              <YearSelector
                ReportId={props.reportData.moduleReportId}
                type="current"
                defaultValue={state.currentYear}
                onYearChange={handleCurrentYearChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlcomparisonYears",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl" style={{ textTransform: "none" }}>
                Year for Comparison
              </Form.Label>
              <YearSelector
                ReportId={props.reportData.moduleReportId}
                type="comparison"
                defaultValue={state.comparisonYear}
                onYearChange={handleComparisonYearChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlaccPeriodMonth",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Accounting Period</Form.Label>
              <YearSelectorAccPeriod
                defaultValue={state.accPeriodMonth}
                onYearChange={handleAccPeriodMonth}
              />
              <p style={{ marginTop: "-20px", fontFamily: "OpenSans" }}>
                [the report will include YTD data through the selected
                accounting period]
              </p>
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlEmployee",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Select Employee</Form.Label>
              <LaborEmployeeSelector
                hotelIds={state.hotelIds}
                status={state.status}
                ref={employeeDDLRef}
                defaultValue={state.employee}
                onLaborEmployeeChange={handleEmployeeChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlBankAccount",
        control: (
          <>
            {state.hotelIds.length > 0 && (
              <>
                {state.hotelIds?.split(",").length === 1 && (
                  <Form.Group controlId="">
                    <Form.Label className="sec-ttl">Bank Account</Form.Label>
                    <BankAccountSelector
                      hotelIds={state.hotelIds}
                      status={state.status}
                      defaultValue={state.BankAccount}
                      reportName={props.reportData.reportName}
                      onBankAccountChange={handleBankAccountChange}
                    />
                  </Form.Group>
                )}
              </>
            )}
          </>
        ),
      },
      {
        controlName: "ddlBankAccountMulti",
        control: (
          <>
            {state.hotelIds !== "" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">Bank Account</Form.Label>
                <Row>
                  <Col className="ehid-picker" sm="12">
                    <MultiBankAccountSelector
                      hotelIds={state.hotelIds}
                      defaultValue={state.BankAccount}
                      custom
                      handlebankACCChange={handlebankACCChange}
                      ref={employeeDDLRef}
                    />
                  </Col>
                </Row>
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlLaborSummarySubType",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Labor Summary SubType</Form.Label>
              <>
                <LaborSummarySubTypeSelector
                  defaultValue={state.laborSummarySubType}
                  onSummarySubTypeChange={onSummarySubTypeChange}
                />
                {/* <br></br>{" "} */}
              </>
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "ddlDepartmentMulti",
        control: (
          <>
            <Form.Group controlId="departmentSelector">
              <Form.Label className="sec-ttl">Department</Form.Label>
              <Row>
                <Col>
                  <DepartmentSelector
                    defaultValue={state?.departmentIds}
                    handleDepartmentChange={handleDepartmentChange}
                  />
                </Col>
              </Row>
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlDepartmentSingle",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Departments</Form.Label>
              <SingleAllDepartmentSelect
                defaultValue={state?.departmentIds}
                isCopyBudgetId={handleSelectAllSingleDepartments}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "txtAutoEmployee",
        control: (
          <>
            {state.reportType !== "ByEHID" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">Employee </Form.Label>
                {state.loadEmployee ? (
                  <></>
                ) : (
                  <EmployeeAutoSelector
                    status={state.statusString}
                    reportid={props.reportData.moduleReportId}
                    defaultValue={state.employee}
                    onEmployeeChange={handleEmployeeChange}
                  />
                )}
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlReportGroup",
        control: (
          <>
            {state.reportType !== "ByEmployee" &&
              state.dateLayOutSelector !== 2 && (
                <Form.Group
                  controlId="ddlReportGroup"
                  className="reportGrpSelector single-select-dropdown-right-Important"
                  onClick={(e) => {
                    setTimeout(() => {
                      frmSectionRef.current.scrollTop =
                        frmSectionRef.current.scrollHeight;
                    });
                  }}
                >
                  <Form.Label className="sec-ttl">Group</Form.Label>
                  <ReportGroupSelector
                    reportid={props.reportData.moduleReportId}
                    defaultValue={state.subGroupSelectValue}
                    defaultValueId={getNewParameterValueByName(
                      "OwnershipIDorGroupid"
                    )}
                    reportGroups={reportData.hasGroup}
                    notIncludeEnterpriseAccounts={controlshouldBeVisible(
                      "notIncludeEnterpriseAccounts"
                    )}
                    showOnlyHotelAccounts={controlshouldBeVisible(
                      "showOnlyHotelAccounts"
                    )}
                    isAll={controlshouldBeVisible("showAllHotels")}
                    handleReportGroupChange={handleReportGroupChange}
                    payrollSubscriptionRequired={
                      reportData?.payrollSubscriptionRequired
                    }
                  />
                </Form.Group>
              )}
          </>
        ),
      },

      {
        controlName: "ddlMultiReportGroup",
        control: (
          <>
            {state.reportType !== "ByEmployee" &&
              state.dateLayOutSelector !== 2 && (
                <Form.Group
                  controlId="ddlMultiReportGroup"
                  className="reportGrpSelector single-select-dropdown-right-Important"
                >
                  <Form.Label className="sec-ttl">Groups </Form.Label>
                  <Row>
                    <Col className="ehid-picker" sm="12">
                      <ReportGroupBrandSelector
                        defaultValue={state.subGroupSelectValue}
                        selectedItems={state.subGroupSelectedList}
                        reportGroups={reportData.hasGroup}
                        resetMultiGroup={state?.resetMultiGroup}
                        resetGroupHid={state?.resetGroupHid}
                        resetGroupID={state?.resetGroupID}
                        notIncludeEnterpriseAccounts={controlshouldBeVisible(
                          "notIncludeEnterpriseAccounts"
                        )}
                        showOnlyHotelAccounts={controlshouldBeVisible(
                          "showOnlyHotelAccounts"
                        )}
                        ref={buisnessAccountRef}
                        isAll={controlshouldBeVisible("showAllHotels")}
                        handleMultiReportGroupChange={
                          handleMultiReportGroupChange
                        }
                        checkGroupSelected={checkGroupSelected}
                        payrollSubscriptionRequired={
                          reportData?.payrollSubscriptionRequired
                        }
                        isMultiGroupAndMultiAccountSynced={controlshouldBeVisible(
                          "isMultiGroupAndMultiAccountSynced"
                        )}
                      />
                    </Col>
                  </Row>
                </Form.Group>
              )}
          </>
        ),
      },

      {
        controlName: "ddlPeriorYear",
        control: (
          <>
            {state.reportType !== "ByEmployee" &&
              state.IsPrayerYear === "Prior" && (
                <Form.Group controlId="">
                  <Form.Label className="sec-ttl">Prior Year</Form.Label>
                  <PeriorYearSelect
                    reportid={props.reportData.moduleReportId}
                    startvalue={"PriorYear"}
                    defaultValue={state.defaultYear}
                    paramterValue={props?.paramterValue}
                    handlePeriorYear={handlePeriorYear}
                  />
                </Form.Group>
              )}
          </>
        ),
      },
      {
        controlName: "ddlAccountingStart",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Accounting Period</Form.Label>
              <Form.Group controlId="">
                {props.reportData.moduleReportId !== 2078 &&
                  props.reportData.moduleReportId !== 2123 &&
                  props.reportData.moduleReportId !== 2201 &&
                  props.reportData.moduleReportId !== 2158 &&
                  props.reportData.moduleReportId !== 2221 &&
                  props.reportData.moduleReportId !== 2180 &&
                  props.reportData.moduleReportId !== 2224 &&
                  props.reportData.moduleReportId !== 2200 &&
                  props.reportData.moduleReportId !== 2232 &&
                  props.reportData.moduleReportId !== 2185 &&
                  props.reportData.moduleReportId !== 2229 &&
                  props.reportData.moduleReportId !== 2239 ? (
                  <Form.Label className="sec-ttl">
                    {props.reportData.uniqueReportId === 2044 ? "" : "Starting"}
                  </Form.Label>
                ) : null}
                <AccotingPeriodSector
                  defaultValue={state.accountsPeriodSelectStart}
                  reportid={props.reportData.moduleReportId}
                  startvalue={"Start"}
                  handleAccotingSelector={handleAccotingSelector}
                />
              </Form.Group>
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlAccountingPeriodEnd",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">
                {props.reportData.moduleReportId === 2166 ||
                  props.reportData.moduleReportId === 2167 ||
                  props.reportData.moduleReportId === 2168
                  ? "Accounting Period"
                  : "Thru"}
              </Form.Label>
              <AccountingPeriodEndSector
                reportid={props.reportData.moduleReportId}
                startvalue={"End"}
                defaultValue={state.serverDateTime} //{state.hotelIds}
                paramterValue={props?.paramterValue}
                handleAccotingSelectorEnd={handleAccotingSelectorEnd}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlChartNofrom",
        control: (
          <>
            {state.coAaccountType === "3" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">Account From</Form.Label>
                <COASelector
                  defaultValue={state.hotelIds}
                  handleCOAAccountSelector={handleCOAAccountSelector}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlAgingSelect",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Aging</Form.Label>
              <AgingSelector
                reportid={props.reportData.moduleReportId}
                defaultValue={state.IsAgingSelect}
                onAgingSelectChange={handleAgingSelectChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlChartNoTo",
        control: (
          <>
            {state.coAaccountType === "3" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">Account To</Form.Label>
                <AccountTOSelector
                  defaultValue={state.hotelIds}
                  handleCOAAccountSelectortow={handleCOAAccountSelectortow}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlChartNofrom",
        control: (
          <>
            {state.coAaccountType === "2" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl"></Form.Label>
                <SelectSingleCOA
                  defaultValue={state.hotelIds}
                  handleSingleCoaSelect={handleSingleCoaSelect}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlHotelSingle",
        control: (
          <>
            {state.reportType !== "ByEmployee" &&
              (state.isLayOutSelector
                ? state.dateLayOutSelector === 2
                  ? true
                  : false
                : true) && (
                <Form.Group
                  controlId=""
                  className="single-select-dropdown-right-Important"
                >
                  <Form.Label className="sec-ttl">Accounts</Form.Label>
                  <SelectAccount
                    defaultValue={state.hotelIds}
                    isAll={controlshouldBeVisible("showAllHotels")}
                    notIncludeEnterpriseAccounts={controlshouldBeVisible(
                      "notIncludeEnterpriseAccounts"
                    )}
                    showOnlyHotelAccounts={controlshouldBeVisible(
                      "showOnlyHotelAccounts"
                    )}
                    handleSingleBusinessAccountChange={
                      handleSingleBusinessAccountChange
                    }
                    rdlcName={reportData.rdlcName}
                    reportMasterId={reportData.reportMasterId}
                    moduleReportId={reportData.moduleReportId}
                    payrollSubscriptionRequired={
                      reportData?.payrollSubscriptionRequired
                    }
                  />
                </Form.Group>
              )}
          </>
        ),
      },
      {
        controlName: "ddlHotelMulti",
        control: (
          <>
            {state.reportType !== "ByEmployee" &&
              (state.isLayOutSelector
                ? state.dateLayOutSelector === 1
                  ? true
                  : false
                : true) && (
                <Form.Group controlId="BusinessAccountSelector">
                  <Form.Label className="sec-ttl">Accounts</Form.Label>
                  <Row>
                    <Col className="ehid-picker" sm="12">
                      <BusinessAccountSelector
                        defaultValue={state.hotelIds}
                        notIncludeEnterpriseAccounts={controlshouldBeVisible(
                          "notIncludeEnterpriseAccounts"
                        )}
                        showOnlyHotelAccounts={controlshouldBeVisible(
                          "showOnlyHotelAccounts"
                        )}
                        isAll={controlshouldBeVisible("showAllHotels")}
                        custom
                        ref={buisnessAccountRef}
                        multigroupList={state?.multigroupList}
                        selectedGroupList={state?.selectedGroupList}
                        // isDisabled=//{isBuisnessDisabeled} this is not used
                        handleBusinessAccountChange={
                          handleBusinessAccountChange
                        }
                        moduleReportId={reportData.moduleReportId}
                        payrollSubscriptionRequired={
                          reportData?.payrollSubscriptionRequired
                        }
                        isMultiGroupAndMultiAccountSynced={controlshouldBeVisible(
                          "isMultiGroupAndMultiAccountSynced"
                        )}
                      />
                    </Col>
                  </Row>
                </Form.Group>
              )}
          </>
        ),
      },
      {
        controlName: "ddlHotelMultiLimit",
        control: (
          <>
            {state.reportType !== "ByEmployee" &&
              (state.isLayOutSelector
                ? state.dateLayOutSelector === 1
                  ? true
                  : false
                : true) && (
                <Form.Group controlId="BussinessAccountSelectorMaxLimit">
                  <Form.Label className="sec-ttl">Accounts</Form.Label>
                  <Row>
                    <Col className="ehid-picker" sm="12">
                      <BussinessAccountSelectorMaxLimit
                        defaultValue={state.hotelIds}
                        notIncludeEnterpriseAccounts={controlshouldBeVisible(
                          "notIncludeEnterpriseAccounts"
                        )}
                        showOnlyHotelAccounts={controlshouldBeVisible(
                          "showOnlyHotelAccounts"
                        )}
                        isAll={controlshouldBeVisible("showAllHotels")}
                        custom
                        ref={buisnessAccountRef}
                        multigroupList={state?.multigroupList}
                        selectedGroupList={state?.selectedGroupList}
                        // isDisabled=//{isBuisnessDisabeled} this is not used
                        handleBusinessAccountChange={
                          handleBusinessAccountChange
                        }
                        moduleReportId={reportData.moduleReportId}
                        payrollSubscriptionRequired={
                          reportData?.payrollSubscriptionRequired
                        }
                      />
                    </Col>
                  </Row>
                </Form.Group>
              )}
          </>
        ),
      },
      {
        controlName: "ddlMultiHotelsByPositivePay",
        control: (
          <>
            {state.reportType !== "ByEmployee" &&
              state.PayFileFormatId !== -1 &&
              state.isAccountEmpty && (
                <Form.Group controlId="MultiHotelsByPositivePay">
                  <Form.Label className="sec-ttl">Accounts</Form.Label>
                  <Row>
                    <Col className="ehid-picker" sm="12">
                      <MultiHotelsByPositivePay
                        defaultValue={state.hotelIds}
                        PayFileFormatId={state.PayFileFormatId}
                        notIncludeEnterpriseAccounts={controlshouldBeVisible(
                          "notIncludeEnterpriseAccounts"
                        )}
                        showOnlyHotelAccounts={controlshouldBeVisible(
                          "showOnlyHotelAccounts"
                        )}
                        isAll={controlshouldBeVisible("showAllHotels")}
                        custom
                        ref={buisnessAccountRef}
                        handleBusinessAccountChange={
                          handleBusinessAccountChange
                        }
                      />
                    </Col>
                  </Row>
                </Form.Group>
              )}
          </>
        ),
      },
      {
        controlName: "ddlDataSource",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Data Source 1</Form.Label>
              <DataSourceOperating
                reportid={props.reportData.moduleReportId}
                defaultValue={state.IsdataSoureSelect}
                onDataSourceOperating={onDataSourceOperating}
                label={"Data Source"}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlDataSource1Periods",
        control: (
          <>
            <Form.Group
              controlId=""
              onClick={(e) => {
                setTimeout(() => {
                  frmSectionRef.current.scrollTop =
                    frmSectionRef.current.scrollHeight;
                });
              }}
            >
              <Form.Label className="sec-ttl">Data Source 1</Form.Label>
              <DataSource1Periods
                reportid={props.reportData.moduleReportId}
                defaultValue={state.IsdataSoureSelect}
                onDataSourceOperating={onDataSourcePeriods}
                label={"Data Source"}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlDataSource1",
        control: (
          <>
            <Form.Group
              controlId=""
              onClick={(e) => {
                setTimeout(() => {
                  frmSectionRef.current.scrollTop =
                    frmSectionRef.current.scrollHeight;
                });
              }}
            >
              <Form.Label className="sec-ttl">Data Source 1</Form.Label>
              <DataSourceSelector
                reportid={props.reportData.moduleReportId}
                defaultValue={state.IsdataSoureSelect}
                onDataSourceChange={handleDataSourceChang}
                label={"Data Source"}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlDataSource2",
        control: (
          <>
            <Form.Group
              controlId=""
              onClick={(e) => {
                setTimeout(() => {
                  frmSectionRef.current.scrollTop =
                    frmSectionRef.current.scrollHeight;
                });
              }}
            >
              <Form.Label className="sec-ttl">Data Source 2</Form.Label>
              <DataSource2Selectore
                reportid={props.reportData.uniqueReportId}
                defaultValue={state.IsdataSoureSelect2}
                onDataSourceChange2={handleDataSource2Chang}
                label={"Data Source"}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlDataSource2Periods",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">{
                (props.reportData.moduleReportId === 2198 ||
                  props.reportData.moduleReportId === 2230 ||
                  props.reportData.moduleReportId === 2199 ||
                  props.reportData.moduleReportId === 2231 ||
                  props.reportData.moduleReportId === 2200 ||
                  props.reportData.moduleReportId === 2232)
                  ? "Data Source 1" : "Data Source 2"}</Form.Label>
              <DataSource2Periods
                reportid={props.reportData.moduleReportId}
                defaultValue={state.IsdataSoureSelect2}
                onDataSourceChange2={handleDataSource2ChangPeriods}
                label={"Data Source"}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlCheckRegister",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Report</Form.Label>
              <PaymentRegisterSelector
                defaultValue={state.ReportName}
                onReportTypeChange={handleReportChange}
              />
              <span>{state.Reportdesc}</span>
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlPositivePayType",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Positive Pay Format</Form.Label>
              <PositivePaySelector
                defaultValue={state.PayFileFormat}
                onPositivePayChange={handlePositivePayChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlACACoverageCodes",
        control: (
          <>
            <ACACodeSelector
              accTypeID={1}
              defaultValue={state.acaCoverageCodes}
              onCoverageCodesChange={handleACACoverageCodesChange}
              label={"ACA Coverage Codes"}
            />
          </>
        ),
      },
      {
        controlName: "ddlACAHarborCodes",
        control: (
          <>
            <ACACodeSelector
              defaultValue={state.acaACASHarborCodes}
              onSaferCodesChange={handleACASaferCodesChange}
              accTypeID={2}
              label={"ACA Safe Harbor Codes"}
            />
          </>
        ),
      },
      {
        controlName: "ddlLookBackPeriod",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">
                Look Back Period (For calculating Average Hours Worked)
              </Form.Label>
              <LookBackPeriodSelector
                defaultValue={state.lookBackPeriod}
                onLookBackPeriodChange={handleLookBackPeriodChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlScheduleReportSortBy",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Sort by the following</Form.Label>
              <ScheduleReportSortSelector
                defaultValue={state.scheduleReportSortBy}
                handleReportSortSelectorChange={handleReportSortSelectorChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlHireDateSortBy",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Sort by Hire Date</Form.Label>
              <HireDateSortSelector
                defaultValue={state.hireDateSortBy}
                handleReportSortSelectorChange={
                  handleHireDateSortSelectorChange
                }
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "ddlEmployeeWageNewReportSortByReportSortBy",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Sort by the following</Form.Label>
              <EmployeeWageHoursExtendedReportSortSelector
                defaultValue={state.employeeWageNewReportSortBy}
                handleEmployeeWageExtendedReportSortSelectorChange={
                  handleEmployeeWageExtendedReportSortSelectorChange
                }
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "ddlEmployementType",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Employment Type</Form.Label>
              <EmployementTypeSelector
                defaultValue={state.employementType}
                onEmpTypeChange={handleEmployementTypeChange}
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "ddlReportType",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Report Type</Form.Label>
              <ReportTypeSelector
                ReportId={props.reportData.moduleReportId}
                defaultValue={state.reportType}
                onReportTypeChange={handleReportTypeChange}
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "ddlEmployeeMulti",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Employee</Form.Label>
              <div className="employee-multipicker">
                <LaborMultiEmployeeSelector
                  ref={employeeDDLRef}
                  hotelIds={state.hotelIds}
                  handleMultiEmployeeChange={handleMultiEmployeeChange}
                />
              </div>
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "ddlStatus",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Response</Form.Label>
              <LaborResponseStatus
                handelResponseStatus={handelResponseStatus}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlCOAType",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">COA</Form.Label>
              {props.reportData.moduleReportId === 2096 ? (
                <>
                  {state.hotelIds ? (
                    <>
                      {state.isResetHIDControl ? (
                        ""
                      ) : (
                        <AccountingCOAType handleCOAType={handleCOAType} />
                      )}
                    </>
                  ) : (
                    <input
                      type="text"
                      className="form-control text-left btn"
                      disabled={true}
                      placeholder="Include all COA's"
                    />
                  )}
                </>
              ) : (
                <AccountingCOAType handleCOAType={handleCOAType} />
              )}
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlReportLayoutforDates",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Layout</Form.Label>
              <DateLayOutSelector
                defaultValue={state.dateLayOutSelector}
                handleDateLayOut={handleDateLayOut}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlRowTittle",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">Row Titles</Form.Label>
                <RowTittle
                  defaultValue={state.rowTitles}
                  handleRowTittle={handleRowTittle}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlDisputeStatus",
        control: (
          <>
            {state.reportType !== "ByEmployee" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">Dispute Status</Form.Label>
                <DisputeStatus
                  defaultValue={state.disputueStatus}
                  handleDisputeStauts={handleDisputeStauts}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlType",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Type</Form.Label>
              <DDLReportType
                defaultValue={state.reportSubTypes}
                handleddlType={handleddlType}
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "ddlMultiTab",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Tab Type</Form.Label>
              <MultiTabls
                defaultValue={state.multiTabs}
                handleMultiTabls={handleMultiTabls}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlHotelDisplayFormat",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl ">Hotel Display Format</Form.Label>
              <HotelDisplayFormat
                defaultValue={state.hotelDisplayFormat}
                handleHotelDisplayFormat={handleHotelDisplayFormat}
                skipHotelFormatOptions={skipHotelFormatOptions()}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlProjectBudget",
        control: (
          <>
            {state.hotelIds !== "" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">Project Budgets</Form.Label>
                <ProjectBudgets
                  hotelIds={state.hotelIds}
                  projectBudgetId={state.projectBudgetId}
                  selectedVendorId={state.selectedVendorId}
                  onProjectBudgetsChange={handleProjectBudgetsChange}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlVendorSelector",
        control: (
          <>
            {state.hotelIds !== "" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">Vendor</Form.Label>
                <VendorSelector
                  hotelIds={state.hotelIds}
                  selectedVendorId={state.selectedVendorId}
                  onVendorChange={handleVendorChange}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlContractSelector",
        control: (
          <>
            {state.hotelIds !== "" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">Contract No.</Form.Label>
                <ContractSelector
                  hotelIds={state.hotelIds}
                  selectedVendorId={state.selectedVendorId}
                  projectBudgetId={state.projectBudgetId}
                  selectedContract={state.selectedContract}
                  onContractChange={handleContractChange}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlCoaClassificationReportType",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Report Type</Form.Label>
              <COAClassificationReportType
                defaultValue={state.selectedCoaClassificationTypes}
                handleMultiCoaClassificationType={
                  handleMultiCoaClassificationType
                }
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlStatusString",
        control: (
          <>
            {state.reportType !== "ByEHID" && (
              <Form.Group controlId="">
                <Form.Label className="sec-ttl">
                  {getStatusDropDwonLablelNameBasedOnReport()}
                </Form.Label>
                <StatusSelector
                  ReportId={props.reportData.moduleReportId}
                  defaultValue={state.statusString}
                  handleDropdownChange={handleStatusStringSelectorChange}
                />
              </Form.Group>
            )}
          </>
        ),
      },
      {
        controlName: "ddlEmployeeStatus",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Employee Status</Form.Label>
              <StatusSelector
                defaultValue={state.employeeStatus}
                handleDropdownChange={handleEmployeeStatusSelectorChange}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlGroupBy",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Group By</Form.Label>
              <GroupBySelector
                defaultValue={state.groupBy}
                handleDropdownChange={handleGroupBySelectorChange}
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "FCdllStatus",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Status</Form.Label>
              <FacilitiesStatus
                hotelIds={state.hotelIds}
                responseFCStatus={state.responseFCStatus}
                handelResponseStatus={handelFCResponseStatus}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "ddlPMschedules",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Schedule</Form.Label>
              <div className="employee-multipicker">
                <FacilitiesMultiPMSchuleSelector
                  ref={employeeDDLRef}
                  // defaultValue={state?.departmentIds}
                  hotelIds={state.hotelIds}
                  PmScheduleId={state.PmScheduleId}
                  handlePMschedulesChange={handlePMschedulesChange}
                />
              </div>
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "FCWodllStatus",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Status</Form.Label>
              <FacilitiesWoStatus
                hotelIds={state.hotelIds}
                FCWoStatus={state.FCWoStatus}
                handelResponseStatus={handelFCWoStatus}
              />
            </Form.Group>
          </>
        ),
      },
      {
        controlName: "FCWodllSorting",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Sorting</Form.Label>
              <FacilitiesWoSorting
                hotelIds={state.hotelIds}
                FCWoSorting={state.FCWoSorting}
                handelResponseStatus={handelFCWoSorting}
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "FCAWodllSorting",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Sorting</Form.Label>
              <FacilitiesAWOSorting
                hotelIds={state.hotelIds}
                FcAwoSorting={state.FcAwoSorting}
                handelResponseStatus={handelFCAWOSorting}
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "FCAWodllStatus",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Status</Form.Label>
              <FacilitiesAWoStatus
                hotelIds={state.hotelIds}
                FcAwoStatus={state.FcAwoStatus}
                handelResponseStatus={handelFCAWOStatus}
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "FCAssetTypeFilterdll",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Asset Type</Form.Label>
              <FacilitiesAssetTypeFilter

                hotelIds={state.hotelIds}
                ref={employeeDDLRef}
                FcAssetTypeDetails={state.FcAssetTypeDetails}
                handelResponseStatus={handelFCAssetType}
              />
            </Form.Group>
          </>
        ),

      },

      {
        controlName: "FCAssetLocationFilterdll",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Location Filter</Form.Label>
              <FacilitiesMultiAssetLocationFilter
                hotelIds={state.hotelIds}
                FcAssetLocation={state.FcAssetLocation}
                ref={employeeDDLRef}
                handelFCAssetFilterStatus={handelFCAssetFilterStatus}
              />
            </Form.Group>
          </>
        ),
      },

      {
        controlName: "FCAssetdllSorting",
        control: (
          <>
            <Form.Group controlId="">
              <Form.Label className="sec-ttl">Sorting</Form.Label>
              <FacilitiesAssetSorting
                hotelIds={state.hotelIds}                
                FcAssetLocationSorting={state.FcAssetLocationSorting}
                handelResponseStatus={handelFCAssetSorting}
              />
            </Form.Group>
          </>
        ),
      },

    ];
  };

  const updateHtmlControlState = (state: IParameterSelectionState) => {
    setCompState(state);
    buildFilterControls(state);
    if (reportInputParameters?.length > 0) {
      let _htmlControls = htmlControls
        .map((r) => {
          if (controlshouldBeVisible(r?.controlName)) {
            const control = getControl(r?.controlName);
            r.displayOrder = control?.displayOrder;
            r.isRequired = control?.isRequired;
            r.isVisible = true;
            r.isSameDateRangeYear = control?.isSameDateRangeYear;
          }
          return r;
        })
        ?.filter((x) => x?.isVisible);
      if (_htmlControls.length > 1) {
        _htmlControls = _htmlControls?.sort(
          (a, b) => a?.displayOrder - b?.displayOrder
        );
      }

      setVisibleHtmlControls(_htmlControls);
    }

    if (visibleHtmlControls?.length > 0) {
      let _htmlControls = htmlControls

        .map((r) => {
          if (controlshouldBeVisible(r?.controlName)) {
            const control = getControl(r?.controlName);
            r.displayOrder = control?.displayOrder;
            r.isRequired = control?.isRequired;
            r.isVisible = true;
          }
          return r;
        })
        ?.filter((x) => x?.isVisible);

      if (_htmlControls.length > 1) {
        _htmlControls = _htmlControls?.sort(
          (a, b) => a?.displayOrder - b?.displayOrder
        );
      }

      setVisibleHtmlControls(_htmlControls);
    }
  };

  const resetFilters = () => {
    debugger
    if (state.dataSourceType === "opr") {
      if (props.reportData.moduleReportId === 2168) {
        setNewParameterValue("DataSource1", "Actual");
        state.IsdataSoureSelect = "Actual";
        state.dataSourceforPanL = 1;
      }
      else {
        setNewParameterValue("DataSource1", "Actual,Original Budget,Prior");
        state.IsdataSoureSelect = "Actual,Original Budget,Prior";
      }
      state.IsPrayerYear = "Prior";
    } else if (state.dataSourceType === "Periods") {
      setNewParameterValue("DataSource1", "Actual");
      state.IsdataSoureSelect = "Actual";
      state.IsPrayerYear = "Prior";
    } else {
      setNewParameterValue("DataSource1", "ADR,OCC,".replace(/,\s*$/, ""));
      state.IsdataSoureSelect = "ADR,OCC,".replace(/,\s*$/, "");
      state.IsPrayerYear = "";
    }
    if (props.reportData.uniqueReportId === 2036) {
      state.IsdataSoureSelect2 = "";
      setNewParameterValue("DataSource2", "");
    }
    if (props.reportData.moduleReportId === 2078) {
      state.IsExClearedtransactions = false;
      setNewParameterValue("ExcClearedTran", "0");
    } else {
      if (state.dataSourceType === "Periods") {
        state.IsdataSoureSelect2 = "$";
        setNewParameterValue("DataSource2", "$");
      } else {
        state.IsdataSoureSelect2 = "%";
        setNewParameterValue("DataSource2", "%");
      }
    }

    state.IsAgingSelect = "0 - 30";
    setNewParameterValue("Aging", "0 - 30");
    state.lastActiveDate = ActPeriodFrom;
    state.accountsPeriodSelectStart = ActPeriodFrom;
    setNewParameterValue("AccountingPeriodFrom", ActPeriodFrom);
    state.defaultYear = PrYear;
    setNewParameterValue("PriorYear", PrYear);
    state.serverDateTime = AccountingPeriodThrough;
    setNewParameterValue("AccountingPeriodThrough", AccountingPeriodThrough);
    state.rowTitles = "No";
    state.reportSubTypes = "Accrual";
    state.scheduleReportSortBy = "Position";
    state.employeeWageNewReportSortBy = "Position";
    state.hireDateSortBy = "";
    state.statusString = "Active";
    state.loadEmployee = false;
    state.employeeStatus = "Active";
    state.groupBy = "Employee";

    setNewParameterValue("StatusString", "Active");
    setNewParameterValue("EmployeeStatus", "Active");
    setNewParameterValue("GroupBy", "Employee");
    state.isVendorReportDateF = "";
    setNewParameterValue("isVendorReportDateF", "");
    state.isVendorReportDateT = "";
    setNewParameterValue("isVendorReportDateT", "");

    state.amountVal = "";
    setNewParameterValue("MinimumAmount", "");
    state.generate1096Val = "";
    setNewParameterValue("Generate1096", "");
    state.multiTabs = "1";
    state.multiDocs = "";
    setNewParameterValue("DocumentType", "");
    state.multiSelectVendor = "";
    setNewParameterValue("MultiSelectVendor", "");
    setNewParameterValue("RowTittle", "No");
    setNewParameterValue("DDLType", "Accrual");
    setNewParameterValue("ScheduleReportSortBy", "Position");
    setNewParameterValue("HireDateSortBy", "");
    setNewParameterValue("EmployeeWageNewReportSortBy", "Position");

    setNewParameterValue("ddlMultiTabls", "1");
    state.disputueStatus = "Open";
    setNewParameterValue("DisputeStatus", "Open");
    state.expireStatus = 30;
    setNewParameterValue("ExpireStatus", 30);
    state.ePayStatus = "All";
    setNewParameterValue("ePayStatusCtrl", "All");
    props?.enableReportRunner();
    setdisableSave(true);
    state.startDate = "";
    setNewParameterValue("StartDate", "");
    state.endDate = "";
    setNewParameterValue("EndDate", "");

    state.hotelIds = "";
    updateEmployeeDDL();
    setNewParameterValue("Hotelid", "");
    state.hotelName = "";
    state.isPageBreak = false;
    const isPageBreak = state.isPageBreak ? "1" : "0";
    const exportType = state.isPageBreak ? "pdf" : "View";
    setNewParameterValue("IsPageBreak", isPageBreak);
    setNewParameterValue("ExportType", exportType);
    state.isIncludeEnterpriseEmployees = false;
    const isExclude = state.isIncludeEnterpriseEmployees ? "Yes" : "No";
    setNewParameterValue("IsExclude", isExclude);
    state.accountingYear = "";
    state.currentYear = "";
    state.comparisonYear = "";
    state.accPeriodMonth = "";
    state.employementType = "";
    state.lookBackPeriod = "";
    state.hireDate = "";
    state.isAccountEmpty = false;
    setNewParameterValue("HireDate", "");
    state.fileSize = "";
    setNewParameterValue("FileSize", "");
    state.acaCoverageCodes = "";
    setNewParameterValue("ACACoverageCode", "");
    state.acaACASHarborCodes = "";
    setNewParameterValue("ACASaferCode", "");
    state.avgHours = "";
    setNewParameterValue("AvgHrsWorked", "");
    state.isAcaCodes = true;
    setNewParameterValue("ChkSummSec", "Yes");
    state.isCompSet = false;
    setNewParameterValue("ChkIsCompSet", "No");
    state.isIncludeDesc = false;
    setNewParameterValue("ChkIsIncludeDesc", "No");
    state.isIncludeBudget = false;
    setNewParameterValue("ChkIncludeBudget", "No");
    state.isZeroActualValues = false;
    setNewParameterValue("ChkHideZeroActualValues", "No");
    state.isIncludeRevenue = false;
    setNewParameterValue("ChkIncludeRevenue", "No");
    state.status = "1";

    setNewParameterValue("ChkCheckCOA", "No");
    state.IsCheckCOA = false;
    setNewParameterValue("ChkGeneralCode", "No");
    state.IsGeneralCode = false;
    setNewParameterValue("ChkContractorExclude", "No");
    state.IsContractorExclude = false;
    setNewParameterValue("chkShowZeroActualHours", "No");
    state.IsShowZeroActualHours = false;

    setNewParameterValue("chkBankBalance", "No");
    state.isBankBalanceValues = false;
    setNewParameterValue("ChkHideStatistics", "No");
    state.IsHideStatistics = false;
    setNewParameterValue("ChkIncludePendingInvoices", "No");
    state.IsIncludePendingInvoices = false;
    setNewParameterValue("chkGroupBankAccountsByType", "No");
    state.isGrpBankAccByTypeValues = false;
    setNewParameterValue("chkShowCombinedOnly", "No");
    state.isShowCombinedValues = false;
    setNewParameterValue("chkSummayOnly", "No");
    state.isShowSummayValues = false;
    setNewParameterValue("chkGroupCCAccounts", "No");
    state.isGrpCCAccountsValues = false;
    setNewParameterValue("ChkUnapprovedtransactions", "No");
    state.IsUnapprovedtransactions = false;
    setNewParameterValue("chkIncludeCustomer", "No");
    state.isIncludeCustomer = false;
    setNewParameterValue("ddlHotelDisplayFormat", "1");
    state.hotelDisplayFormat = "1";
    setNewParameterValue("chkExClearedtransactions", "No");
    state.IsExClearedtransactions = false;

    setNewParameterValue("Status", "1");

    // state.CalculatedStatus = "1";
    // setNewParameterValue("CalculatedStatus", "1");
    if (reportData.moduleReportId === 2078) {
      setNewParameterValue("coaType", ActPeriodFrom);
    } else {
      setNewParameterValue("coaType", "Active");
    }

    state.reportType = "";
    let Module_Id = ModuleReports.getModuleId(localStorage.mainMenu as any);
    if (Module_Id === 4) {
      if (
        props.reportData.moduleReportId !== 2081 &&
        props.reportData.moduleReportId !== 2082 &&
        props.reportData.moduleReportId !== 2083 &&
        props.reportData.moduleReportId !== 2085 &&
        props.reportData.moduleReportId !== 2086 &&
        props.reportData.moduleReportId !== 2087
      ) {
        setNewParameterValue("ReportType", "ByEmployee");
      }
    }
    if (Module_Id === 8) {
      if (props.reportData.moduleReportId === 2234) {
        setNewParameterValue("currentYear", new Date().getFullYear());
        setNewParameterValue("comparisonYear", new Date().getFullYear() - 1);
        setNewParameterValue("accPeriodMonth", "01");
      }
    }

    state.punchHistoryType = "";
    state.employee = "";
    state.BankAccount = "";
    setNewParameterValue("Employee", "");
    state.groupSelectValue = "";
    state.subGroupSelectValue = "";
    state.groupNameForMsg = "";
    state.departmentIds = "";
    setNewParameterValue("deptID", "");
    state.hoursFormat = "";
    state.laborSummarySubType = "";
    state.IsDollars = false;
    state.userUniquenIds = "";
    state.responseStatus = "";
    state.responseFCStatus = "";
    setNewParameterValue("IsDollars", "No");
    state.IsSalaried = false;
    setNewParameterValue("IsSalaried", "No");
    state.IsExcludePayroll = false;
    setNewParameterValue("IsExcludePayroll", "No");
    state.showNonWorkingHoursAndwages = true;
    setNewParameterValue("chkNonWorkingHoursAndwages", "Yes");
    state.IsVariance = false;
    setNewParameterValue("IsVariance", "No");
    state.chkCompareActuals = 0;
    setNewParameterValue("ActualCompared", "0");
    state.Reportdesc = "[Check total by vendor]";
    state.adjustedBudget =
      props.reportData.moduleReportId === 2168 ? "" : "Adjusted Budget";
    setNewParameterValue(
      "PayRollDataSource",
      props.reportData.moduleReportId === 2168 ? "" : "Adjusted Budget"
    );
    if (props.reportData.moduleReportId === 2204) {
      state.actual = "Variance to Budget";
    } else {
      state.actual = "Actual";
    }
    setNewParameterValue("dataSourceType", "Actual");
    if (props.reportData.moduleReportId === 2158) {
      state.TwelveAccountPeriod = "-1";
      setNewParameterValue("LayoutDesign", "-1");
    } else {
      state.TwelveAccountPeriod = "1";
      setNewParameterValue("LayoutDesign", "1");
    }
    state.CalculatedStatus = "Total";
    setNewParameterValue("CalculatedStatus", "Total");

    state.PayFileFormat = "Select";
    state.PayFileFormatId = -1;
    setNewParameterValue("PayFileFormatId", -1);

    state.projectBudget = "Select";
    state.projectBudgetId = -1;
    setNewParameterValue("projectBudget", "Select");
    setNewParameterValue("projectBudgetId", -1);
    setNewParameterValue("PHotelName", "");

    state.selectedVendorId = -1;
    setNewParameterValue("selectedVendorId", -1);

    state.selectedContract = "Select";
    setNewParameterValue("selectedContract", "Select");

    state.selectedCoaClassificationTypes = "";
    setNewParameterValue("CoaClassificationTypes", "");

    let storage = JSON.parse(localStorage.getItem("storage")!);
    let userUniqueID = storage === null ? 0 : storage.user_UniqueID;
    setNewParameterValue("loginUserId", userUniqueID || 0);

    switch (reportData.reportName) {
      case "Daily Flash #1":
        state.ReportName = "1";
        setNewParameterValue("ReportName", "1");
        break;
      case "Daily Flash #2":
        state.ReportName = "1";
        setNewParameterValue("ReportName", "1");
        break;
      case "Daily Flash #3":
        state.ReportName = "1";
        setNewParameterValue("ReportName", "1");
        break;
      case "Daily Flash #4":
        state.ReportName = "1";
        setNewParameterValue("ReportName", "1");
        break;
      case "Daily Flash #5":
        state.ReportName = "1";
        setNewParameterValue("ReportName", "1");
        break;
      default:
        //state.ReportName = reportData.reportName;
        //setNewParameterValue("ReportName", reportData.reportName);
        break;
    }

    //// facilty control reset 
    state.FcAssetLocationSorting = "";
    setNewParameterValue("FcAssetLocationSorting", "");
    state.FcAwoSorting = "";
    setNewParameterValue("FcAwoSorting", "");
    state.FcAwoStatus = "";
    setNewParameterValue("FcAwoStatus", "");
    state.FCWoStatus = "";
    setNewParameterValue("FCWoStatus", "");
    state.FCWoSorting = "";
    setNewParameterValue("FCWoSorting", "");
    state.responseFCStatus = "";
    setNewParameterValue("responseFCStatus", "");
    state.FcAssetTypeDetails = "";
    setNewParameterValue("FcAssetTypeDetails", "");
    state.FcAssetLocation = "";
    setNewParameterValue("FcAssetLocation", "");
    state.FcAssetLocationSorting = "";
    setNewParameterValue("FcAssetLocationSorting", "");

    setNewParameterValue("SubGroupid", "");
    updateHtmlControlState(state);
  };

  const enableResetButton = (): boolean => {
    let enable = false;

    if (controlshouldBeVisible("chkACACodes") && !state.isAcaCodes) {
      enable = true;
    }
    if (
      controlshouldBeVisible("chkCompareActuals") &&
      +state.chkCompareActuals > 0
    ) {
      enable = true;
    }
    if (controlshouldBeVisible("chkDollars") && state.IsDollars) {
      enable = true;
    }
    if (
      controlshouldBeVisible("chkIncludeEnterpriseEmployees") &&
      state.isIncludeEnterpriseEmployees
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("chkIncludeSalariedEmployees") &&
      state.IsSalaried
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("chkIsExcludePayroll") &&
      state.IsExcludePayroll
    ) {
      enable = true;
    }
    if (controlshouldBeVisible("chkPageBreak") && state.isPageBreak) {
      enable = true;
    }
    if (controlshouldBeVisible("chkShowZeroActualHours") && state.isPageBreak) {
      enable = true;
    }
    if (controlshouldBeVisible("chkStatus") && +state.status > 1) {
      enable = true;
    }
    if (controlshouldBeVisible("chkVariance") && state.IsVariance) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlACACoverageCodes") &&
      state.acaCoverageCodes?.length > 0
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlDataSource") &&
      state.IsdataSoureSelect !==
      (state.dataSourceType === "opr"
        ? "Actual,Original Budget,Prior"
        : "ADR,OCC")
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlDataSource1") &&
      state.IsdataSoureSelect !==
      (state.dataSourceType === "opr"
        ? "Actual,Original Budget,Prior"
        : "ADR,OCC")
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlDataSource1Periods") &&
      state.IsdataSoureSelect !== "Actual"
    ) {
      enable = true;
    }

    if (
      controlshouldBeVisible("ddlDataSource2") &&
      state.IsdataSoureSelect2 !== "%"
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlDataSource2Periods") &&
      state.IsdataSoureSelect2 !== "$"
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlACAHarborCodes") &&
      state.acaACASHarborCodes?.length > 0
    ) {
      enable = true;
    }
    if (controlshouldBeVisible("ddlAccountingYears") && state.accountingYear) {
      enable = true;
    }
    if (controlshouldBeVisible("ddlCurrentYears") && state.currentYear) {
      enable = true;
    }
    if (controlshouldBeVisible("ddlcomparisonYear") && state.accPeriodMonth) {
      enable = true;
    }

    if (controlshouldBeVisible("ddlaccPeriodMonth") && state.comparisonYear) {
      enable = true;
    }

    if (controlshouldBeVisible("ddlDepartmentMulti") && state.departmentIds) {
      enable = true;
    }
    if (controlshouldBeVisible("ddlDepartmentSingle") && state.departmentIds) {
      enable = true;
    }

    if (
      controlshouldBeVisible("ddlEmployementType") &&
      state.employementType &&
      state.employementType !== "All"
    ) {
      enable = true;
    }
    if (controlshouldBeVisible("ddlHotelMulti") && state.hotelIds) {
      enable = true;
    }
    if (controlshouldBeVisible("ddlHotelSingle") && state.hotelIds) {
      enable = true;
    }
    if (controlshouldBeVisible("ddlHoursFormat") && state.hoursFormat) {
      enable = true;
    }

    if (
      controlshouldBeVisible("ddlLookBackPeriod") &&
      state.lookBackPeriod &&
      +state.lookBackPeriod > 1
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlPunchHistoryReportType") &&
      state.punchHistoryType
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlReportGroup") &&
      state.subGroupSelectValue &&
      state.subGroupSelectValue !== "Select Group"
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlMultiReportGroup") &&
      state.subGroupSelectValue &&
      state.subGroupSelectValue !== "Select Group"
    ) {
      enable = true;
    }
    if (controlshouldBeVisible("ddlReportType") && state.reportType) {
      enable = true;
    }
    if (controlshouldBeVisible("txtAutoEmployee") && state.employee) {
      enable = true;
    }
    if (controlshouldBeVisible("txtAvgHoursWorked") && +state.avgHours > 0) {
      enable = true;
    }
    if (controlshouldBeVisible("txtDate") && state.startDate) {
      enable = true;
    }
    if (
      controlshouldBeVisible("txtDateRange") &&
      state.startDate &&
      state.endDate
    ) {
      enable = true;
    }
    if (controlshouldBeVisible("txtHireDate") && +state.hireDate > 0) {
      enable = true;
    }
    if (controlshouldBeVisible("txtFileSize") && +state.fileSize > 0) {
      enable = true;
    }
    if (
      controlshouldBeVisible("chkZeroActualValues") &&
      +state.isZeroActualValues
    ) {
      enable = true;
    }
    if (controlshouldBeVisible("chkIncludeBudget") && +state.isIncludeBudget) {
      enable = true;
    }
    if (
      controlshouldBeVisible("chkUnapprovedtransactions") &&
      state.IsUnapprovedtransactions
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("chkIncludeCustomer") &&
      state.isIncludeCustomer
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlHotelDisplayFormat") &&
      state.hotelDisplayFormat !== "1"
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("chkExClearedtransactions") &&
      state.IsExClearedtransactions
    ) {
      enable = true;
    }

    if (
      controlshouldBeVisible("ddlPositivePayType") &&
      state.PayFileFormatId !== -1
    ) {
      enable = true;
    }

    if (
      controlshouldBeVisible("ddlProjectBudget") &&
      state.projectBudgetId !== -1
    ) {
      enable = true;
    }

    if (
      controlshouldBeVisible("ddlVendorSelector") &&
      state.selectedVendorId !== -1
    ) {
      enable = true;
    }

    if (
      controlshouldBeVisible("ddlContractSelector") &&
      state.selectedContract.toLowerCase() !== "select"
    ) {
      enable = true;
    }

    if (
      controlshouldBeVisible("txtExpireStatusCtrl") &&
      state.expireStatus !== 30
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("txtEpayStatusCtrl") &&
      state.ePayStatus !== "All"
    ) {
      enable = true;
    }
    if (controlshouldBeVisible("txtDocumentType") && state.multiDocs !== "") {
      enable = true;
    }
    let cList: any =
      state.multiSelectVendor !== undefined &&
      state.multiSelectVendor.split(",");
    if (
      controlshouldBeVisible("txtMultiVendor") &&
      state.hotelIds !== "" &&
      vePayLst.length !== cList.length
    ) {
      enable = true;
    }
    if (controlshouldBeVisible("txtAmountControl") && state.amountVal !== "") {
      enable = true;
    }
    if (
      controlshouldBeVisible("txtgenerate1096ValCtrl") &&
      state.generate1096Val !== ""
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("txtDateStartingAndThruControl") &&
      (state.isVendorReportDateF || state.isVendorReportDateT)
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("chkNonWorkingHoursAndwages") &&
      state.showNonWorkingHoursAndwages
    ) {
      enable = true;
    }
    if (
      controlshouldBeVisible("ddlCoaClassificationReportType") &&
      state.selectedCoaClassificationTypes !== ""
    ) {
      enable = true;
    }

    return enable;
  };

  const getStatusDropDwonLablelNameBasedOnReport = () => {
    let label = "";
    if (props?.reportData?.uniqueReportId == 2175) {
      label = "Deduction Status";
    } else {
      label = "Status";
    }
    return label;
  };
  const getPageBreakCheckBoxLablelNameBasedOnReport = () => {
    let label = "";
    if (
      props?.reportData?.reportName === "Employee Wage Per Hours: VER.02" ||
      props?.reportData?.reportName === "Employee Wage Per Hours: VER.03"
    ) {
      label = "Page Break By Hotel on Export";
    } else if (
      props?.reportData?.uniqueReportId == 2175 ||
      props?.reportData?.uniqueReportId == 2210 ||
      props?.reportData?.uniqueReportId == 2213 ||
      props?.reportData?.reportName ===
      "Daily Labor Flash - Labor Hours Variance"
    ) {
      label = "Page Break By EHID";
    } else if (props?.reportData?.uniqueReportId == 49) {
      label = "Page Break by Vendor/Agency";
    } else {
      label = "Page Break By Department on Export";
    }
    return label;
  };

  const pageBreakControlDisplayCondition = (state) => {
    let visible = true;
    if (props.reportData.uniqueReportId == 2175 && state.groupBy != "EHID") {
      visible = false;
    }
    if (
      props.reportData.uniqueReportId == 49 &&
      state.employementType != "Contractor"
    ) {
      visible = false;
    }

    return visible;
  };

  return (
    <Tab.Container
      activeKey={key}
      onSelect={(k) =>
        setKey(state.isGlobalSetting === true && k != null ? k : "runoptions")
      }
      // {(k) => setKey( isGlobalSett ==1? k: "runOptions" )}
      // activeKey={this.state.activeTab}
      // onSelect={(selectedtab) => this.setActiveTab(selectedtab)}
      id="controlled-tab-example"
      defaultActiveKey="runoptions"
    >
      <div className="left-panel">
        <Nav className="nav-tabs flex-row">
          <Nav.Item>
            <Nav.Link eventKey="runoptions">Run Options</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="globalsettings"
              hidden={state.isGlobalSetting != true ? true : false}
            >
              Global Settings
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          <Tab.Pane eventKey="runoptions">
            <div className="report-parameter-selection">
              {!dataFetched ? (
                <div className="section-body">
                  <ReactPageLoader
                    // useas={"reportsParaSelection reportsScheduleLeftPanel"}
                    useas={"reportsParaSelectionmodal"}
                  />
                </div>
              ) : (
                <>
                  <div className="section-body" ref={frmSectionRef}>
                    {visibleHtmlControls?.length > 0 && (
                      <div className="sec-group">
                        <div className="section">
                          {visibleHtmlControls?.length > 0 && (
                            <div className="frm-section">
                              {visibleHtmlControls?.map((item) => (
                                <>{item.control}</>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {dataFetched && visibleHtmlControls?.length === 0 && (
                      <div className="no-parameter-msg">
                        This report does not require settings
                      </div>
                    )}

                    <div className="horizontal-separator"></div>
                  </div>

                  <div className="section-footer d-flex">
                    <div className="action-group">
                      <span data-tip={tooltipMessageReset}>
                        <ReactTooltip
                          effect="solid"
                          event="mouseover mouseenter"
                          eventOff="mouseleave mouseout scroll mousewheel blur"
                          place="bottom"
                          multiline={true}
                        />
                        {visibleHtmlControls?.length > 0 && (
                          <span data-tip={"Reset"}>
                            <ReactTooltip
                              effect="solid"
                              event="mouseover mouseenter"
                              eventOff="mouseleave mouseout scroll mousewheel blur"
                              place="bottom"
                              multiline={true}
                            />

                            <Button
                              disabled={
                                !enableResetButton() ||
                                (disableRunReport
                                  ? disableRunReport
                                  : props.disableRunReport)
                              }
                              type="button"
                              onClick={resetFilters}
                              className="btn-outline-primary refresh"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M10 13.3335C11.3925 13.3335 12.5 12.2243 12.5 10.8335C12.5 9.44266 11.3925 8.3335 10 8.3335C8.6075 8.3335 7.5 9.44266 7.5 10.8335C7.5 12.2243 8.6075 13.3335 10 13.3335Z" />
                                <path d="M17.3475 9.3215C17.2475 8.83567 17.1 8.36234 16.91 7.91484C16.7225 7.4715 16.49 7.04317 16.2183 6.639C15.9483 6.23984 15.6408 5.86734 15.3033 5.5315C14.9667 5.19317 14.5925 4.88484 14.1933 4.614C13.7908 4.34234 13.3617 4.11067 12.92 3.92317C12.4717 3.73234 11.9983 3.58567 11.5108 3.48484C11.0108 3.38234 10.495 3.33317 9.97917 3.33484V1.6665L6.66667 4.1665L9.97917 6.6665V5.0015C10.3825 4.99984 10.7858 5.03817 11.175 5.11817C11.5533 5.1965 11.9217 5.31067 12.27 5.459C12.6142 5.604 12.9475 5.78567 13.26 5.99567C13.5708 6.20567 13.8617 6.44567 14.125 6.70984C14.3875 6.9715 14.6283 7.26234 14.8367 7.57234C15.0483 7.88567 15.2292 8.219 15.375 8.56484C15.5233 8.91234 15.6367 9.28067 15.715 9.65734C15.7933 10.0398 15.8333 10.4357 15.8333 10.8332C15.8333 11.2307 15.7933 11.6265 15.715 12.0082C15.6367 12.3865 15.5233 12.7548 15.375 13.104C15.2292 13.4482 15.0483 13.7815 14.8383 14.094C14.6275 14.4048 14.3867 14.6957 14.1233 14.9598C13.8608 15.2232 13.5708 15.4623 13.26 15.6715C12.95 15.8807 12.6175 16.0615 12.2692 16.209C11.9217 16.3565 11.5542 16.4707 11.1767 16.549C10.41 16.7057 9.58833 16.7057 8.825 16.549C8.44667 16.4707 8.07833 16.3565 7.73 16.2082C7.38333 16.0615 7.05083 15.8807 6.73917 15.6707C6.43 15.4623 6.14 15.2223 5.87667 14.959C5.61417 14.6957 5.37333 14.4048 5.16417 14.0957C4.9525 13.7823 4.77167 13.449 4.62583 13.104C4.4775 12.7557 4.36417 12.3873 4.28583 12.0107C4.20667 11.6265 4.16667 11.2307 4.16667 10.8332H2.5C2.5 11.3423 2.55167 11.8507 2.6525 12.3448C2.7525 12.8298 2.9 13.3032 3.09 13.7523C3.2775 14.1957 3.51 14.624 3.7825 15.0282C4.05167 15.4257 4.35917 15.7982 4.69667 16.1357C5.035 16.4748 5.40833 16.7832 5.80583 17.0515C6.205 17.3223 6.63417 17.5548 7.08 17.7432C7.52833 17.934 8.00167 18.0807 8.48917 18.1815C8.9825 18.2815 9.49083 18.3332 10 18.3332C10.5092 18.3332 11.0175 18.2815 11.5117 18.1807C11.9975 18.0798 12.4708 17.9332 12.9183 17.7432C13.3658 17.554 13.795 17.3215 14.1933 17.0515C14.5917 16.7832 14.965 16.4748 15.3025 16.1357C15.64 15.7982 15.9475 15.4248 16.2192 15.0257C16.49 14.6232 16.7225 14.194 16.91 13.7523C17.1008 13.3023 17.2475 12.829 17.3475 12.3423C17.4483 11.8507 17.5 11.3423 17.5 10.8332C17.5 10.324 17.4483 9.81567 17.3475 9.3215Z" />
                              </svg>
                            </Button>
                          </span>
                        )}
                      </span>
                      <>
                        {props.runFrom === "gallery" &&
                          currentSaveReport.userReportId == 0 && (
                            <span data-tip={tooltipMessageAdd}>
                              <ReactTooltip
                                effect="solid"
                                event="mouseover mouseenter"
                                eventOff="mouseleave mouseout scroll mousewheel blur"
                                place="bottom"
                                multiline={true}
                              />
                              <Button
                                disabled={disableSave}
                                type="button"
                                onClick={openSaveReportModal}
                                className="addBtn btn-outline-primary"
                              >
                                Add
                              </Button>
                            </span>
                          )}
                        {showRenameModal && (
                          <Modal
                            className="rename-report-modal"
                            show={showRenameModal}
                            onHide={() => hideRenameModal()}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            keyboard={false}
                            enforceFocus={false}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title className="report-modal-header">
                                Save My Report
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <label className="report-modal-label">
                                Report Name{" "}
                                <strong className="text-danger">*</strong>
                              </label>
                              <input
                                type="text"
                                maxLength={100}
                                value={newReportName}
                                onChange={(e) => changeReportName(e)}
                                className="form-control"
                              ></input>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                className="cancel-btn btn-ghost ml-auto"
                                onClick={() => hideRenameModal()}
                              >
                                Cancel
                              </Button>
                              <Button
                                className="reset-password-btn"
                                onClick={() => saveReport()}
                              >
                                Save
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        )}
                      </>
                      {(props.runFrom === "myreports" ||
                        currentSaveReport.userReportId > 0) && (
                          <Button
                            disabled={disableSave}
                            type="button"
                            onClick={saveReport}
                            className="saveBtn btn-outline-primary"
                          >
                            Save
                          </Button>
                        )}

                      <Button
                        disabled={
                          disableRunReport
                            ? disableRunReport
                            : props.disableRunReport
                        }
                        type="button"
                        onClick={runReportClicked}
                      >
                        Run Report
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="globalsettings">
            {key === "globalsettings" && (
              <ReportGlobalSetting
                cancelreportsetup={cancelreportsetup}
                moduleReportId={props.reportData.moduleReportId}
                ParantID={ParantID}
              />
            )}
          </Tab.Pane>
        </Tab.Content>
      </div>
    </Tab.Container>
  );
};
